define(["react","prop-types","ca-ui-toolkit","jquery","mobx-state-tree","underscore","mobx-react","polyglot","gemini/lib/@waca/dashboard-common/dist/core/APIFactory","classnames","gemini/lib/@waca/baglass/js/baglass/utils/Utils","react-dom"], function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_16__, __WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_29__, __WEBPACK_EXTERNAL_MODULE_30__, __WEBPACK_EXTERNAL_MODULE_39__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 38);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _VisSlotEditorResources = __webpack_require__(15);

var _VisSlotEditorResources2 = _interopRequireDefault(_VisSlotEditorResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Polyglot = __webpack_require__(16);

var StringResources = function () {
	function StringResources() {
		_classCallCheck(this, StringResources);

		/**
   * Module which provides simple access to string resources.
   */
		this.polyglot = new Polyglot({
			phrases: _VisSlotEditorResources2.default
		});
	}

	/**
  * Get the string resource for the given key and interpolation options
  *
  * @param key						The  key of the string to return
  * @param interpolationOptions		Optional interpolation options (see poly.t documentation for details)
  * @returns							The string to display
  */


	_createClass(StringResources, [{
		key: 'get',
		value: function get(key, interpolationOptions) {
			return this.polyglot.t(key, interpolationOptions);
		}
	}]);

	return StringResources;
}();

exports.default = new StringResources();

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * Gets the number of filter items
 * @param {object} localFilter the filter applied.
 * @return the number of filter items applied. If filter number is not applicable, return null
 */
var getNumberOfFilterItems = exports.getNumberOfFilterItems = function getNumberOfFilterItems(localFilter) {
	if (localFilter) {
		if (localFilter.operator === 'in' || localFilter.operator === 'notin' || localFilter.operator === 'isnull') {
			return localFilter.values.length;
		}
	}
	return null;
};

// Scrollable drag constants
var SCROLL_DRAG_DISTANCE = 20;
var handleScroll = exports.handleScroll = function handleScroll(e, scrollableContainer, onScrollCallback) {
	var boundingRect = scrollableContainer.getBoundingClientRect();
	var rect = {
		top: boundingRect.top,
		bottom: boundingRect.bottom
	};
	if (e.type === 'touchmove') {
		var coords = e.touches[0];
		if (coords) {
			e.clientX = coords.clientX;
			e.clientY = coords.clientY;
		}
	}
	if (!e.clientX || !e.clientY) {
		return;
	}
	var position = {
		x: e.clientX,
		y: e.clientY
	};
	var distanceBottom = rect.bottom - position.y;
	var distanceTop = position.y - rect.top;
	var isScrollingBottom = distanceBottom > 0 && distanceBottom < SCROLL_DRAG_DISTANCE;
	var isScrollingTop = distanceTop > 0 && distanceTop < SCROLL_DRAG_DISTANCE;
	var distanceY = 0;
	if (isScrollingTop && isScrollingBottom) {
		isScrollingTop = distanceTop > distanceBottom;
		isScrollingBottom = !isScrollingTop;
	}
	if (isScrollingBottom) {
		distanceY = SCROLL_DRAG_DISTANCE - distanceBottom;
	} else if (isScrollingTop) {
		distanceY = distanceTop - SCROLL_DRAG_DISTANCE;
	}
	var newScrollTop = scrollableContainer.scrollTop + distanceY;
	if (newScrollTop <= 0) {
		newScrollTop = 0;
	} else {
		var maxScrollTop = scrollableContainer.scrollHeight - scrollableContainer.clientHeight;
		if (newScrollTop > maxScrollTop) {
			newScrollTop = maxScrollTop;
		}
	}
	if (scrollableContainer.scrollTop !== newScrollTop) {
		scrollableContainer.scrollTop = newScrollTop;
		if (onScrollCallback) {
			onScrollCallback();
		}
	}
};

/** this function returns datasource id that will be used in type in dropdown
 * it exercises following logic: 
 * 1. if there is active datasource id, use it
 * 2. else, use first datasource id in the list of datasources
 */
var getDataSourceIdTypeIn = exports.getDataSourceIdTypeIn = function getDataSourceIdTypeIn(dashboardApi) {
	var sourceId = dashboardApi.getActiveDataSourceId();
	if (!sourceId) {
		var dataSourceFeature = dashboardApi.getFeature('DataSources');
		if (dataSourceFeature.getDataSourceList().length > 0) {
			sourceId = dataSourceFeature.getDataSourceList()[0].getId();
		}
	}
	return sourceId;
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (t) {
  function n(e) {
    if (o[e]) return o[e].exports;var r = o[e] = { i: e, l: !1, exports: {} };return t[e].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
  }var e = window.webpackJsonPBaGraphics;window.webpackJsonPBaGraphics = function (o, i, u) {
    for (var c, s, a, f = 0, d = []; f < o.length; f++) {
      s = o[f], r[s] && d.push(r[s][0]), r[s] = 0;
    }for (c in i) {
      Object.prototype.hasOwnProperty.call(i, c) && (t[c] = i[c]);
    }for (e && e(o, i, u); d.length;) {
      d.shift()();
    }if (u) for (f = 0; f < u.length; f++) {
      a = n(n.s = u[f]);
    }return a;
  };var o = {},
      r = { 2086: 0 };n.m = t, n.c = o, n.d = function (t, e, o) {
    n.o(t, e) || Object.defineProperty(t, e, { configurable: !1, enumerable: !0, get: o });
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };return n.d(e, "a", e), e;
  }, n.o = function (t, n) {
    return Object.prototype.hasOwnProperty.call(t, n);
  }, n.p = "", n.oe = function (t) {
    throw console.error(t), t;
  };
}({ "698d75b157f24ae829cc": function d75b157f24ae829cc(t, n) {
    var e;e = function () {
      return this;
    }();try {
      e = e || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (e = window);
    }t.exports = e;
  }, "9689a9c94ae38b47fa2c": function a9c94ae38b47fa2c(t, n, e) {
    (function (n) {
      !function (n, e) {
        t.exports = e();
      }(0, function () {
        "use strict";
        function t(t, n) {
          return n = { exports: {} }, t(n, n.exports), n.exports;
        }var e = function e(t) {
          var n = t.id,
              e = t.viewBox,
              o = t.content;this.id = n, this.viewBox = e, this.content = o;
        };e.prototype.stringify = function () {
          return this.content;
        }, e.prototype.toString = function () {
          return this.stringify();
        }, e.prototype.destroy = function () {
          var t = this;["id", "viewBox", "content"].forEach(function (n) {
            return delete t[n];
          });
        };var o = function o(t) {
          var n = !!document.importNode,
              e = new DOMParser().parseFromString(t, "image/svg+xml").documentElement;return n ? document.importNode(e, !0) : e;
        },
            r = ("undefined" != typeof window ? window : void 0 !== n || "undefined" != typeof self && self, t(function (t, n) {
          !function (n, e) {
            t.exports = e();
          }(0, function () {
            function t(t) {
              return t && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && "[object RegExp]" !== Object.prototype.toString.call(t) && "[object Date]" !== Object.prototype.toString.call(t);
            }function n(t) {
              return Array.isArray(t) ? [] : {};
            }function e(e, o) {
              return o && !0 === o.clone && t(e) ? i(n(e), e, o) : e;
            }function o(n, o, r) {
              var u = n.slice();return o.forEach(function (o, c) {
                void 0 === u[c] ? u[c] = e(o, r) : t(o) ? u[c] = i(n[c], o, r) : -1 === n.indexOf(o) && u.push(e(o, r));
              }), u;
            }function r(n, o, r) {
              var u = {};return t(n) && Object.keys(n).forEach(function (t) {
                u[t] = e(n[t], r);
              }), Object.keys(o).forEach(function (c) {
                t(o[c]) && n[c] ? u[c] = i(n[c], o[c], r) : u[c] = e(o[c], r);
              }), u;
            }function i(t, n, i) {
              var u = Array.isArray(n),
                  c = i || { arrayMerge: o },
                  s = c.arrayMerge || o;return u ? Array.isArray(t) ? s(t, n, i) : e(n, i) : r(t, n, i);
            }return i.all = function (t, n) {
              if (!Array.isArray(t) || t.length < 2) throw new Error("first argument should be an array with at least two elements");return t.reduce(function (t, e) {
                return i(t, e, n);
              });
            }, i;
          });
        })),
            i = t(function (t, n) {
          var e = { svg: { name: "xmlns", uri: "http://www.w3.org/2000/svg" }, xlink: { name: "xmlns:xlink", uri: "http://www.w3.org/1999/xlink" } };n.default = e, t.exports = n.default;
        }),
            u = function u(t) {
          return Object.keys(t).map(function (n) {
            return n + '="' + t[n].toString().replace(/"/g, "&quot;") + '"';
          }).join(" ");
        },
            c = i.svg,
            s = i.xlink,
            a = {};a[c.name] = c.uri, a[s.name] = s.uri;var f = function f(t, n) {
          void 0 === t && (t = "");var e = r(a, n || {});return "<svg " + u(e) + ">" + t + "</svg>";
        };return function (t) {
          function n() {
            t.apply(this, arguments);
          }t && (n.__proto__ = t), n.prototype = Object.create(t && t.prototype), n.prototype.constructor = n;var e = { isMounted: {} };return e.isMounted.get = function () {
            return !!this.node;
          }, n.createFromExistingNode = function (t) {
            return new n({ id: t.getAttribute("id"), viewBox: t.getAttribute("viewBox"), content: t.outerHTML });
          }, n.prototype.destroy = function () {
            this.isMounted && this.unmount(), t.prototype.destroy.call(this);
          }, n.prototype.mount = function (t) {
            if (this.isMounted) return this.node;var n = "string" == typeof t ? document.querySelector(t) : t,
                e = this.render();return this.node = e, n.appendChild(e), e;
          }, n.prototype.render = function () {
            var t = this.stringify();return o(f(t)).childNodes[0];
          }, n.prototype.unmount = function () {
            this.node.parentNode.removeChild(this.node);
          }, Object.defineProperties(n.prototype, e), n;
        }(e);
      });
    }).call(n, e("698d75b157f24ae829cc"));
  }, "9ce58a7deea14f49ef01": function ce58a7deea14f49ef01(t, n, e) {
    (function (n) {
      !function (n, e) {
        t.exports = e();
      }(0, function () {
        "use strict";
        function t(t, n) {
          return n = { exports: {} }, t(n, n.exports), n.exports;
        }function e(t) {
          return t = t || Object.create(null), { on: function on(n, e) {
              (t[n] || (t[n] = [])).push(e);
            }, off: function off(n, e) {
              t[n] && t[n].splice(t[n].indexOf(e) >>> 0, 1);
            }, emit: function emit(n, e) {
              (t[n] || []).map(function (t) {
                t(e);
              }), (t["*"] || []).map(function (t) {
                t(n, e);
              });
            } };
        }function o(t, n) {
          return _(t).reduce(function (t, e) {
            if (!e.attributes) return t;var o = _(e.attributes),
                r = n ? o.filter(n) : o;return t.concat(r);
          }, []);
        }function r(t) {
          return t.replace(B, function (t) {
            return "%" + t[0].charCodeAt(0).toString(16).toUpperCase();
          });
        }function i(t, n, e) {
          return _(t).forEach(function (t) {
            var o = t.getAttribute(k);if (o && 0 === o.indexOf(n)) {
              var r = o.replace(n, e);t.setAttributeNS(T, k, r);
            }
          }), t;
        }var u = ("undefined" != typeof window ? window : void 0 !== n || "undefined" != typeof self && self, t(function (t, n) {
          !function (n, e) {
            t.exports = e();
          }(0, function () {
            function t(t) {
              return t && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && "[object RegExp]" !== Object.prototype.toString.call(t) && "[object Date]" !== Object.prototype.toString.call(t);
            }function n(t) {
              return Array.isArray(t) ? [] : {};
            }function e(e, o) {
              return o && !0 === o.clone && t(e) ? i(n(e), e, o) : e;
            }function o(n, o, r) {
              var u = n.slice();return o.forEach(function (o, c) {
                void 0 === u[c] ? u[c] = e(o, r) : t(o) ? u[c] = i(n[c], o, r) : -1 === n.indexOf(o) && u.push(e(o, r));
              }), u;
            }function r(n, o, r) {
              var u = {};return t(n) && Object.keys(n).forEach(function (t) {
                u[t] = e(n[t], r);
              }), Object.keys(o).forEach(function (c) {
                t(o[c]) && n[c] ? u[c] = i(n[c], o[c], r) : u[c] = e(o[c], r);
              }), u;
            }function i(t, n, i) {
              var u = Array.isArray(n),
                  c = i || { arrayMerge: o },
                  s = c.arrayMerge || o;return u ? Array.isArray(t) ? s(t, n, i) : e(n, i) : r(t, n, i);
            }return i.all = function (t, n) {
              if (!Array.isArray(t) || t.length < 2) throw new Error("first argument should be an array with at least two elements");return t.reduce(function (t, e) {
                return i(t, e, n);
              });
            }, i;
          });
        })),
            c = t(function (t, n) {
          var e = { svg: { name: "xmlns", uri: "http://www.w3.org/2000/svg" }, xlink: { name: "xmlns:xlink", uri: "http://www.w3.org/1999/xlink" } };n.default = e, t.exports = n.default;
        }),
            s = function s(t) {
          return Object.keys(t).map(function (n) {
            return n + '="' + t[n].toString().replace(/"/g, "&quot;") + '"';
          }).join(" ");
        },
            a = c.svg,
            f = c.xlink,
            d = {};d[a.name] = a.uri, d[f.name] = f.uri;var l,
            p = function p(t, n) {
          void 0 === t && (t = "");var e = u(d, n || {});return "<svg " + s(e) + ">" + t + "</svg>";
        },
            h = c.svg,
            y = c.xlink,
            m = { attrs: (l = { style: ["position: absolute", "width: 0", "height: 0"].join("; ") }, l[h.name] = h.uri, l[y.name] = y.uri, l) },
            v = function v(t) {
          this.config = u(m, t || {}), this.symbols = [];
        };v.prototype.add = function (t) {
          var n = this,
              e = n.symbols,
              o = this.find(t.id);return o ? (e[e.indexOf(o)] = t, !1) : (e.push(t), !0);
        }, v.prototype.remove = function (t) {
          var n = this,
              e = n.symbols,
              o = this.find(t);return !!o && (e.splice(e.indexOf(o), 1), o.destroy(), !0);
        }, v.prototype.find = function (t) {
          return this.symbols.filter(function (n) {
            return n.id === t;
          })[0] || null;
        }, v.prototype.has = function (t) {
          return null !== this.find(t);
        }, v.prototype.stringify = function () {
          var t = this.config,
              n = t.attrs,
              e = this.symbols.map(function (t) {
            return t.stringify();
          }).join("");return p(e, n);
        }, v.prototype.toString = function () {
          return this.stringify();
        }, v.prototype.destroy = function () {
          this.symbols.forEach(function (t) {
            return t.destroy();
          });
        };var g = function g(t) {
          var n = t.id,
              e = t.viewBox,
              o = t.content;this.id = n, this.viewBox = e, this.content = o;
        };g.prototype.stringify = function () {
          return this.content;
        }, g.prototype.toString = function () {
          return this.stringify();
        }, g.prototype.destroy = function () {
          var t = this;["id", "viewBox", "content"].forEach(function (n) {
            return delete t[n];
          });
        };var w,
            b = function b(t) {
          var n = !!document.importNode,
              e = new DOMParser().parseFromString(t, "image/svg+xml").documentElement;return n ? document.importNode(e, !0) : e;
        },
            x = function (t) {
          function n() {
            t.apply(this, arguments);
          }t && (n.__proto__ = t), n.prototype = Object.create(t && t.prototype), n.prototype.constructor = n;var e = { isMounted: {} };return e.isMounted.get = function () {
            return !!this.node;
          }, n.createFromExistingNode = function (t) {
            return new n({ id: t.getAttribute("id"), viewBox: t.getAttribute("viewBox"), content: t.outerHTML });
          }, n.prototype.destroy = function () {
            this.isMounted && this.unmount(), t.prototype.destroy.call(this);
          }, n.prototype.mount = function (t) {
            if (this.isMounted) return this.node;var n = "string" == typeof t ? document.querySelector(t) : t,
                e = this.render();return this.node = e, n.appendChild(e), e;
          }, n.prototype.render = function () {
            var t = this.stringify();return b(p(t)).childNodes[0];
          }, n.prototype.unmount = function () {
            this.node.parentNode.removeChild(this.node);
          }, Object.defineProperties(n.prototype, e), n;
        }(g),
            E = { autoConfigure: !0, mountTo: "body", syncUrlsWithBaseTag: !1, listenLocationChangeEvent: !0, locationChangeEvent: "locationChange", locationChangeAngularEmitter: !1, usagesToUpdate: "use[*|href]", moveGradientsOutsideSymbol: !1 },
            _ = function _(t) {
          return Array.prototype.slice.call(t, 0);
        },
            O = navigator.userAgent,
            S = { isChrome: /chrome/i.test(O), isFirefox: /firefox/i.test(O), isIE: /msie/i.test(O) || /trident/i.test(O), isEdge: /edge/i.test(O) },
            M = function M(t, n) {
          var e = document.createEvent("CustomEvent");e.initCustomEvent(t, !1, !1, n), window.dispatchEvent(e);
        },
            A = function A(t) {
          var n = [];return _(t.querySelectorAll("style")).forEach(function (t) {
            t.textContent += "", n.push(t);
          }), n;
        },
            C = function C(t) {
          return (t || window.location.href).split("#")[0];
        },
            j = function j(t) {
          angular.module("ng").run(["$rootScope", function (n) {
            n.$on("$locationChangeSuccess", function (n, e, o) {
              M(t, { oldUrl: o, newUrl: e });
            });
          }]);
        },
            N = function N(t, n) {
          return void 0 === n && (n = "linearGradient, radialGradient, pattern"), _(t.querySelectorAll("symbol")).forEach(function (t) {
            _(t.querySelectorAll(n)).forEach(function (n) {
              t.parentNode.insertBefore(n, t);
            });
          }), t;
        },
            T = c.xlink.uri,
            k = "xlink:href",
            B = /[{}|\\\^\[\]`"<>]/g,
            U = ["clipPath", "colorProfile", "src", "cursor", "fill", "filter", "marker", "markerStart", "markerMid", "markerEnd", "mask", "stroke", "style"],
            L = U.map(function (t) {
          return "[" + t + "]";
        }).join(","),
            P = function P(t, n, e, u) {
          var c = r(e),
              s = r(u);o(t.querySelectorAll(L), function (t) {
            var n = t.localName,
                e = t.value;return -1 !== U.indexOf(n) && -1 !== e.indexOf("url(" + c);
          }).forEach(function (t) {
            return t.value = t.value.replace(c, s);
          }), i(n, c, s);
        },
            G = { MOUNT: "mount", SYMBOL_MOUNT: "symbol_mount" },
            q = function (t) {
          function n(n) {
            var o = this;void 0 === n && (n = {}), t.call(this, u(E, n));var r = e();this._emitter = r, this.node = null;var i = this,
                c = i.config;if (c.autoConfigure && this._autoConfigure(n), c.syncUrlsWithBaseTag) {
              var s = document.getElementsByTagName("base")[0].getAttribute("href");r.on(G.MOUNT, function () {
                return o.updateUrls("#", s);
              });
            }var a = this._handleLocationChange.bind(this);this._handleLocationChange = a, c.listenLocationChangeEvent && window.addEventListener(c.locationChangeEvent, a), c.locationChangeAngularEmitter && j(c.locationChangeEvent), r.on(G.MOUNT, function (t) {
              c.moveGradientsOutsideSymbol && N(t);
            }), r.on(G.SYMBOL_MOUNT, function (t) {
              c.moveGradientsOutsideSymbol && N(t.parentNode), (S.isIE || S.isEdge) && A(t);
            });
          }t && (n.__proto__ = t), n.prototype = Object.create(t && t.prototype), n.prototype.constructor = n;var o = { isMounted: {} };return o.isMounted.get = function () {
            return !!this.node;
          }, n.prototype._autoConfigure = function (t) {
            var n = this,
                e = n.config;void 0 === t.syncUrlsWithBaseTag && (e.syncUrlsWithBaseTag = void 0 !== document.getElementsByTagName("base")[0]), void 0 === t.locationChangeAngularEmitter && (e.locationChangeAngularEmitter = "angular" in window), void 0 === t.moveGradientsOutsideSymbol && (e.moveGradientsOutsideSymbol = S.isFirefox);
          }, n.prototype._handleLocationChange = function (t) {
            var n = t.detail,
                e = n.oldUrl,
                o = n.newUrl;this.updateUrls(e, o);
          }, n.prototype.add = function (n) {
            var e = this,
                o = t.prototype.add.call(this, n);return this.isMounted && o && (n.mount(e.node), this._emitter.emit(G.SYMBOL_MOUNT, n.node)), o;
          }, n.prototype.attach = function (t) {
            var n = this,
                e = this;if (e.isMounted) return e.node;var o = "string" == typeof t ? document.querySelector(t) : t;return e.node = o, this.symbols.forEach(function (t) {
              t.mount(e.node), n._emitter.emit(G.SYMBOL_MOUNT, t.node);
            }), _(o.querySelectorAll("symbol")).forEach(function (t) {
              var n = x.createFromExistingNode(t);n.node = t, e.add(n);
            }), this._emitter.emit(G.MOUNT, o), o;
          }, n.prototype.destroy = function () {
            var t = this,
                n = t.config,
                e = t.symbols,
                o = t._emitter;e.forEach(function (t) {
              return t.destroy();
            }), o.off("*"), window.removeEventListener(n.locationChangeEvent, this._handleLocationChange), this.isMounted && this.unmount();
          }, n.prototype.mount = function (t, n) {
            void 0 === t && (t = this.config.mountTo), void 0 === n && (n = !1);var e = this;if (e.isMounted) return e.node;var o = "string" == typeof t ? document.querySelector(t) : t,
                r = e.render();return this.node = r, n && o.childNodes[0] ? o.insertBefore(r, o.childNodes[0]) : o.appendChild(r), this._emitter.emit(G.MOUNT, r), r;
          }, n.prototype.render = function () {
            return b(this.stringify());
          }, n.prototype.unmount = function () {
            this.node.parentNode.removeChild(this.node);
          }, n.prototype.updateUrls = function (t, n) {
            if (!this.isMounted) return !1;var e = document.querySelectorAll(this.config.usagesToUpdate);return P(this.node, e, C(t) + "#", C(n) + "#"), !0;
          }, Object.defineProperties(n.prototype, o), n;
        }(v),
            D = t(function (t) {
          /*!
          * domready (c) Dustin Diaz 2014 - License MIT
          */
          !function (n, e) {
            t.exports = function () {
              var _t,
                  n = [],
                  e = document,
                  o = e.documentElement.doScroll,
                  r = (o ? /^loaded|^c/ : /^loaded|^i|^c/).test(e.readyState);return r || e.addEventListener("DOMContentLoaded", _t = function t() {
                for (e.removeEventListener("DOMContentLoaded", _t), r = 1; _t = n.shift();) {
                  _t();
                }
              }), function (t) {
                r ? setTimeout(t, 0) : n.push(t);
              };
            }();
          }();
        }),
            F = !!window.__SVG_SPRITE__;F ? w = window.__SVG_SPRITE__ : (w = new q({ attrs: { id: "__SVG_SPRITE_NODE__" } }), window.__SVG_SPRITE__ = w);var I = function I() {
          var t = document.getElementById("__SVG_SPRITE_NODE__");t ? w.attach(t) : w.mount(document.body, !0);
        };return document.body ? I() : D(I), w;
      });
    }).call(n, e("698d75b157f24ae829cc"));
  } });

/***/ }),
/* 9 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(47);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.BrowserSpriteSymbol = factory());
}(this, (function () { 'use strict';

var SpriteSymbol = function SpriteSymbol(ref) {
  var id = ref.id;
  var viewBox = ref.viewBox;
  var content = ref.content;

  this.id = id;
  this.viewBox = viewBox;
  this.content = content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.stringify = function stringify () {
  return this.content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.toString = function toString () {
  return this.stringify();
};

SpriteSymbol.prototype.destroy = function destroy () {
    var this$1 = this;

  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
};

/**
 * @param {string} content
 * @return {Element}
 */
var parse = function (content) {
  var hasImportNode = !!document.importNode;
  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;

  /**
   * Fix for browser which are throwing WrongDocumentError
   * if you insert an element which is not part of the document
   * @see http://stackoverflow.com/a/7986519/4624403
   */
  if (hasImportNode) {
    return document.importNode(doc, true);
  }

  return doc;
};

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var deepmerge = createCommonjsModule(function (module, exports) {
(function (root, factory) {
    if (false) {
        undefined(factory);
    } else {
        module.exports = factory();
    }
}(commonjsGlobal, function () {

function isMergeableObject(val) {
    var nonNullObject = val && typeof val === 'object';

    return nonNullObject
        && Object.prototype.toString.call(val) !== '[object RegExp]'
        && Object.prototype.toString.call(val) !== '[object Date]'
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var array = Array.isArray(source);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var arrayMerge = options.arrayMerge || defaultArrayMerge;

    if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

return deepmerge

}));
});

var namespaces_1 = createCommonjsModule(function (module, exports) {
var namespaces = {
  svg: {
    name: 'xmlns',
    uri: 'http://www.w3.org/2000/svg'
  },
  xlink: {
    name: 'xmlns:xlink',
    uri: 'http://www.w3.org/1999/xlink'
  }
};

exports.default = namespaces;
module.exports = exports.default;
});

/**
 * @param {Object} attrs
 * @return {string}
 */
var objectToAttrsString = function (attrs) {
  return Object.keys(attrs).map(function (attr) {
    var value = attrs[attr].toString().replace(/"/g, '&quot;');
    return (attr + "=\"" + value + "\"");
  }).join(' ');
};

var svg = namespaces_1.svg;
var xlink = namespaces_1.xlink;

var defaultAttrs = {};
defaultAttrs[svg.name] = svg.uri;
defaultAttrs[xlink.name] = xlink.uri;

/**
 * @param {string} [content]
 * @param {Object} [attributes]
 * @return {string}
 */
var wrapInSvgString = function (content, attributes) {
  if ( content === void 0 ) content = '';

  var attrs = deepmerge(defaultAttrs, attributes || {});
  var attrsRendered = objectToAttrsString(attrs);
  return ("<svg " + attrsRendered + ">" + content + "</svg>");
};

var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
  function BrowserSpriteSymbol () {
    SpriteSymbol$$1.apply(this, arguments);
  }

  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;

  var prototypeAccessors = { isMounted: {} };

  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * @param {Element} node
   * @return {BrowserSpriteSymbol}
   */
  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
    return new BrowserSpriteSymbol({
      id: node.getAttribute('id'),
      viewBox: node.getAttribute('viewBox'),
      content: node.outerHTML
    });
  };

  BrowserSpriteSymbol.prototype.destroy = function destroy () {
    if (this.isMounted) {
      this.unmount();
    }
    SpriteSymbol$$1.prototype.destroy.call(this);
  };

  /**
   * @param {Element|string} target
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.mount = function mount (target) {
    if (this.isMounted) {
      return this.node;
    }

    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
    var node = this.render();
    this.node = node;

    mountTarget.appendChild(node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.render = function render () {
    var content = this.stringify();
    return parse(wrapInSvgString(content)).childNodes[0];
  };

  BrowserSpriteSymbol.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );

  return BrowserSpriteSymbol;
}(SpriteSymbol));

return BrowserSpriteSymbol;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.BrowserSprite = factory());
}(this, (function () { 'use strict';

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var deepmerge = createCommonjsModule(function (module, exports) {
(function (root, factory) {
    if (false) {
        undefined(factory);
    } else {
        module.exports = factory();
    }
}(commonjsGlobal, function () {

function isMergeableObject(val) {
    var nonNullObject = val && typeof val === 'object';

    return nonNullObject
        && Object.prototype.toString.call(val) !== '[object RegExp]'
        && Object.prototype.toString.call(val) !== '[object Date]'
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var array = Array.isArray(source);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var arrayMerge = options.arrayMerge || defaultArrayMerge;

    if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

return deepmerge

}));
});

//      
// An event handler can take an optional event argument
// and should not return a value
                                          
// An array of all currently registered event handlers for a type
                                            
// A map of event types and their corresponding event handlers.
                        
                                   
  

/** Mitt: Tiny (~200b) functional event emitter / pubsub.
 *  @name mitt
 *  @returns {Mitt}
 */
function mitt(all                 ) {
	all = all || Object.create(null);

	return {
		/**
		 * Register an event handler for the given type.
		 *
		 * @param  {String} type	Type of event to listen for, or `"*"` for all events
		 * @param  {Function} handler Function to call in response to given event
		 * @memberOf mitt
		 */
		on: function on(type        , handler              ) {
			(all[type] || (all[type] = [])).push(handler);
		},

		/**
		 * Remove an event handler for the given type.
		 *
		 * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
		 * @param  {Function} handler Handler function to remove
		 * @memberOf mitt
		 */
		off: function off(type        , handler              ) {
			if (all[type]) {
				all[type].splice(all[type].indexOf(handler) >>> 0, 1);
			}
		},

		/**
		 * Invoke all handlers for the given type.
		 * If present, `"*"` handlers are invoked after type-matched handlers.
		 *
		 * @param {String} type  The event type to invoke
		 * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
		 * @memberof mitt
		 */
		emit: function emit(type        , evt     ) {
			(all[type] || []).map(function (handler) { handler(evt); });
			(all['*'] || []).map(function (handler) { handler(type, evt); });
		}
	};
}

var namespaces_1 = createCommonjsModule(function (module, exports) {
var namespaces = {
  svg: {
    name: 'xmlns',
    uri: 'http://www.w3.org/2000/svg'
  },
  xlink: {
    name: 'xmlns:xlink',
    uri: 'http://www.w3.org/1999/xlink'
  }
};

exports.default = namespaces;
module.exports = exports.default;
});

/**
 * @param {Object} attrs
 * @return {string}
 */
var objectToAttrsString = function (attrs) {
  return Object.keys(attrs).map(function (attr) {
    var value = attrs[attr].toString().replace(/"/g, '&quot;');
    return (attr + "=\"" + value + "\"");
  }).join(' ');
};

var svg = namespaces_1.svg;
var xlink = namespaces_1.xlink;

var defaultAttrs = {};
defaultAttrs[svg.name] = svg.uri;
defaultAttrs[xlink.name] = xlink.uri;

/**
 * @param {string} [content]
 * @param {Object} [attributes]
 * @return {string}
 */
var wrapInSvgString = function (content, attributes) {
  if ( content === void 0 ) content = '';

  var attrs = deepmerge(defaultAttrs, attributes || {});
  var attrsRendered = objectToAttrsString(attrs);
  return ("<svg " + attrsRendered + ">" + content + "</svg>");
};

var svg$1 = namespaces_1.svg;
var xlink$1 = namespaces_1.xlink;

var defaultConfig = {
  attrs: ( obj = {
    style: ['position: absolute', 'width: 0', 'height: 0'].join('; ')
  }, obj[svg$1.name] = svg$1.uri, obj[xlink$1.name] = xlink$1.uri, obj )
};
var obj;

var Sprite = function Sprite(config) {
  this.config = deepmerge(defaultConfig, config || {});
  this.symbols = [];
};

/**
 * Add new symbol. If symbol with the same id exists it will be replaced.
 * @param {SpriteSymbol} symbol
 * @return {boolean} `true` - symbol was added, `false` - replaced
 */
Sprite.prototype.add = function add (symbol) {
  var ref = this;
    var symbols = ref.symbols;
  var existing = this.find(symbol.id);

  if (existing) {
    symbols[symbols.indexOf(existing)] = symbol;
    return false;
  }

  symbols.push(symbol);
  return true;
};

/**
 * Remove symbol & destroy it
 * @param {string} id
 * @return {boolean} `true` - symbol was found & successfully destroyed, `false` - otherwise
 */
Sprite.prototype.remove = function remove (id) {
  var ref = this;
    var symbols = ref.symbols;
  var symbol = this.find(id);

  if (symbol) {
    symbols.splice(symbols.indexOf(symbol), 1);
    symbol.destroy();
    return true;
  }

  return false;
};

/**
 * @param {string} id
 * @return {SpriteSymbol|null}
 */
Sprite.prototype.find = function find (id) {
  return this.symbols.filter(function (s) { return s.id === id; })[0] || null;
};

/**
 * @param {string} id
 * @return {boolean}
 */
Sprite.prototype.has = function has (id) {
  return this.find(id) !== null;
};

/**
 * @return {string}
 */
Sprite.prototype.stringify = function stringify () {
  var ref = this.config;
    var attrs = ref.attrs;
  var stringifiedSymbols = this.symbols.map(function (s) { return s.stringify(); }).join('');
  return wrapInSvgString(stringifiedSymbols, attrs);
};

/**
 * @return {string}
 */
Sprite.prototype.toString = function toString () {
  return this.stringify();
};

Sprite.prototype.destroy = function destroy () {
  this.symbols.forEach(function (s) { return s.destroy(); });
};

var SpriteSymbol = function SpriteSymbol(ref) {
  var id = ref.id;
  var viewBox = ref.viewBox;
  var content = ref.content;

  this.id = id;
  this.viewBox = viewBox;
  this.content = content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.stringify = function stringify () {
  return this.content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.toString = function toString () {
  return this.stringify();
};

SpriteSymbol.prototype.destroy = function destroy () {
    var this$1 = this;

  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
};

/**
 * @param {string} content
 * @return {Element}
 */
var parse = function (content) {
  var hasImportNode = !!document.importNode;
  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;

  /**
   * Fix for browser which are throwing WrongDocumentError
   * if you insert an element which is not part of the document
   * @see http://stackoverflow.com/a/7986519/4624403
   */
  if (hasImportNode) {
    return document.importNode(doc, true);
  }

  return doc;
};

var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
  function BrowserSpriteSymbol () {
    SpriteSymbol$$1.apply(this, arguments);
  }

  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;

  var prototypeAccessors = { isMounted: {} };

  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * @param {Element} node
   * @return {BrowserSpriteSymbol}
   */
  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
    return new BrowserSpriteSymbol({
      id: node.getAttribute('id'),
      viewBox: node.getAttribute('viewBox'),
      content: node.outerHTML
    });
  };

  BrowserSpriteSymbol.prototype.destroy = function destroy () {
    if (this.isMounted) {
      this.unmount();
    }
    SpriteSymbol$$1.prototype.destroy.call(this);
  };

  /**
   * @param {Element|string} target
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.mount = function mount (target) {
    if (this.isMounted) {
      return this.node;
    }

    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
    var node = this.render();
    this.node = node;

    mountTarget.appendChild(node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.render = function render () {
    var content = this.stringify();
    return parse(wrapInSvgString(content)).childNodes[0];
  };

  BrowserSpriteSymbol.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );

  return BrowserSpriteSymbol;
}(SpriteSymbol));

var defaultConfig$1 = {
  /**
   * Should following options be automatically configured:
   * - `syncUrlsWithBaseTag`
   * - `locationChangeAngularEmitter`
   * - `moveGradientsOutsideSymbol`
   * @type {boolean}
   */
  autoConfigure: true,

  /**
   * Default mounting selector
   * @type {string}
   */
  mountTo: 'body',

  /**
   * Fix disappearing SVG elements when <base href> exists.
   * Executes when sprite mounted.
   * @see http://stackoverflow.com/a/18265336/796152
   * @see https://github.com/everdimension/angular-svg-base-fix
   * @see https://github.com/angular/angular.js/issues/8934#issuecomment-56568466
   * @type {boolean}
   */
  syncUrlsWithBaseTag: false,

  /**
   * Should sprite listen custom location change event
   * @type {boolean}
   */
  listenLocationChangeEvent: true,

  /**
   * Custom window event name which should be emitted to update sprite urls
   * @type {string}
   */
  locationChangeEvent: 'locationChange',

  /**
   * Emit location change event in Angular automatically
   * @type {boolean}
   */
  locationChangeAngularEmitter: false,

  /**
   * Selector to find symbols usages when updating sprite urls
   * @type {string}
   */
  usagesToUpdate: 'use[*|href]',

  /**
   * Fix Firefox bug when gradients and patterns don't work if they are within a symbol.
   * Executes when sprite is rendered, but not mounted.
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=306674
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=353575
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1235364
   * @type {boolean}
   */
  moveGradientsOutsideSymbol: false
};

/**
 * @param {*} arrayLike
 * @return {Array}
 */
var arrayFrom = function (arrayLike) {
  return Array.prototype.slice.call(arrayLike, 0);
};

var ua = navigator.userAgent;

var browser = {
  isChrome: /chrome/i.test(ua),
  isFirefox: /firefox/i.test(ua),

  // https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
  isIE: /msie/i.test(ua) || /trident/i.test(ua),
  isEdge: /edge/i.test(ua)
};

/**
 * @param {string} name
 * @param {*} data
 */
var dispatchEvent = function (name, data) {
  var event = document.createEvent('CustomEvent');
  event.initCustomEvent(name, false, false, data);
  window.dispatchEvent(event);
};

/**
 * IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
 * This trick will trigger IE to read and use any existing SVG <style> tags.
 * @see https://github.com/iconic/SVGInjector/issues/23
 * @see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10898469/
 *
 * @param {Element} node DOM Element to search <style> tags in
 * @return {Array<HTMLStyleElement>}
 */
var evalStylesIEWorkaround = function (node) {
  var updatedNodes = [];

  arrayFrom(node.querySelectorAll('style'))
    .forEach(function (style) {
      style.textContent += '';
      updatedNodes.push(style);
    });

  return updatedNodes;
};

/**
 * @param {string} [url] If not provided - current URL will be used
 * @return {string}
 */
var getUrlWithoutFragment = function (url) {
  return (url || window.location.href).split('#')[0];
};

/* global angular */
/**
 * @param {string} eventName
 */
var locationChangeAngularEmitter = function (eventName) {
  angular.module('ng').run(['$rootScope', function ($rootScope) {
    $rootScope.$on('$locationChangeSuccess', function (e, newUrl, oldUrl) {
      dispatchEvent(eventName, { oldUrl: oldUrl, newUrl: newUrl });
    });
  }]);
};

var defaultSelector = 'linearGradient, radialGradient, pattern';

/**
 * @param {Element} svg
 * @param {string} [selector]
 * @return {Element}
 */
var moveGradientsOutsideSymbol = function (svg, selector) {
  if ( selector === void 0 ) selector = defaultSelector;

  arrayFrom(svg.querySelectorAll('symbol')).forEach(function (symbol) {
    arrayFrom(symbol.querySelectorAll(selector)).forEach(function (node) {
      symbol.parentNode.insertBefore(node, symbol);
    });
  });
  return svg;
};

/**
 * @param {NodeList} nodes
 * @param {Function} [matcher]
 * @return {Attr[]}
 */
function selectAttributes(nodes, matcher) {
  var attrs = arrayFrom(nodes).reduce(function (acc, node) {
    if (!node.attributes) {
      return acc;
    }

    var arrayfied = arrayFrom(node.attributes);
    var matched = matcher ? arrayfied.filter(matcher) : arrayfied;
    return acc.concat(matched);
  }, []);

  return attrs;
}

/**
 * @param {NodeList|Node} nodes
 * @param {boolean} [clone=true]
 * @return {string}
 */

var xLinkNS = namespaces_1.xlink.uri;
var xLinkAttrName = 'xlink:href';

// eslint-disable-next-line no-useless-escape
var specialUrlCharsPattern = /[{}|\\\^\[\]`"<>]/g;

function encoder(url) {
  return url.replace(specialUrlCharsPattern, function (match) {
    return ("%" + (match[0].charCodeAt(0).toString(16).toUpperCase()));
  });
}

/**
 * @param {NodeList} nodes
 * @param {string} startsWith
 * @param {string} replaceWith
 * @return {NodeList}
 */
function updateReferences(nodes, startsWith, replaceWith) {
  arrayFrom(nodes).forEach(function (node) {
    var href = node.getAttribute(xLinkAttrName);
    if (href && href.indexOf(startsWith) === 0) {
      var newUrl = href.replace(startsWith, replaceWith);
      node.setAttributeNS(xLinkNS, xLinkAttrName, newUrl);
    }
  });

  return nodes;
}

/**
 * List of SVG attributes to update url() target in them
 */
var attList = [
  'clipPath',
  'colorProfile',
  'src',
  'cursor',
  'fill',
  'filter',
  'marker',
  'markerStart',
  'markerMid',
  'markerEnd',
  'mask',
  'stroke',
  'style'
];

var attSelector = attList.map(function (attr) { return ("[" + attr + "]"); }).join(',');

/**
 * Update URLs in svg image (like `fill="url(...)"`) and update referencing elements
 * @param {Element} svg
 * @param {NodeList} references
 * @param {string|RegExp} startsWith
 * @param {string} replaceWith
 * @return {void}
 *
 * @example
 * const sprite = document.querySelector('svg.sprite');
 * const usages = document.querySelectorAll('use');
 * updateUrls(sprite, usages, '#', 'prefix#');
 */
var updateUrls = function (svg, references, startsWith, replaceWith) {
  var startsWithEncoded = encoder(startsWith);
  var replaceWithEncoded = encoder(replaceWith);

  var nodes = svg.querySelectorAll(attSelector);
  var attrs = selectAttributes(nodes, function (ref) {
    var localName = ref.localName;
    var value = ref.value;

    return attList.indexOf(localName) !== -1 && value.indexOf(("url(" + startsWithEncoded)) !== -1;
  });

  attrs.forEach(function (attr) { return attr.value = attr.value.replace(startsWithEncoded, replaceWithEncoded); });
  updateReferences(references, startsWithEncoded, replaceWithEncoded);
};

/**
 * Internal emitter events
 * @enum
 * @private
 */
var Events = {
  MOUNT: 'mount',
  SYMBOL_MOUNT: 'symbol_mount'
};

var BrowserSprite = (function (Sprite$$1) {
  function BrowserSprite(cfg) {
    var this$1 = this;
    if ( cfg === void 0 ) cfg = {};

    Sprite$$1.call(this, deepmerge(defaultConfig$1, cfg));

    var emitter = mitt();
    this._emitter = emitter;
    this.node = null;

    var ref = this;
    var config = ref.config;

    if (config.autoConfigure) {
      this._autoConfigure(cfg);
    }

    if (config.syncUrlsWithBaseTag) {
      var baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
      emitter.on(Events.MOUNT, function () { return this$1.updateUrls('#', baseUrl); });
    }

    var handleLocationChange = this._handleLocationChange.bind(this);
    this._handleLocationChange = handleLocationChange;

    // Provide way to update sprite urls externally via dispatching custom window event
    if (config.listenLocationChangeEvent) {
      window.addEventListener(config.locationChangeEvent, handleLocationChange);
    }

    // Emit location change event in Angular automatically
    if (config.locationChangeAngularEmitter) {
      locationChangeAngularEmitter(config.locationChangeEvent);
    }

    // After sprite mounted
    emitter.on(Events.MOUNT, function (spriteNode) {
      if (config.moveGradientsOutsideSymbol) {
        moveGradientsOutsideSymbol(spriteNode);
      }
    });

    // After symbol mounted into sprite
    emitter.on(Events.SYMBOL_MOUNT, function (symbolNode) {
      if (config.moveGradientsOutsideSymbol) {
        moveGradientsOutsideSymbol(symbolNode.parentNode);
      }

      if (browser.isIE || browser.isEdge) {
        evalStylesIEWorkaround(symbolNode);
      }
    });
  }

  if ( Sprite$$1 ) BrowserSprite.__proto__ = Sprite$$1;
  BrowserSprite.prototype = Object.create( Sprite$$1 && Sprite$$1.prototype );
  BrowserSprite.prototype.constructor = BrowserSprite;

  var prototypeAccessors = { isMounted: {} };

  /**
   * @return {boolean}
   */
  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * Automatically configure following options
   * - `syncUrlsWithBaseTag`
   * - `locationChangeAngularEmitter`
   * - `moveGradientsOutsideSymbol`
   * @param {Object} cfg
   * @private
   */
  BrowserSprite.prototype._autoConfigure = function _autoConfigure (cfg) {
    var ref = this;
    var config = ref.config;

    if (typeof cfg.syncUrlsWithBaseTag === 'undefined') {
      config.syncUrlsWithBaseTag = typeof document.getElementsByTagName('base')[0] !== 'undefined';
    }

    if (typeof cfg.locationChangeAngularEmitter === 'undefined') {
      config.locationChangeAngularEmitter = 'angular' in window;
    }

    if (typeof cfg.moveGradientsOutsideSymbol === 'undefined') {
      config.moveGradientsOutsideSymbol = browser.isFirefox;
    }
  };

  /**
   * @param {Event} event
   * @param {Object} event.detail
   * @param {string} event.detail.oldUrl
   * @param {string} event.detail.newUrl
   * @private
   */
  BrowserSprite.prototype._handleLocationChange = function _handleLocationChange (event) {
    var ref = event.detail;
    var oldUrl = ref.oldUrl;
    var newUrl = ref.newUrl;
    this.updateUrls(oldUrl, newUrl);
  };

  /**
   * Add new symbol. If symbol with the same id exists it will be replaced.
   * If sprite already mounted - `symbol.mount(sprite.node)` will be called.
   * @fires Events#SYMBOL_MOUNT
   * @param {BrowserSpriteSymbol} symbol
   * @return {boolean} `true` - symbol was added, `false` - replaced
   */
  BrowserSprite.prototype.add = function add (symbol) {
    var sprite = this;
    var isNewSymbol = Sprite$$1.prototype.add.call(this, symbol);

    if (this.isMounted && isNewSymbol) {
      symbol.mount(sprite.node);
      this._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
    }

    return isNewSymbol;
  };

  /**
   * Attach to existing DOM node
   * @param {string|Element} target
   * @return {Element|null} attached DOM Element. null if node to attach not found.
   */
  BrowserSprite.prototype.attach = function attach (target) {
    var this$1 = this;

    var sprite = this;

    if (sprite.isMounted) {
      return sprite.node;
    }

    /** @type Element */
    var node = typeof target === 'string' ? document.querySelector(target) : target;
    sprite.node = node;

    // Already added symbols needs to be mounted
    this.symbols.forEach(function (symbol) {
      symbol.mount(sprite.node);
      this$1._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
    });

    // Create symbols from existing DOM nodes, add and mount them
    arrayFrom(node.querySelectorAll('symbol'))
      .forEach(function (symbolNode) {
        var symbol = BrowserSpriteSymbol.createFromExistingNode(symbolNode);
        symbol.node = symbolNode; // hack to prevent symbol mounting to sprite when adding
        sprite.add(symbol);
      });

    this._emitter.emit(Events.MOUNT, node);

    return node;
  };

  BrowserSprite.prototype.destroy = function destroy () {
    var ref = this;
    var config = ref.config;
    var symbols = ref.symbols;
    var _emitter = ref._emitter;

    symbols.forEach(function (s) { return s.destroy(); });

    _emitter.off('*');
    window.removeEventListener(config.locationChangeEvent, this._handleLocationChange);

    if (this.isMounted) {
      this.unmount();
    }
  };

  /**
   * @fires Events#MOUNT
   * @param {string|Element} [target]
   * @param {boolean} [prepend=false]
   * @return {Element|null} rendered sprite node. null if mount node not found.
   */
  BrowserSprite.prototype.mount = function mount (target, prepend) {
    if ( target === void 0 ) target = this.config.mountTo;
    if ( prepend === void 0 ) prepend = false;

    var sprite = this;

    if (sprite.isMounted) {
      return sprite.node;
    }

    var mountNode = typeof target === 'string' ? document.querySelector(target) : target;
    var node = sprite.render();
    this.node = node;

    if (prepend && mountNode.childNodes[0]) {
      mountNode.insertBefore(node, mountNode.childNodes[0]);
    } else {
      mountNode.appendChild(node);
    }

    this._emitter.emit(Events.MOUNT, node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSprite.prototype.render = function render () {
    return parse(this.stringify());
  };

  /**
   * Detach sprite from the DOM
   */
  BrowserSprite.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  /**
   * Update URLs in sprite and usage elements
   * @param {string} oldUrl
   * @param {string} newUrl
   * @return {boolean} `true` - URLs was updated, `false` - sprite is not mounted
   */
  BrowserSprite.prototype.updateUrls = function updateUrls$1 (oldUrl, newUrl) {
    if (!this.isMounted) {
      return false;
    }

    var usages = document.querySelectorAll(this.config.usagesToUpdate);

    updateUrls(
      this.node,
      usages,
      ((getUrlWithoutFragment(oldUrl)) + "#"),
      ((getUrlWithoutFragment(newUrl)) + "#")
    );

    return true;
  };

  Object.defineProperties( BrowserSprite.prototype, prototypeAccessors );

  return BrowserSprite;
}(Sprite));

var ready$1 = createCommonjsModule(function (module) {
/*!
  * domready (c) Dustin Diaz 2014 - License MIT
  */
!function (name, definition) {

  { module.exports = definition(); }

}('domready', function () {

  var fns = [], listener
    , doc = document
    , hack = doc.documentElement.doScroll
    , domContentLoaded = 'DOMContentLoaded'
    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);


  if (!loaded)
  { doc.addEventListener(domContentLoaded, listener = function () {
    doc.removeEventListener(domContentLoaded, listener);
    loaded = 1;
    while (listener = fns.shift()) { listener(); }
  }); }

  return function (fn) {
    loaded ? setTimeout(fn, 0) : fns.push(fn);
  }

});
});

var spriteNodeId = '__SVG_SPRITE_NODE__';
var spriteGlobalVarName = '__SVG_SPRITE__';
var isSpriteExists = !!window[spriteGlobalVarName];

// eslint-disable-next-line import/no-mutable-exports
var sprite;

if (isSpriteExists) {
  sprite = window[spriteGlobalVarName];
} else {
  sprite = new BrowserSprite({ attrs: { id: spriteNodeId } });
  window[spriteGlobalVarName] = sprite;
}

var loadSprite = function () {
  /**
   * Check for page already contains sprite node
   * If found - attach to and reuse it's content
   * If not - render and mount the new sprite
   */
  var existing = document.getElementById(spriteNodeId);

  if (existing) {
    sprite.attach(existing);
  } else {
    sprite.mount(document.body, true);
  }
};

if (document.body) {
  loadSprite();
} else {
  ready$1(loadSprite);
}

var sprite$1 = sprite;

return sprite$1;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 15 */
/***/ (function(module, exports) {

var amdi18n={"__root":{"localFilters":"Local filters","slotEditorMsg1":"Required field","slotEditorMsg2":"Drag and drop data to the fields above to build and filter the visualization.","missingColumn":"Missing: %{columnLabel}","placeholderDropzone":"Click or drag data here","slotEditor_emptyState_no_visualization_selected_title":"No visualization selected","slotEditor_emptyState_no_visualization_selected_description":"Select a visualization to manage the field settings.","slotEditor_emptyState_widget_not_support_slot_selected_title":"The widget selected does not use fields","slotEditor_emptyState_widget_not_support_slot_selected_description":"Select a visualization to manage the field settings.","slotEditor_emptyState_multiple_visualizations_selected_title":"Multiple widgets selected","slotEditor_emptyState_multiple_visualizations_selected_description":"Select a visualization to manage the field settings.","slotEditor_emptyState_visualization_has_error_title":"The visualization cannot be displayed","slotEditor_slotItem_tooltip":"Source:","slotEditor_emptyState_vis_not_created_title":"No visualization created","slotEditor_emptyState_vis_not_created_description":"Create a visualization to manage the field settings.","slotEditor":"Fields","slotEditorCoachMarkTitle":"Access fields","slotEditorCoachMarkContents":"Add columns to the fields to build and modify visualizations.","toolbarDeleteFilterActionText":"Remove filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Filter bins","coachMarkTitleSpiralTarget":"Edit scope","coachMarkContentSpiralTarget":"This is where you can access and modify the driver selection for your target.","overlayDropZonePlaceHolderText":"Drag data here"},"__cs":{"localFilters":"Lokální filtry","slotEditorMsg1":"Povinné pole","slotEditorMsg2":"Přetáhněte data do polí nahoře, aby se sestavila a filtrovala vizualizace.","missingColumn":"Chybí: %{columnLabel}","placeholderDropzone":"Klepněte nebo přetáhněte data sem","slotEditor_emptyState_no_visualization_selected_title":"Není vybrána žádná vizualizace","slotEditor_emptyState_no_visualization_selected_description":"Vyberte vizualizaci pro správu nastavení polí.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Vybraný modul widget nepoužívá pole","slotEditor_emptyState_widget_not_support_slot_selected_description":"Vyberte vizualizaci pro správu nastavení polí.","slotEditor_emptyState_multiple_visualizations_selected_title":"Vybráno více modulů widget","slotEditor_emptyState_multiple_visualizations_selected_description":"Vyberte vizualizaci pro správu nastavení polí.","slotEditor_emptyState_visualization_has_error_title":"Vizualizaci nelze zobrazit","slotEditor_slotItem_tooltip":"Zdroj:","slotEditor_emptyState_vis_not_created_title":"Nebyla vytvořena žádná vizualizace","slotEditor_emptyState_vis_not_created_description":"Vytvořte vizualizaci pro správu nastavení polí.","slotEditor":"Pole","slotEditorCoachMarkTitle":"Přístupová pole","slotEditorCoachMarkContents":"Přidejte sloupce do polí, abyste mohli sestavovat a upravovat vizualizace.","toolbarDeleteFilterActionText":"Odebrat filtr","toolbarActionFilter":"Filtr","filterAutobinActionText":"Filtrovat přihrádky","coachMarkTitleSpiralTarget":"Upravit rozsah","coachMarkContentSpiralTarget":"Zde je k dispozici přístup k výběru drivery pro cíl a možnost jeho úprav.","overlayDropZonePlaceHolderText":"Přetáhněte data sem"},"__da":{"localFilters":"Lokale filtre","slotEditorMsg1":"Påkrævet felt","slotEditorMsg2":"Træk og placér data til felterne ovenfor for at bygge og filtrere visualiseringen.","missingColumn":"Mangler: %{columnLabel}","placeholderDropzone":"Klik og træk data her","slotEditor_emptyState_no_visualization_selected_title":"Der er ikke valgt nogen visualisering","slotEditor_emptyState_no_visualization_selected_description":"Vælg en visualisering for at administrere feltindstilingerne.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Den valgte widget bruger ikke felter","slotEditor_emptyState_widget_not_support_slot_selected_description":"Vælg en visualisering for at administrere feltindstilingerne.","slotEditor_emptyState_multiple_visualizations_selected_title":"Flere widgetter er valgt","slotEditor_emptyState_multiple_visualizations_selected_description":"Vælg en visualisering for at administrere feltindstilingerne.","slotEditor_emptyState_visualization_has_error_title":"Visualiseringen kan ikke vises","slotEditor_slotItem_tooltip":"Kilde:","slotEditor_emptyState_vis_not_created_title":"Ingen visualisering er oprettet","slotEditor_emptyState_vis_not_created_description":"Opret en visualisering for at administrere feltindstilingerne.","slotEditor":"Felter","slotEditorCoachMarkTitle":"Anvend felter","slotEditorCoachMarkContents":"Tilføj kolonner til felterne for at bygge og ændre visualiseringer.","toolbarDeleteFilterActionText":"Fjern filter","toolbarActionFilter":"Filtrér","filterAutobinActionText":"Filtrér områder (bins)","coachMarkTitleSpiralTarget":"Redigér omfang","coachMarkContentSpiralTarget":"Her kan du få adgang til og ændre styreprogramvalget for dit mål.","overlayDropZonePlaceHolderText":"Træk data her"},"__de":{"localFilters":"Lokale Filter","slotEditorMsg1":"Erforderliches Feld","slotEditorMsg2":"Daten in die Felder oben ziehen und ablegen, um die Visualisierung zu erstellen und zu filtern.","missingColumn":"Nicht vorhanden: %{columnLabel}","placeholderDropzone":"Klicken oder Daten hierher ziehen","slotEditor_emptyState_no_visualization_selected_title":"Keine Visualisierung ausgewählt","slotEditor_emptyState_no_visualization_selected_description":"Zum Verwalten der Feldeigenschaften eine Visualisierung auswählen.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Ausgewähltes Widget verwendet keine Felder","slotEditor_emptyState_widget_not_support_slot_selected_description":"Zum Verwalten der Feldeigenschaften eine Visualisierung auswählen.","slotEditor_emptyState_multiple_visualizations_selected_title":"Mehrere Widgets ausgewählt","slotEditor_emptyState_multiple_visualizations_selected_description":"Zum Verwalten der Feldeigenschaften eine Visualisierung auswählen.","slotEditor_emptyState_visualization_has_error_title":"Anzeigen der Visualisierung nicht möglich","slotEditor_slotItem_tooltip":"Quelle:","slotEditor_emptyState_vis_not_created_title":"Keine Visualisierung erstellt","slotEditor_emptyState_vis_not_created_description":"Zum Verwalten der Feldeigenschaften eine Visualisierung erstellen.","slotEditor":"Felder","slotEditorCoachMarkTitle":"Felder aufrufen","slotEditorCoachMarkContents":"Spalten zu den Feldern hinzufügen, um Visualisierungen zu erstellen und zu ändern.","toolbarDeleteFilterActionText":"Filter entfernen","toolbarActionFilter":"Filtern","filterAutobinActionText":"Bins filtern","coachMarkTitleSpiralTarget":"Bereich bearbeiten","coachMarkContentSpiralTarget":"Hier können Sie auf die Auswahl der Einflussfaktoren für das Ziel zugreifen und gegebenenfalls Änderungen vornehmen.","overlayDropZonePlaceHolderText":"Daten hierher ziehen"},"__es":{"localFilters":"Filtros locales","slotEditorMsg1":"Campo necesario","slotEditorMsg2":"Arrastre y suelte los datos en los campos para crear y filtrar la visualización.","missingColumn":"Falta: %{columnLabel}","placeholderDropzone":"Pulse o arrastre los datos aquí ","slotEditor_emptyState_no_visualization_selected_title":"No se ha seleccionado ninguna visualización","slotEditor_emptyState_no_visualization_selected_description":"Seleccione una visualización para gestionar los valores de campos.","slotEditor_emptyState_widget_not_support_slot_selected_title":"El widget seleccionado no utiliza campos","slotEditor_emptyState_widget_not_support_slot_selected_description":"Seleccione una visualización para gestionar los valores de campos.","slotEditor_emptyState_multiple_visualizations_selected_title":"Varios widgets seleccionados","slotEditor_emptyState_multiple_visualizations_selected_description":"Seleccione una visualización para gestionar los valores de campos.","slotEditor_emptyState_visualization_has_error_title":"La visualización no se puede visualizar","slotEditor_slotItem_tooltip":"Origen:","slotEditor_emptyState_vis_not_created_title":"No se ha creado ninguna visualización","slotEditor_emptyState_vis_not_created_description":"Cree una visualización para gestionar los valores de campos.","slotEditor":"Campos","slotEditorCoachMarkTitle":"Acceder a campos","slotEditorCoachMarkContents":"Añada columnas a los campos para crear y modificar visualizaciones.","toolbarDeleteFilterActionText":"Eliminar filtro","toolbarActionFilter":"Filtro","filterAutobinActionText":"Filtrar cubetas","coachMarkTitleSpiralTarget":"Editar ámbito","coachMarkContentSpiralTarget":"Aquí puede acceder y modificar la selección de controlador de su destino.","overlayDropZonePlaceHolderText":"Arrastre los datos aquí "},"__fi":{"localFilters":"Paikalliset suodattimet","slotEditorMsg1":"Pakollinen kenttä","slotEditorMsg2":"Voit muodostaa visualisoinnin ja suodattaa sen vetämällä ja pudottamalla tiedot yllä oleviin kenttiin.","missingColumn":"Puuttuva: %{columnLabel}","placeholderDropzone":"Napsauta tätä, tai vedä tiedot tähän","slotEditor_emptyState_no_visualization_selected_title":"Visualisointia ei ole valittu","slotEditor_emptyState_no_visualization_selected_description":"Valitse visualisointi, jotta voit hallita kentän asetuksia.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Valittu pienoisohjelma ei käytä kenttiä","slotEditor_emptyState_widget_not_support_slot_selected_description":"Valitse visualisointi, jotta voit hallita kentän asetuksia.","slotEditor_emptyState_multiple_visualizations_selected_title":"On valittu useita pienoisohjelmia","slotEditor_emptyState_multiple_visualizations_selected_description":"Valitse visualisointi, jotta voit hallita kentän asetuksia.","slotEditor_emptyState_visualization_has_error_title":"Visualisoinnin näyttö ei onnistunut","slotEditor_slotItem_tooltip":"Lähde:","slotEditor_emptyState_vis_not_created_title":"Visualisointia ei ole luotu","slotEditor_emptyState_vis_not_created_description":"Valitse visualisointi, jotta voit hallita kentän asetuksia.","slotEditor":"Kentät","slotEditorCoachMarkTitle":"Kenttien käyttö","slotEditorCoachMarkContents":"Lisää kenttiin sarakkeita visualisointien luontia ja muokkausta varten.","toolbarDeleteFilterActionText":"Poista suodatin","toolbarActionFilter":"Suodatin","filterAutobinActionText":"Suodata numeroryhmät","coachMarkTitleSpiralTarget":"Muokkaa aluetta","coachMarkContentSpiralTarget":"Tässä voit käyttää ja muokata vaikuttimien valintaa kohdetta varten.","overlayDropZonePlaceHolderText":"Vedä tiedot tähän"},"__fr":{"localFilters":"Filtres locaux","slotEditorMsg1":"Zone requise","slotEditorMsg2":"Glissez-déposez des données sur les zones ci-dessus pour générer et filtrer la visualisation.","missingColumn":"Manquant : %{columnLabel}","placeholderDropzone":"Cliquez ou faites glisser les données ici","slotEditor_emptyState_no_visualization_selected_title":"Aucune visualisation sélectionnée","slotEditor_emptyState_no_visualization_selected_description":"Sélectionnez une visualisation pour gérer les paramètres de zone.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Le widget sélectionné n'utilise pas les zones","slotEditor_emptyState_widget_not_support_slot_selected_description":"Sélectionnez une visualisation pour gérer les paramètres de zone.","slotEditor_emptyState_multiple_visualizations_selected_title":"Plusieurs widgets sélectionnés","slotEditor_emptyState_multiple_visualizations_selected_description":"Sélectionnez une visualisation pour gérer les paramètres de zone.","slotEditor_emptyState_visualization_has_error_title":"Impossible d'afficher la visualisation","slotEditor_slotItem_tooltip":"Source :","slotEditor_emptyState_vis_not_created_title":"Aucune visualisation créée","slotEditor_emptyState_vis_not_created_description":"Créez une visualisation pour gérer les paramètres de zone.","slotEditor":"Zones","slotEditorCoachMarkTitle":"Zones d'accès","slotEditorCoachMarkContents":"Ajouter des colonnes aux zones pour générer et modifier des visualisations.","toolbarDeleteFilterActionText":"Retirer le filtre","toolbarActionFilter":"Filtre","filterAutobinActionText":"Filtrer les casiers","coachMarkTitleSpiralTarget":"Editer la portée","coachMarkContentSpiralTarget":"Vous pouvez accéder ici au pilote sélectionné pour votre cible et le modifier.","overlayDropZonePlaceHolderText":"Glisser les données ici"},"__hr":{"localFilters":"Lokalni filteri","slotEditorMsg1":"Obavezno polje","slotEditorMsg2":"Povucite i ispustite podatke gore na polja da izgradite i filtrirate vizualizaciju.","missingColumn":"Nedostaje: %{columnLabel}","placeholderDropzone":"Kliknite ili povucite podatke ovdje","slotEditor_emptyState_no_visualization_selected_title":"Nema izabranih vizualizacija","slotEditor_emptyState_no_visualization_selected_description":"Izaberite vizualizaciju za upravljanje postavkama polja.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Izabrani grafički element ne koristi polja.","slotEditor_emptyState_widget_not_support_slot_selected_description":"Izaberite vizualizaciju za upravljanje postavkama polja.","slotEditor_emptyState_multiple_visualizations_selected_title":"Izabrano je više grafičkih elemenata.","slotEditor_emptyState_multiple_visualizations_selected_description":"Izaberite vizualizaciju za upravljanje postavkama polja.","slotEditor_emptyState_visualization_has_error_title":"Vizualizacija se ne može prikazati.","slotEditor_slotItem_tooltip":"Izvor:","slotEditor_emptyState_vis_not_created_title":"Vizualizacija nije kreirana","slotEditor_emptyState_vis_not_created_description":"Kreirajte vizualizaciju za upravljanje postavkama polja.","slotEditor":"Polja","slotEditorCoachMarkTitle":"Dohvati polja","slotEditorCoachMarkContents":"Poljima dodajte stupce za izgradite i promijenite vizualizacije.","toolbarDeleteFilterActionText":"Ukloni filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Pregradci filtera","coachMarkTitleSpiralTarget":"Uređivanje opsega","coachMarkContentSpiralTarget":"Ovdje možete dohvatiti i promijeniti izbor pogonitelja za vaš cilj.","overlayDropZonePlaceHolderText":"Povucite podatke ovdje"},"__hu":{"localFilters":"Helyi szűrők","slotEditorMsg1":"Kötelező mező","slotEditorMsg2":"Húzza az adatokat a fenti mezőkre a megjelenítés összeállításához és szűréséhez.","missingColumn":"A következő hiányzik: %{columnLabel}","placeholderDropzone":"Kattintson vagy húzzon ide adatokat","slotEditor_emptyState_no_visualization_selected_title":"Nincs kijelölt megjelenítés","slotEditor_emptyState_no_visualization_selected_description":"A mezőbeállítások kezeléséhez válasszon ki egy megjelenítést.","slotEditor_emptyState_widget_not_support_slot_selected_title":"A kiválasztott felületi elem nem használ mezőket","slotEditor_emptyState_widget_not_support_slot_selected_description":"A mezőbeállítások kezeléséhez válasszon ki egy megjelenítést.","slotEditor_emptyState_multiple_visualizations_selected_title":"Több felületi elem lett kiválasztva","slotEditor_emptyState_multiple_visualizations_selected_description":"A mezőbeállítások kezeléséhez válasszon ki egy megjelenítést.","slotEditor_emptyState_visualization_has_error_title":"A megjelenítés nem jeleníthető meg","slotEditor_slotItem_tooltip":"Forrás:","slotEditor_emptyState_vis_not_created_title":"Nincs létrehozva megjelenítés","slotEditor_emptyState_vis_not_created_description":"A mezőbeállítások kezeléséhez hozzon létre egy megjelenítést.","slotEditor":"Mezők","slotEditorCoachMarkTitle":"Mezők elérése","slotEditorCoachMarkContents":"Megjelenítések összeállításához és módosításához vegyen fel oszlopokat a mezőkbe.","toolbarDeleteFilterActionText":"Szűrő eltávolítása","toolbarActionFilter":"Szűrő","filterAutobinActionText":"Tároló szűrése","coachMarkTitleSpiralTarget":"Hatókör szerkesztése","coachMarkContentSpiralTarget":"Itt érheti el és módosíthatja a célhoz kijelölt tényezőket.","overlayDropZonePlaceHolderText":"Húzza ide az adatokat"},"__it":{"localFilters":"Filtri locali","slotEditorMsg1":"Campo obbligatorio","slotEditorMsg2":"Trascinare e rilasciare i dati nei campi sopra riportati per creare e filtrare la visualizzazione.","missingColumn":"Mancante: %{columnLabel}","placeholderDropzone":"Fare clic o trascinare i dati qui ","slotEditor_emptyState_no_visualization_selected_title":"Nessuna visualizzazione selezionata","slotEditor_emptyState_no_visualization_selected_description":"Selezionare una visualizzazione per gestire le impostazioni del campo.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Il widget selezionato non utilizza i campi","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selezionare una visualizzazione per gestire le impostazioni del campo.","slotEditor_emptyState_multiple_visualizations_selected_title":"Più widget selezionati","slotEditor_emptyState_multiple_visualizations_selected_description":"Selezionare una visualizzazione per gestire le impostazioni del campo.","slotEditor_emptyState_visualization_has_error_title":"Impossibile mostrare la visualizzazione","slotEditor_slotItem_tooltip":"Sorgente:","slotEditor_emptyState_vis_not_created_title":"Nessuna visualizzazione creata","slotEditor_emptyState_vis_not_created_description":"Creare una visualizzazione per gestire le impostazioni del campo.","slotEditor":"Campi","slotEditorCoachMarkTitle":"Accedi campi","slotEditorCoachMarkContents":"Aggiungi colonne ai campi per creare e modificare le visualizzazioni.","toolbarDeleteFilterActionText":"Rimuovi filtro","toolbarActionFilter":"Filtra","filterAutobinActionText":"Filtra bin","coachMarkTitleSpiralTarget":"Modifica ambito","coachMarkContentSpiralTarget":"Da qui è possibile accedere e modificare la selezione del driver per la propria destinazione.","overlayDropZonePlaceHolderText":"Trascinare i dati in questo punto"},"__ja":{"localFilters":"ローカル・フィルター","slotEditorMsg1":"必須フィールド","slotEditorMsg2":"上のフィールドにデータをドラッグ・アンド・ドロップし、視覚化を作成してフィルターに掛けます。","missingColumn":"欠落しています: %{columnLabel}","placeholderDropzone":"データをクリックするかここにドラッグしてください","slotEditor_emptyState_no_visualization_selected_title":"視覚化が選択されていません","slotEditor_emptyState_no_visualization_selected_description":"フィールド設定を管理するための視覚化を選択してください。","slotEditor_emptyState_widget_not_support_slot_selected_title":"選択したウィジェットではフィールドは使用しません","slotEditor_emptyState_widget_not_support_slot_selected_description":"フィールド設定を管理するための視覚化を選択してください。","slotEditor_emptyState_multiple_visualizations_selected_title":"複数のウィジェットが選択されています","slotEditor_emptyState_multiple_visualizations_selected_description":"フィールド設定を管理するための視覚化を選択してください。","slotEditor_emptyState_visualization_has_error_title":"視覚化を表示できません","slotEditor_slotItem_tooltip":"ソース:","slotEditor_emptyState_vis_not_created_title":"視覚化が作成されていません","slotEditor_emptyState_vis_not_created_description":"フィールド設定を管理するための視覚化を作成してください。","slotEditor":"フィールド","slotEditorCoachMarkTitle":"フィールドへのアクセス","slotEditorCoachMarkContents":"視覚化を作成したり変更したりするために列をフィールドに追加します。","toolbarDeleteFilterActionText":"フィルターの削除","toolbarActionFilter":"フィルター","filterAutobinActionText":"ビンのフィルター","coachMarkTitleSpiralTarget":"範囲の編集","coachMarkContentSpiralTarget":"ここでターゲットのドライバー選択にアクセスして変更することができます。","overlayDropZonePlaceHolderText":"ここにデータをドラッグ"},"__kk":{"localFilters":"Жергілікті сүзгілер","slotEditorMsg1":"Қажетті өріс","slotEditorMsg2":"Көрнекілікті сүзгілеу және құру үшін өрістерге деректерді сүйреп апарып тастаңыз.","missingColumn":"Жоқ: %{columnLabel}","placeholderDropzone":"Деректерді мына жерге нұқыңыз немесе сүйреңіз","slotEditor_emptyState_no_visualization_selected_title":"Көрнекілендіру таңдалмаған","slotEditor_emptyState_no_visualization_selected_description":"Өрістердің параметрлерін басқару үшін көрнекілендіру жасаңыз.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Таңдалған виджет өрістерды пайдаланбайды","slotEditor_emptyState_widget_not_support_slot_selected_description":"Өрістердің параметрлерін басқару үшін көрнекілендіру таңдаңыз.","slotEditor_emptyState_multiple_visualizations_selected_title":"Бірнеше виджеттер таңдалды","slotEditor_emptyState_multiple_visualizations_selected_description":"Өрістердің параметрлерін басқару үшін көрнекілендіру тандаңыз.","slotEditor_emptyState_visualization_has_error_title":"Көрнекілендіруді көрсету мүмкін емес","slotEditor_slotItem_tooltip":"Бастапқы:","slotEditor_emptyState_vis_not_created_title":"Жасалған көрнекілендіру жоқ","slotEditor_emptyState_vis_not_created_description":"Өрістердің параметрлерін басқару үшін көрнекілендіру жасаңыз.","slotEditor":"Өрістер","slotEditorCoachMarkTitle":"Кіру өрістері","slotEditorCoachMarkContents":"Көрнекілендіру бейнелерді құру және өзгерту үшін өрістерге баған қосыңыз.","toolbarDeleteFilterActionText":"Сүзгіш жою","toolbarActionFilter":"Сүзгі","filterAutobinActionText":"Bin -дерді сүзгілеу","coachMarkTitleSpiralTarget":"Ауқымды өңдеу","coachMarkContentSpiralTarget":"Мұнда мақсатыңызға арналған драйвер таңдауына кіруге және оны өзгертуге болады.","overlayDropZonePlaceHolderText":"Деректерді осы жерге апарыңыз"},"__ko":{"localFilters":"로컬 필터","slotEditorMsg1":"필수 필드","slotEditorMsg2":"시각화를 빌드하고 필터링하려면 위의 필드에 데이터를 끌어서 놓으십시오.","missingColumn":"누락: %{columnLabel}","placeholderDropzone":"데이터 클릭 또는 여기로 끌기","slotEditor_emptyState_no_visualization_selected_title":"선택된 시각화 없음","slotEditor_emptyState_no_visualization_selected_description":"필드 설정을 관리하려면 시각화를 선택하십시오.","slotEditor_emptyState_widget_not_support_slot_selected_title":"선택한 위젯에서 필드를 사용하지 않음","slotEditor_emptyState_widget_not_support_slot_selected_description":"필드 설정을 관리하려면 시각화를 선택하십시오.","slotEditor_emptyState_multiple_visualizations_selected_title":"여러 위젯이 선택됨","slotEditor_emptyState_multiple_visualizations_selected_description":"필드 설정을 관리하려면 시각화를 선택하십시오.","slotEditor_emptyState_visualization_has_error_title":"시각화를 표시할 수 없음","slotEditor_slotItem_tooltip":"소스:","slotEditor_emptyState_vis_not_created_title":"작성된 시각화 없음","slotEditor_emptyState_vis_not_created_description":"필드 설정을 관리하려면 시각화를 작성하십시오.","slotEditor":"필드","slotEditorCoachMarkTitle":"액세스 필드","slotEditorCoachMarkContents":"시각화를 빌드하고 수정하려면 필드에 열을 추가하십시오.","toolbarDeleteFilterActionText":"필터 제거","toolbarActionFilter":"필터","filterAutobinActionText":"구간 필터","coachMarkTitleSpiralTarget":"범위 편집","coachMarkContentSpiralTarget":"대상에 대한 드라이버 선택에 액세스하고 수정할 수 있는 위치입니다.","overlayDropZonePlaceHolderText":"데이터 여기에 놓기"},"__nb":{"localFilters":"Lokale filtre","slotEditorMsg1":"Obligatorisk felt","slotEditorMsg2":"Dra og slipp data i feltene ovenfor for å bygge og filtrere visualiseringen.","missingColumn":"Mangler: %{columnLabel}","placeholderDropzone":"Klikk eller dra data hit","slotEditor_emptyState_no_visualization_selected_title":"Ingen visualisering valgt","slotEditor_emptyState_no_visualization_selected_description":"Velg en visualisering for å administrere innstillingene for felt.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Den valgte widgeten bruker ikke felt","slotEditor_emptyState_widget_not_support_slot_selected_description":"Velg en visualisering for å administrere innstillingene for felt.","slotEditor_emptyState_multiple_visualizations_selected_title":"Flere widgeter valgt","slotEditor_emptyState_multiple_visualizations_selected_description":"Velg en visualisering for å administrere innstillingene for felt.","slotEditor_emptyState_visualization_has_error_title":"Visualiseringen kan ikke vises","slotEditor_slotItem_tooltip":"Kilde:","slotEditor_emptyState_vis_not_created_title":"Ingen visualisering opprettet","slotEditor_emptyState_vis_not_created_description":"Opprett en visualisering for å administrere innstillingene for felt.","slotEditor":"Felt","slotEditorCoachMarkTitle":"Tilgang til felt","slotEditorCoachMarkContents":"Legg til kolonner i feltene for å bygge og endre visualiseringer.","toolbarDeleteFilterActionText":"Fjern filter","toolbarActionFilter":"Filtrer","filterAutobinActionText":"Filtrer binger","coachMarkTitleSpiralTarget":"Rediger omfang","coachMarkContentSpiralTarget":"Her får du tilgang til og kan endre drivervalget for målet ditt.","overlayDropZonePlaceHolderText":"Dra data hit"},"__nl":{"localFilters":"Lokale filters","slotEditorMsg1":"Verplicht veld","slotEditorMsg2":"Versleep de gegevens naar de bovenstaande velden om de visualisatie samen te stellen en te filteren.","missingColumn":"%{columnLabel} ontbreekt","placeholderDropzone":"Klik hier of versleep gegevens hiernaartoe","slotEditor_emptyState_no_visualization_selected_title":"Geen visualisatie geselecteerd","slotEditor_emptyState_no_visualization_selected_description":"Selecteer een visualisatie om de instellingen van het veld te beheren.","slotEditor_emptyState_widget_not_support_slot_selected_title":"De geselecteerde widget gebruikt geen velden","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selecteer een visualisatie om de instellingen van het veld te beheren.","slotEditor_emptyState_multiple_visualizations_selected_title":"Meerdere widgets geselecteerd","slotEditor_emptyState_multiple_visualizations_selected_description":"Selecteer een visualisatie om de instellingen van het veld te beheren.","slotEditor_emptyState_visualization_has_error_title":"De visualisatie kan niet worden afgebeeld","slotEditor_slotItem_tooltip":"Bron:","slotEditor_emptyState_vis_not_created_title":"Geen visualisatie gemaakt","slotEditor_emptyState_vis_not_created_description":"Maak een visualisatie om de instellingen van het veld te beheren.","slotEditor":"Velden","slotEditorCoachMarkTitle":"Velden benaderen","slotEditorCoachMarkContents":"Voeg kolommen toe aan de velden om visualisaties te bouwen en te wijzigen.","toolbarDeleteFilterActionText":"Filter verwijderen","toolbarActionFilter":"Filteren","filterAutobinActionText":"Bins filteren","coachMarkTitleSpiralTarget":"Bereik bewerken","coachMarkContentSpiralTarget":"Dit is de plek waar u toegang hebt tot de driverselectie voor uw doel en waar u wijzigingen kunt aanbrengen.","overlayDropZonePlaceHolderText":"Sleep gegevens hier naartoe"},"__no":{"localFilters":"Lokale filtre","slotEditorMsg1":"Obligatorisk felt","slotEditorMsg2":"Dra og slipp data i feltene ovenfor for å bygge og filtrere visualiseringen.","missingColumn":"Mangler: %{columnLabel}","placeholderDropzone":"Klikk eller dra data hit","slotEditor_emptyState_no_visualization_selected_title":"Ingen visualisering valgt","slotEditor_emptyState_no_visualization_selected_description":"Velg en visualisering for å administrere innstillingene for felt.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Den valgte widgeten bruker ikke felt","slotEditor_emptyState_widget_not_support_slot_selected_description":"Velg en visualisering for å administrere innstillingene for felt.","slotEditor_emptyState_multiple_visualizations_selected_title":"Flere widgeter valgt","slotEditor_emptyState_multiple_visualizations_selected_description":"Velg en visualisering for å administrere innstillingene for felt.","slotEditor_emptyState_visualization_has_error_title":"Visualiseringen kan ikke vises","slotEditor_slotItem_tooltip":"Kilde:","slotEditor_emptyState_vis_not_created_title":"Ingen visualisering opprettet","slotEditor_emptyState_vis_not_created_description":"Opprett en visualisering for å administrere innstillingene for felt.","slotEditor":"Felt","slotEditorCoachMarkTitle":"Tilgang til felt","slotEditorCoachMarkContents":"Legg til kolonner i feltene for å bygge og endre visualiseringer.","toolbarDeleteFilterActionText":"Fjern filter","toolbarActionFilter":"Filtrer","filterAutobinActionText":"Filtrer binger","coachMarkTitleSpiralTarget":"Rediger omfang","coachMarkContentSpiralTarget":"Her får du tilgang til og kan endre drivervalget for målet ditt.","overlayDropZonePlaceHolderText":"Dra data hit"},"__pl":{"localFilters":"Filtry lokalne","slotEditorMsg1":"Pole wymagane","slotEditorMsg2":"Przeciągnij i upuść dane w powyższych szczelinach, aby utworzyć i przefiltrować wizualizację.","missingColumn":"Brak: %{columnLabel}","placeholderDropzone":"Kliknij lub przeciągnij dane w to miejsce","slotEditor_emptyState_no_visualization_selected_title":"Nie wybrano wizualizacji","slotEditor_emptyState_no_visualization_selected_description":"Wybierz wizualizację, aby zarządzać ustawieniami pól.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Wybrany widget nie korzysta ze pól","slotEditor_emptyState_widget_not_support_slot_selected_description":"Wybierz wizualizację, aby zarządzać ustawieniami pól.","slotEditor_emptyState_multiple_visualizations_selected_title":"Wybrano więcej niż jeden widget","slotEditor_emptyState_multiple_visualizations_selected_description":"Wybierz wizualizację, aby zarządzać ustawieniami pól.","slotEditor_emptyState_visualization_has_error_title":"Nie można wyświetlić wizualizacji","slotEditor_slotItem_tooltip":"Źródło:","slotEditor_emptyState_vis_not_created_title":"Nie utworzono żadnej wizualizacji","slotEditor_emptyState_vis_not_created_description":"Utwórz wizualizację, aby zarządzać ustawieniami pól.","slotEditor":"Pola","slotEditorCoachMarkTitle":"Uzyskaj dostęp do pól","slotEditorCoachMarkContents":"Dodawaj kolumny do pól, aby budować i modyfikować wizualizacje.","toolbarDeleteFilterActionText":"Usuń filtr","toolbarActionFilter":"Filtr","filterAutobinActionText":"Filtruj kategorie","coachMarkTitleSpiralTarget":"Edytuj zakres","coachMarkContentSpiralTarget":"W tym miejscu można uzyskać dostęp do czynników dla zmiennej przewidywanej i zmodyfikować ich wybór.","overlayDropZonePlaceHolderText":"Przeciągnij tutaj dane"},"__pt":{"localFilters":"Filtros locais","slotEditorMsg1":"Campo requerido","slotEditorMsg2":"Arraste e solte dados para os campos acima para criar e filtrar a visualização.","missingColumn":"Ausente: %{columnLabel}","placeholderDropzone":"Clicar ou arrastar dados aqui","slotEditor_emptyState_no_visualization_selected_title":"Nenhuma visualização selecionada","slotEditor_emptyState_no_visualization_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_widget_not_support_slot_selected_title":"O widget selecionado não usa campos","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_multiple_visualizations_selected_title":"Vários widgets selecionados","slotEditor_emptyState_multiple_visualizations_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_visualization_has_error_title":"Não é possível exibir a visualização","slotEditor_slotItem_tooltip":"Origem:","slotEditor_emptyState_vis_not_created_title":"Nenhuma visualização criada","slotEditor_emptyState_vis_not_created_description":"Crie uma visualização para gerenciar as configurações de campo.","slotEditor":"Campos","slotEditorCoachMarkTitle":"Campos de acesso","slotEditorCoachMarkContents":"Inclua colunas nos campos para criar e modificar visualizações.","toolbarDeleteFilterActionText":"Remover filtro","toolbarActionFilter":"Filtrar","filterAutobinActionText":"Filtro de categorias","coachMarkTitleSpiralTarget":"Editar escopo","coachMarkContentSpiralTarget":"Este é o local onde é possível acessar e modificar a seleção do driver para seu destino.","overlayDropZonePlaceHolderText":"Arraste os dados para cá"},"__pt-br":{"localFilters":"Filtros locais","slotEditorMsg1":"Campo requerido","slotEditorMsg2":"Arraste e solte dados para os campos acima para criar e filtrar a visualização.","missingColumn":"Ausente: %{columnLabel}","placeholderDropzone":"Clicar ou arrastar dados aqui","slotEditor_emptyState_no_visualization_selected_title":"Nenhuma visualização selecionada","slotEditor_emptyState_no_visualization_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_widget_not_support_slot_selected_title":"O widget selecionado não usa campos","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_multiple_visualizations_selected_title":"Vários widgets selecionados","slotEditor_emptyState_multiple_visualizations_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_visualization_has_error_title":"Não é possível exibir a visualização","slotEditor_slotItem_tooltip":"Origem:","slotEditor_emptyState_vis_not_created_title":"Nenhuma visualização criada","slotEditor_emptyState_vis_not_created_description":"Crie uma visualização para gerenciar as configurações de campo.","slotEditor":"Campos","slotEditorCoachMarkTitle":"Campos de acesso","slotEditorCoachMarkContents":"Inclua colunas nos campos para criar e modificar visualizações.","toolbarDeleteFilterActionText":"Remover filtro","toolbarActionFilter":"Filtrar","filterAutobinActionText":"Filtro de categorias","coachMarkTitleSpiralTarget":"Editar escopo","coachMarkContentSpiralTarget":"Este é o local onde é possível acessar e modificar a seleção do driver para seu destino.","overlayDropZonePlaceHolderText":"Arraste os dados para cá"},"__ro":{"localFilters":"Filtre locale","slotEditorMsg1":"Câmp necesar","slotEditorMsg2":"Trageţi şi plasaţi datele în câmpurile de deasupra, pentru a construi şi filtra vizualizarea.","missingColumn":"Lipsă: %{columnLabel}","placeholderDropzone":"Faceţi clic sau trageţi date aici ","slotEditor_emptyState_no_visualization_selected_title":"Nicio vizualizare selectată","slotEditor_emptyState_no_visualization_selected_description":"Selectaţi o vizualizare pentru gestionarea setărilor de câmp.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Widget-ul selectat nu utilizează câmpuri.","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selectaţi o vizualizare pentru gestionarea setărilor de câmp.","slotEditor_emptyState_multiple_visualizations_selected_title":"Sunt selectate mai multe widget-uri","slotEditor_emptyState_multiple_visualizations_selected_description":"Selectaţi o vizualizare pentru gestionarea setărilor de câmp.","slotEditor_emptyState_visualization_has_error_title":"Vizualizarea nu poate fi afişată.","slotEditor_slotItem_tooltip":"Sursă:","slotEditor_emptyState_vis_not_created_title":"Nu a fost creată nicio vizualizare","slotEditor_emptyState_vis_not_created_description":"Creaţi o vizualizare pentru gestionarea setărilor de câmp.","slotEditor":"Câmpuri","slotEditorCoachMarkTitle":"Accesare câmpuri","slotEditorCoachMarkContents":"Adăugaţi coloane la câmpuri pentru a construi şi modifica vizualizările.","toolbarDeleteFilterActionText":"Înlăturare filtru","toolbarActionFilter":"Filtru","filterAutobinActionText":"Filtrare bin-uri","coachMarkTitleSpiralTarget":"Editare domeniu","coachMarkContentSpiralTarget":"Aici puteţi accesa şi modifica selecţia de driver-e pentru ţinta dumneavoastră.","overlayDropZonePlaceHolderText":"Trageţi date aici"},"__ru":{"localFilters":"Локальные фильтры","slotEditorMsg1":"Обязательное поле","slotEditorMsg2":"Перетащите данные на находящиеся выше поля, чтобы построить визуализацию и применить к ней фильтр.","missingColumn":"Отсутствует: %{columnLabel}","placeholderDropzone":"Щелкните здесь или перетащите сюда данные","slotEditor_emptyState_no_visualization_selected_title":"Визуализация не отобрана","slotEditor_emptyState_no_visualization_selected_description":"Выберите визуализацию для управления настройками полей.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Выбранный виджет не использует поля","slotEditor_emptyState_widget_not_support_slot_selected_description":"Выберите визуализацию для управления настройками полей.","slotEditor_emptyState_multiple_visualizations_selected_title":"Выбрано несколько виджетов","slotEditor_emptyState_multiple_visualizations_selected_description":"Выберите визуализацию для управления настройками полей.","slotEditor_emptyState_visualization_has_error_title":"Вывести визуализацию невозможно","slotEditor_slotItem_tooltip":"Источник:","slotEditor_emptyState_vis_not_created_title":"Визуализация не создана","slotEditor_emptyState_vis_not_created_description":"Создайте визуализацию для управления настройками полей.","slotEditor":"Поля","slotEditorCoachMarkTitle":"Доступ к полям","slotEditorCoachMarkContents":"Добавьте в поля столбцы для построения и изменения визуализаций.","toolbarDeleteFilterActionText":"Удалить фильтр","toolbarActionFilter":"Фильтр","filterAutobinActionText":"Применить фильтр к контейнерам","coachMarkTitleSpiralTarget":"Изменить область","coachMarkContentSpiralTarget":"Здесь можно получить доступ и изменить выбор драйвера для целевого объекта.","overlayDropZonePlaceHolderText":"Перетащите сюда данные"},"__sl":{"localFilters":"Lokalni filtri","slotEditorMsg1":"Obvezno polje","slotEditorMsg2":"Povlecite in spustite podatke v polja zgoraj, da zgradite in filtrirate vizualizacijo.","missingColumn":"Manjkajoče: %{columnLabel}","placeholderDropzone":"Kliknite ali povlecite podatke sem","slotEditor_emptyState_no_visualization_selected_title":"Izbrana ni nobena vizualizacija","slotEditor_emptyState_no_visualization_selected_description":"Izberite vizualizacijo za upravljanje nastavitev polja.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Izbrani gradnik ne uporablja polj","slotEditor_emptyState_widget_not_support_slot_selected_description":"Izberite vizualizacijo za upravljanje nastavitev polja.","slotEditor_emptyState_multiple_visualizations_selected_title":"Izbranih je več gradnikov","slotEditor_emptyState_multiple_visualizations_selected_description":"Izberite vizualizacijo za upravljanje nastavitev polja.","slotEditor_emptyState_visualization_has_error_title":"Vizualizacije ni mogoče prikazati","slotEditor_slotItem_tooltip":"Izvor:","slotEditor_emptyState_vis_not_created_title":"Ustvarjena ni bila nobena vizualizacija","slotEditor_emptyState_vis_not_created_description":"Ustvarite vizualizacijo za upravljanje nastavitev polja.","slotEditor":"Polja","slotEditorCoachMarkTitle":"Polja za dostop","slotEditorCoachMarkContents":"V polja dodajte stolpce, da boste lahko gradili in spreminjali vizualizacije.","toolbarDeleteFilterActionText":"Odstrani filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Predali filtra","coachMarkTitleSpiralTarget":"Urejanje območja","coachMarkContentSpiralTarget":"Tukaj lahko dostopate do izbora gonilnikov za svoj cilj in jih spreminjate.","overlayDropZonePlaceHolderText":"Povlecite podatke sem"},"__sv":{"localFilters":"Lokala filter","slotEditorMsg1":"Obligatoriskt fält","slotEditorMsg2":"Dra data till fälten ovan för att skapa och filtrera visualiseringen.","missingColumn":"%{columnLabel} saknas","placeholderDropzone":"Klicka eller dra data hit","slotEditor_emptyState_no_visualization_selected_title":"Ingen visualisering vald","slotEditor_emptyState_no_visualization_selected_description":"Välj en visualisering för att hantera fältinställningarna.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Den valda widgeten använder inte fält","slotEditor_emptyState_widget_not_support_slot_selected_description":"Välj en visualisering för att hantera fältinställningarna.","slotEditor_emptyState_multiple_visualizations_selected_title":"Flera widgetar har valts","slotEditor_emptyState_multiple_visualizations_selected_description":"Välj en visualisering för att hantera fältinställningarna.","slotEditor_emptyState_visualization_has_error_title":"Det går inte att visa visualiseringen","slotEditor_slotItem_tooltip":"Källa:","slotEditor_emptyState_vis_not_created_title":"Inga visualiseringar har skapats","slotEditor_emptyState_vis_not_created_description":"Skapa en visualisering för att hantera fältinställningarna.","slotEditor":"Fält","slotEditorCoachMarkTitle":"Åtkomst till fält","slotEditorCoachMarkContents":"Lägg till kolumner i fälten för att skapa och ändra visualiseringar.","toolbarDeleteFilterActionText":"Ta bort filter","toolbarActionFilter":"Filtrera","filterAutobinActionText":"Filtrera bin","coachMarkTitleSpiralTarget":"Ändra omfattning","coachMarkContentSpiralTarget":"Här kan du komma åt och ändra valet av styrfunktioner för målet.","overlayDropZonePlaceHolderText":"Dra data hit"},"__th":{"localFilters":"ตัวกรองโลคัล","slotEditorMsg1":"ฟิลด์ที่จำเป็น","slotEditorMsg2":"ลากและปล่อยข้อมูลลงในฟิลด์ด้านบนเพื่อบิลด์และกรองวิชวลไลเซชัน","missingColumn":"ไม่มี: %{columnLabel}","placeholderDropzone":"คลิกหรือลากข้อมูลที่นี่","slotEditor_emptyState_no_visualization_selected_title":"ไม่ได้เลือกวิชวลไลเซชัน","slotEditor_emptyState_no_visualization_selected_description":"เลือกวิชวลไลเซชันที่จะจัดการการตั้งค่าฟิลด์","slotEditor_emptyState_widget_not_support_slot_selected_title":"วิดเจ็ตที่เลือกไม่ได้ใช้ฟิลด์","slotEditor_emptyState_widget_not_support_slot_selected_description":"เลือกวิชวลไลเซชันที่จะจัดการการตั้งค่าฟิลด์","slotEditor_emptyState_multiple_visualizations_selected_title":"เลือกหลายวิดเจ็ต","slotEditor_emptyState_multiple_visualizations_selected_description":"เลือกวิชวลไลเซชันที่จะจัดการการตั้งค่าฟิลด์","slotEditor_emptyState_visualization_has_error_title":"วิชวลไลเซชันไม่สามารถแสดงผลได้","slotEditor_slotItem_tooltip":"ซอร์ส:","slotEditor_emptyState_vis_not_created_title":"ไม่มีการสร้างวิชวลไลเซชัน","slotEditor_emptyState_vis_not_created_description":"สร้างวิชวลไลเซชันที่จะจัดการการตั้งค่าฟิลด์","slotEditor":"ฟิลด์","slotEditorCoachMarkTitle":"เข้าถึงฟิลด์","slotEditorCoachMarkContents":"เพิ่มคอลัมน์ลงในฟิลด์เพื่อบิลด์และปรับเปลี่ยนวิชวลไลเซชัน","toolbarDeleteFilterActionText":"ลบตัวกรอง","toolbarActionFilter":"ตัวกรอง","filterAutobinActionText":"ถังกรอง","coachMarkTitleSpiralTarget":"แก้ไขขอบเขต","coachMarkContentSpiralTarget":"นี่เป็นตำแหน่งที่คุณสามารถเข้าถึงและปรับเปลี่ยนการเลือกไดรเวอร์สำหรับเป้าหมายของคุณ","overlayDropZonePlaceHolderText":"ลากข้อมูลที่นี่"},"__tr":{"localFilters":"Yerel süzgeçler","slotEditorMsg1":"Zorunlu alan","slotEditorMsg2":"Görselleştirmeyi oluşturup süzgeçten geçirmek için verileri yukarıdaki alanlara sürükleyip bırakın.","missingColumn":"Eksik: %{columnLabel}","placeholderDropzone":"Tıklatın veya verileri buraya sürükleyin","slotEditor_emptyState_no_visualization_selected_title":"Bir görselleştirme seçilmedi","slotEditor_emptyState_no_visualization_selected_description":"Alan ayarlarını yönetmek için bir görselleştirme seçin.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Seçilen pencere öğesi alanları kullanmıyor","slotEditor_emptyState_widget_not_support_slot_selected_description":"Alan ayarlarını yönetmek için bir görselleştirme seçin.","slotEditor_emptyState_multiple_visualizations_selected_title":"Birden çok pencere öğesi seçildi","slotEditor_emptyState_multiple_visualizations_selected_description":"Alan ayarlarını yönetmek için bir görselleştirme seçin.","slotEditor_emptyState_visualization_has_error_title":"Görselleştirme görüntülenemiyor","slotEditor_slotItem_tooltip":"Kaynak:","slotEditor_emptyState_vis_not_created_title":"Bir görselleştirme oluşturulmadı","slotEditor_emptyState_vis_not_created_description":"Alan ayarlarını yönetmek için bir görselleştirme oluşturun.","slotEditor":"Alanlar","slotEditorCoachMarkTitle":"Erişim alanları","slotEditorCoachMarkContents":"Görselleştirmeleri oluşturmak ve değiştirmek için alanlara sütun ekleyin.","toolbarDeleteFilterActionText":"Süzgeci kaldır","toolbarActionFilter":"Süzgeç","filterAutobinActionText":"Süzgeç bölmeleri","coachMarkTitleSpiralTarget":"Kapsamı düzenle","coachMarkContentSpiralTarget":"Burası, hedefiniz için sürücü seçimine erişebileceğiniz ve sürücü seçimini değiştirebileceğiniz yerdir.","overlayDropZonePlaceHolderText":"Verileri buraya sürükleyin"},"__zh":{"localFilters":"本地过滤器","slotEditorMsg1":"必填字段","slotEditorMsg2":"将数据拖放到字段上方可构建并过滤可视化。","missingColumn":"缺少：%{columnLabel}","placeholderDropzone":"单击数据或将数据拖到此处","slotEditor_emptyState_no_visualization_selected_title":"未选择任何可视化","slotEditor_emptyState_no_visualization_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_widget_not_support_slot_selected_title":"所选窗口小部件不使用字段","slotEditor_emptyState_widget_not_support_slot_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_multiple_visualizations_selected_title":"已选择多个窗口小部件","slotEditor_emptyState_multiple_visualizations_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_visualization_has_error_title":"无法显示可视化","slotEditor_slotItem_tooltip":"源：","slotEditor_emptyState_vis_not_created_title":"未创建任何可视化","slotEditor_emptyState_vis_not_created_description":"创建可视化以管理字段设置。","slotEditor":"字段","slotEditorCoachMarkTitle":"访问字段","slotEditorCoachMarkContents":"向字段添加列以构建并修改可视化。","toolbarDeleteFilterActionText":"除去过滤器","toolbarActionFilter":"过滤器","filterAutobinActionText":"过滤分箱","coachMarkTitleSpiralTarget":"编辑作用域","coachMarkContentSpiralTarget":"您可以在此访问和修改目标的动因选择。","overlayDropZonePlaceHolderText":"将数据拖到此处"},"__zh-cn":{"localFilters":"本地过滤器","slotEditorMsg1":"必填字段","slotEditorMsg2":"将数据拖放到字段上方可构建并过滤可视化。","missingColumn":"缺少：%{columnLabel}","placeholderDropzone":"单击数据或将数据拖到此处","slotEditor_emptyState_no_visualization_selected_title":"未选择任何可视化","slotEditor_emptyState_no_visualization_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_widget_not_support_slot_selected_title":"所选窗口小部件不使用字段","slotEditor_emptyState_widget_not_support_slot_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_multiple_visualizations_selected_title":"已选择多个窗口小部件","slotEditor_emptyState_multiple_visualizations_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_visualization_has_error_title":"无法显示可视化","slotEditor_slotItem_tooltip":"源：","slotEditor_emptyState_vis_not_created_title":"未创建任何可视化","slotEditor_emptyState_vis_not_created_description":"创建可视化以管理字段设置。","slotEditor":"字段","slotEditorCoachMarkTitle":"访问字段","slotEditorCoachMarkContents":"向字段添加列以构建并修改可视化。","toolbarDeleteFilterActionText":"除去过滤器","toolbarActionFilter":"过滤器","filterAutobinActionText":"过滤分箱","coachMarkTitleSpiralTarget":"编辑作用域","coachMarkContentSpiralTarget":"您可以在此访问和修改目标的动因选择。","overlayDropZonePlaceHolderText":"将数据拖到此处"},"__zh-tw":{"localFilters":"本端過濾器","slotEditorMsg1":"必要欄位","slotEditorMsg2":"將資料拖放至上方的欄位來建置及過濾視覺化。","missingColumn":"遺漏：%{columnLabel}","placeholderDropzone":"在這裡按一下或拖曳資料","slotEditor_emptyState_no_visualization_selected_title":"未選取任何視覺化","slotEditor_emptyState_no_visualization_selected_description":"選取視覺化以管理欄位設定。","slotEditor_emptyState_widget_not_support_slot_selected_title":"選取的小組件沒有使用欄位。","slotEditor_emptyState_widget_not_support_slot_selected_description":"選取視覺化以管理欄位設定。","slotEditor_emptyState_multiple_visualizations_selected_title":"已選取多個小組件","slotEditor_emptyState_multiple_visualizations_selected_description":"選取視覺化以管理欄位設定。","slotEditor_emptyState_visualization_has_error_title":"無法顯示視覺化。","slotEditor_slotItem_tooltip":"來源：","slotEditor_emptyState_vis_not_created_title":"未建立任何視覺化","slotEditor_emptyState_vis_not_created_description":"建立視覺化以管理欄位設定。","slotEditor":"欄位","slotEditorCoachMarkTitle":"存取欄位","slotEditorCoachMarkContents":"將直條圖新增至欄位以建置和修改視覺化。","toolbarDeleteFilterActionText":"移除過濾器","toolbarActionFilter":"過濾","filterAutobinActionText":"過濾組","coachMarkTitleSpiralTarget":"編輯範圍","coachMarkContentSpiralTarget":"您可以在此處存取及修改目標動因選項。","overlayDropZonePlaceHolderText":"將資料拖曳至此"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_16__;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(46);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./slotEditor.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./slotEditor.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(79);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/index.js??ref--2-2!../../../node_modules/resolve-url-loader/index.js!../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./slotEditor.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/index.js??ref--2-2!../../../node_modules/resolve-url-loader/index.js!../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./slotEditor.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SLOT_ITEM_TOUCH_DRAG_DURATION = 600;

var DndSlotItemHandler = function () {
	/**
  * DndSlotItemHandler hides most of the drag and drop handling used by the glass DndManager
  * It handles drop of data from the metadata tree to a Slot Item (or Slot Heading)
  * It also handles Drag&Drop of slot to slot data.
  *
  * @param {Object} 	options
  * @param {DOMNode} options.domNode - DOM node to attach drag and drop to
  * @param {string} 	options.className - class name
  * @param {Function} options.slotDataItemHandler - the slotDataItemHandler.
  * @param {Boolean}	options.addAfter - true if this drop is after a slot
  * @param {Object} 	options.dndManager - the drag&drop manager.
  * @param {Function} [options.onDragEnter] - oprional function to be executed in addition to activateDropTarget when entering this target
  * @param {Function} [options.onDragLeave] - oprional function to be executed in addition to activateDropTarget when exiting this target
  * @param {Boolean} [options.isVisOverlay] - if set, this target is a visOverlay....rules are determined in VisDnDManager.
  */
	function DndSlotItemHandler(options) {
		_classCallCheck(this, DndSlotItemHandler);

		this.domNode = options.domNode;
		this.className = options.className;

		this.slotDataItemHandler = options.slotDataItemHandler;

		this.addAfter = options.addAfter;
		this.dndManager = options.dndManager;
		this.onDragEnter = options.onDragEnter; //custom drag enter handling (in addition to activateDropTarget)
		this.onDragLeave = options.onDragLeave; //custom drag enter handling (in addition to deactivateDropTarget)
		this.isVisOverlay = options.isVisOverlay;
		this.timer = null;

		// Register slot as a drop target
		if (this.dndManager) {
			this._setupDnD();
		}
	}

	_createClass(DndSlotItemHandler, [{
		key: '_setupDnD',
		value: function _setupDnD() {
			var _this = this;

			var onDrop = this.slotDataItemHandler && this.slotDataItemHandler.onDrop && this.slotDataItemHandler.onDrop.bind(this.slotDataItemHandler);

			//NOTE: registering a new dropTarget on a node derigisters the old one.
			this.dndManager.registerDropTarget({
				el: this.domNode,
				type: 'slot.item',
				info: function info(domNode, event) {
					return {
						//position info
						dragInfo: {
							position: {
								x: event.clientX,
								y: event.clientY
							}
						},
						node: domNode,

						//drag&drop handlers
						onDragEnter: _this.activateDropTarget.bind(_this),
						onDragLeave: _this.deactivateDropTarget.bind(_this),
						onDrop: onDrop,

						//slot data variables.
						contentId: _this.slotDataItemHandler.getContentId(),
						slot: _this.slotDataItemHandler.getSlotAPI(),
						indexInSlot: _this.slotDataItemHandler.indexInSlot,
						addAfter: _this.addAfter,
						isVisOverlay: _this.isVisOverlay
					};
				}
			});
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			this.dndManager.deregisterDropTarget(this.domNode);
		}
	}, {
		key: 'updateDropTarget',
		value: function updateDropTarget(slotDataItemHandler) {
			if (this.dndManager) {
				this.slotDataItemHandler = slotDataItemHandler;
				this._setupDnD();
			}
		}
	}, {
		key: 'activateDropTarget',
		value: function activateDropTarget() {
			(0, _jquery2.default)(this.domNode).toggleClass(this.className, true);
			if (this.onDragEnter) {
				this.onDragEnter();
			}
		}
	}, {
		key: 'deactivateDropTarget',
		value: function deactivateDropTarget() {
			(0, _jquery2.default)(this.domNode).toggleClass(this.className, false);
			if (this.onDragLeave) {
				this.onDragLeave();
			}
		}
	}, {
		key: 'onDragMove',
		value: function onDragMove(dragObject, dropNode, event) {
			var _this2 = this;

			var slotEditorNode = (0, _jquery2.default)(dropNode).closest('.slotEditor').get(0);
			if (slotEditorNode) {
				(0, _utils.handleScroll)(event, slotEditorNode, function () {
					return _this2.dndManager && _this2.dndManager.reassessContainer(slotEditorNode);
				});
			}
			this.activateDropTarget();
		}

		/**
   * @param dndManager - the dndManager to initialize the drag within
   * @param cbGetSlotDataItemHandler - a callback function which should be called when starting any drag to get the up-to-date item data handler.
   */

	}, {
		key: 'initializeDndSource',
		value: function initializeDndSource(dndManager, cbGetSlotDataItemHandler, iconsFeature, startDragCallBack) {
			var _this3 = this;

			// Separate mouse and touch event handlers for defect 241719
			(0, _jquery2.default)(this.domNode).on('mousedown', {}, function (event) {
				if (startDragCallBack) {
					startDragCallBack();
				}
				_this3._startDrag({
					dndManager: dndManager,
					event: event,
					cbGetSlotDataItemHandler: cbGetSlotDataItemHandler,
					iconsFeature: iconsFeature
				});
				return true;
			});

			(0, _jquery2.default)(this.domNode).on('touchstart', {}, function (event) {
				if (startDragCallBack) {
					startDragCallBack();
				}
				_this3._touchStart({
					dndManager: dndManager,
					event: event,
					cbGetSlotDataItemHandler: cbGetSlotDataItemHandler,
					iconsFeature: iconsFeature
				});
				return true;
			});

			(0, _jquery2.default)(this.domNode).on('touchend touchcancel', {}, function () {
				return _this3._touchEnd();
			});
		}

		// defect 241719
		// after touchstart, wait short time to start drag process if still touch,
		// so that it can reduce change of ambiguous event with scrolling of the slot editor

	}, {
		key: '_touchStart',
		value: function _touchStart(options) {
			this.timer = setTimeout(function () {
				this._touchStartDrag(options);
			}.bind(this), SLOT_ITEM_TOUCH_DRAG_DURATION);
		}
	}, {
		key: '_touchEnd',
		value: function _touchEnd() {
			if (this.timer) {
				clearTimeout(this.timer);
			}
			this.timer = null;
		}
	}, {
		key: '_touchStartDrag',
		value: function _touchStartDrag(options) {
			if (this.timer) {
				this._startDrag(options);
			}
		}
	}, {
		key: '_startDrag',
		value: function _startDrag(options) {
			var $avatar = (0, _jquery2.default)('<div style="position:absolute; z-index:10000;"/>');

			var $draggedNode = (0, _jquery2.default)(this.domNode).clone().addClass('draggedNode');

			var _domNode$getBoundingC = this.domNode.getBoundingClientRect(),
			    width = _domNode$getBoundingC.width;

			$draggedNode.css({
				width: width,
				cursor: 'default'
			});
			if (options.iconsFeature) {
				var disableIcon = options.iconsFeature.getIcon('common-nodrop');
				if (disableIcon) {
					var $nodropSign = (0, _jquery2.default)('<div class="nodrop is-hidden">\n\t\t\t\t\t\t<svg class="svgIcon">\n\t\t\t\t\t\t\t<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#' + disableIcon.id + '">\n\t\t\t\t\t\t\t</use>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t</div>');
					$draggedNode.find('.bi-common-field-item__nameLine__draggable').remove();
					$draggedNode.find('.bi-common-field-item__nameLine').prepend($nodropSign);
				}
			}
			$avatar.append($draggedNode);

			var sourceSlotDataItemHandler = options.cbGetSlotDataItemHandler();
			options.dndManager.startDrag({
				event: options.event,
				type: 'SLOT_ITEM',
				data: {
					source: {
						slot: sourceSlotDataItemHandler.getSlotAPI(),
						indexInSlot: sourceSlotDataItemHandler.indexInSlot
					}
				},
				callerCallbacks: {
					onMove: this._onMove.bind(this)
				},
				avatar: $avatar,
				moveXThreshold: 20,
				moveYThreshold: 20
			});
		}
	}, {
		key: '_onMove',
		value: function _onMove(event) {
			var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var dragObject = payload.dragObject;

			if (dragObject) {
				var avatar = dragObject.avatar;

				if (avatar) {
					var $avatar = (0, _jquery2.default)(avatar);
					var $nodrop = $avatar.find('.nodrop');
					if ($nodrop.length) {
						var dropTargetNode = payload.dropTargetNode;

						if (!dropTargetNode) {
							// no payload.dropTargetNode means currenly you cannot drop here, so we show `not allowed drop sign`
							$nodrop.toggleClass('is-hidden', false);
						} else {
							// else payload.dropTargetNode exists,
							// if the drop target is not `.slotEditor` (which is used for drag auto scroll ),
							// then means currenly you can REALLY drop the slot item here, so we does not show `not allowed drop sign`
							var isDropTargetNotSlotEditor = !(dropTargetNode.classList && dropTargetNode.classList.contains('slotEditor'));
							$nodrop.toggleClass('is-hidden', isDropTargetNotSlotEditor);
						}
					}
				}
			}
		}
	}]);

	return DndSlotItemHandler;
}();

exports.default = DndSlotItemHandler;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2020, 2021
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _caUiToolkit = __webpack_require__(3);

var _mobxReact = __webpack_require__(12);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _debounce = __webpack_require__(48);

var _debounce2 = _interopRequireDefault(_debounce);

__webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BASE_CLASS_NAME = 'dropdownWrapper';
var BLUR_TIME = 350;

var FieldDropdown = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(FieldDropdown, _Component);

	function FieldDropdown(props) {
		_classCallCheck(this, FieldDropdown);

		var _this = _possibleConstructorReturn(this, (FieldDropdown.__proto__ || Object.getPrototypeOf(FieldDropdown)).call(this, props));

		_this.scrollToDropdown = function () {
			if (_this.dropdownRef.current) {
				var differenceRect = _this.dropdownRef.current.getBoundingClientRect().bottom - window.innerHeight;
				if (differenceRect > 300) {
					var slotEditorNode = _this.dropdownRef.current.closest('.slotEditor');
					slotEditorNode.scrollTop = differenceRect;
				}
			}
		};

		_this.onChange = function (value) {
			_this.setState({
				userTextInput: value
			});
		};

		_this.handleEscapeDropdown = function (event) {
			if (event.key === 'Escape') {
				_this.props.onBlur();
			}
		};

		_this.handleKeyDown = function (event) {
			if (event.key === 'ArrowDown') {
				var currentDropNode = _this.dropdownRef.current;
				var muiList = (0, _jquery2.default)(currentDropNode).find('div.ba-common-list')[0];
				if (muiList) {
					event.preventDefault();
					muiList.focus();
				}
			} else if (event.key === 'Enter' && _this.state.userTextInput === '') {
				event.preventDefault();
				/* when replaceSlotItem = true, we want to modify slot item,
     * in this case delete when nothing is selected,
     * otherwise close the dropdown */
				if (_this.props.replaceSlotItem) {
					_this.props.a11Y.deleteSlotItem(_this.props.slotDataItemHandler);
				} else {
					_this.props.onBlur();
				}
			}
		};

		_this.onBlur = function () {
			_this.blurTimer = setTimeout(_this.props.onBlur, BLUR_TIME);
		};

		_this.onFocus = function () {
			if (_this.blurTimer) {
				clearTimeout(_this.blurTimer);
				_this.blurTimer = null;
			}
		};

		_this.state = {
			userTextInput: _this.props.textValue
		};
		_this.dropdownRef = _react2.default.createRef();
		return _this;
	}

	_createClass(FieldDropdown, [{
		key: 'render',
		value: function render() {
			var dropdownStyle = {
				'max-height': this.props.getDropdownMaxHeight() > 0 ? this.props.getDropdownMaxHeight() + 'px' : 'none'
			};
			var dropdownContent = _react2.default.createElement(
				'div',
				{
					className: 'ba-common-dropdown dropdown',
					ref: this.dropdownRef,
					style: dropdownStyle
				},
				_react2.default.createElement(
					_caUiToolkit.Collapse,
					{
						isOpened: this.props.open,
						autoUnmount: true
						/* Has to use this prop to control if we want animation when dropdown content changes, check https://github.com/nkbt/react-collapse */
						, hasNestedCollapse: true,
						forceInitialAnimation: true,
						onRest: this.scrollToDropdown
					},
					this._renderMetadataTree()
				)
			);

			return _react2.default.createElement(
				'div',
				{
					className: BASE_CLASS_NAME,
					onBlur: this.onBlur,
					onFocus: this.onFocus,
					onKeyDown: this.handleEscapeDropdown
				},
				this._renderTextInput(),
				dropdownContent
			);
		}
	}, {
		key: '_renderTextInput',
		value: function _renderTextInput() {
			var DEBOUNCE_WAIT = 250; //ms
			var truncatedTextStyle = {
				width: '100%',
				height: 40
			};
			return _react2.default.createElement(_caUiToolkit.TextInput, {
				className: 'itemInput',
				noBottomBorder: true,
				value: this.state.userTextInput,
				autoFocus: true,
				onChange: (0, _debounce2.default)(this.onChange.bind(this), DEBOUNCE_WAIT),
				onKeyDown: (0, _debounce2.default)(this.handleKeyDown.bind(this), DEBOUNCE_WAIT),
				style: truncatedTextStyle
			});
		}

		/* setting timeout to prevent dropdown from closing
  when tabbing into it onBlur is called before onFocus*/

	}, {
		key: 'performSelection',
		value: function performSelection(selectedValue) {
			this.props.slotDataItemHandler.insertItemFromTypeInSlot(selectedValue, this.props.sourceId, { replaceSlotItem: this.props.replaceSlotItem, parentNode: this.props.parentNode });
			this.props.onItemSelected();
			this.props.onBlur();
		}
	}, {
		key: '_renderMetadataTree',
		value: function _renderMetadataTree() {
			var includeOptions = null;
			var context = this.props.slotDataItemHandler.getPickTreeContext && this.props.slotDataItemHandler.getPickTreeContext(this.props.replaceSlotItem);
			return this.props.dashboardApi.getFeature('DataSources.UI').getPickTree(this.props.sourceId, this.state.userTextInput, this.performSelection.bind(this), includeOptions, context);
		}
	}]);

	return FieldDropdown;
}(_react.Component)) || _class;

FieldDropdown.propTypes = {
	a11Y: _propTypes2.default.object,
	open: _propTypes2.default.bool.isRequired,
	textValue: _propTypes2.default.string,
	dashboardApi: _propTypes2.default.object.isRequired,
	getDropdownMaxHeight: _propTypes2.default.func.isRequired,
	sourceId: _propTypes2.default.string.isRequired,
	onBlur: _propTypes2.default.func.isRequired,
	replaceSlotItem: _propTypes2.default.bool.isRequired,
	parentNode: _propTypes2.default.object,
	slotDataItemHandler: _propTypes2.default.object.isRequired,
	onItemSelected: _propTypes2.default.func
};

FieldDropdown.defaultProps = {
	parentNode: {},
	textValue: '',
	a11Y: undefined,
	onItemSelected: function onItemSelected() {}
};

exports.default = FieldDropdown;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(50);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(25);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _caUiToolkit = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Watson Analytics (C) Copyright IBM Corp. 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * The SlotEditorItemFlyout component is responsible for the User Interface for a flyout of a single slot data item
 */
var SlotEditorItemFlyout = function (_Component) {
	_inherits(SlotEditorItemFlyout, _Component);

	function SlotEditorItemFlyout() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, SlotEditorItemFlyout);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SlotEditorItemFlyout.__proto__ || Object.getPrototypeOf(SlotEditorItemFlyout)).call.apply(_ref, [this].concat(args))), _this), _this._onCloseFlyout = function () {
			if (_this.props.onClose) {
				_this.props.onClose();
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(SlotEditorItemFlyout, [{
		key: 'render',
		value: function render() {
			var tooltipLabel = _StringResources2.default.get('slotEditor_slotItem_tooltip');
			var querySubjectItem = this._renderQuerySubjectItem();
			if (querySubjectItem) {
				return _react2.default.createElement(
					_caUiToolkit.Flyout,
					{
						domNodeToAttachTo: document.body,
						triggerNode: this.props.domNode,
						offset: 10,
						placement: 'topCentred',
						candidatePlacement: ['topCentred'],
						onClose: this._onCloseFlyout
					},
					_react2.default.createElement(
						'div',
						{ className: 'slotEditorItem__disambiguatingTooltipTitle' },
						tooltipLabel
					),
					_react2.default.createElement(
						'div',
						{ className: 'slotEditorItem__disambiguatingTooltip' },
						querySubjectItem
					)
				);
			}
			return null;
		}
	}, {
		key: '_renderQuerySubjectItem',
		value: function _renderQuerySubjectItem() {
			return this.props.dashboardApi.getFeature('DataSources.UI').getColumnSourceTree(this.props.sourceId, this.props.columnId);
		}
	}]);

	return SlotEditorItemFlyout;
}(_react.Component);

SlotEditorItemFlyout.propTypes = {
	domNode: _propTypes2.default.object.isRequired,
	dashboardApi: _propTypes2.default.object.isRequired,
	columnId: _propTypes2.default.string,
	sourceId: _propTypes2.default.string,
	onClose: _propTypes2.default.func
};

exports.default = SlotEditorItemFlyout;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _caUiToolkit = __webpack_require__(3);

var _FieldDropdown = __webpack_require__(23);

var _FieldDropdown2 = _interopRequireDefault(_FieldDropdown);

var _mobxReact = __webpack_require__(12);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(7);

__webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var MAX_HEIGHT = 500;

var SlotItemPlaceholder = function (_Component) {
	_inherits(SlotItemPlaceholder, _Component);

	function SlotItemPlaceholder(props) {
		_classCallCheck(this, SlotItemPlaceholder);

		var _this = _possibleConstructorReturn(this, (SlotItemPlaceholder.__proto__ || Object.getPrototypeOf(SlotItemPlaceholder)).call(this, props));

		_this._placeholderTypeInOn = function () {
			_this.setState({ isTypeInMode: true });
		};

		_this._placeholderTypeInOff = function () {
			_this.setState({ isTypeInMode: false });
		};

		_this._placeholderDropzoneOn = function () {
			_this.props.slotPlaceholderStateModel.setActivePlaceholderExists(true);
			_this.setState({ showDropzone: true });
		};

		_this._placeholderDropzoneOff = function () {
			_this.props.slotPlaceholderStateModel.setActivePlaceholderExists(false);
			_this.setState({ showDropzone: false });
		};

		_this.state = {
			isTypeInMode: false,
			showDropzone: false
		};
		_this.placeholderRef = _react2.default.createRef();
		return _this;
	}

	_createClass(SlotItemPlaceholder, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			var options = {
				onDragEnter: this._placeholderDropzoneOn.bind(this),
				onDragLeave: this._placeholderDropzoneOff.bind(this),
				getDndManager: function getDndManager(dndManager) {
					_this2._dndManager = dndManager;
				}
			};
			this.props.initializeDnd(this.placeholderRef.current, options);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this3 = this;

			if (this.state.showDropzone !== prevState.showDropzone) {
				var slotNode = (0, _jquery2.default)(this.placeholderRef.current).closest('.slotEditor__slots__slot').get(0);
				// if showDropzone state changes, and if we are dragging now,
				// we call reassessContainer to reassess the drop targets inside `slot`
				if (slotNode && this._dndManager && this._dndManager.dragObject) {
					this._dndManager.reassessContainer(slotNode);
				}
			}
			if (prevProps.slotDataItemHandler !== this.props.slotDataItemHandler) {
				var options = {
					onDragEnter: this._placeholderDropzoneOn.bind(this),
					onDragLeave: this._placeholderDropzoneOff.bind(this),
					getDndManager: function getDndManager(dndManager) {
						_this3._dndManager = dndManager;
					}
				};
				this.props.initializeDnd(this.placeholderRef.current, options);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this._dndManager) {
				this._dndManager.deregisterDropTarget(this.placeholderRef.current);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'slotPlaceholder',
					ref: this.placeholderRef
				},
				_react2.default.createElement('div', { className: 'slotPlaceholder__hoverIndicator' }),
				this._renderItem()
			);
		}
	}, {
		key: 'shouldRenderPlaceholder',


		/**
   * @returns {boolean} indicating if placeholder should be rendered
   * rules to render placeholder:
   * 1. this slot can accept more items and
   * there are no other placeholders currently rendered in this slot and
   * this item is the last one in the slot
   * 2. state showDropzone is true -> user is dragging metadata item on top of this placeholder
   */
		value: function shouldRenderPlaceholder() {
			var _props = this.props,
			    slotPlaceholderStateModel = _props.slotPlaceholderStateModel,
			    indexInSlot = _props.indexInSlot,
			    numberItemsInSlot = _props.numberItemsInSlot,
			    canAcceptMoreItems = _props.canAcceptMoreItems;


			if (!slotPlaceholderStateModel || !slotPlaceholderStateModel.getActivePlaceholderExists() && canAcceptMoreItems) {
				return numberItemsInSlot === indexInSlot + 1;
			}
			return this.state.showDropzone;
		}
	}, {
		key: '_renderItem',
		value: function _renderItem() {
			var _this4 = this;

			if (this.shouldRenderPlaceholder()) {
				this.sourceId = this.props.slotDataItemHandler.getDatasourceId() || (0, _utils.getDataSourceIdTypeIn)(this.props.dashboardApi);
				return _react2.default.createElement(
					'div',
					{ className: 'slotPlaceholder__itemPlaceholder',
						tabIndex: '0',
						onClick: this._placeholderTypeInOn,
						onKeyDown: function onKeyDown(event) {
							return _this4.props.a11Y.handleOpenTypeInDropdown(event, _this4._placeholderTypeInOn.bind(_this4));
						}
					},
					this.state.isTypeInMode && this.sourceId ? this._renderFieldDropdown() : _react2.default.createElement(_caUiToolkit.Label, { label: _StringResources2.default.get('placeholderDropzone'), className: 'slotPlaceholder__itemPlaceholder__actionLabel' })
				);
			}
		}
	}, {
		key: '_renderFieldDropdown',
		value: function _renderFieldDropdown() {
			return _react2.default.createElement(_FieldDropdown2.default, {
				a11Y: this.props.a11Y,
				open: this.state.isTypeInMode,
				dashboardApi: this.props.dashboardApi,
				getDropdownMaxHeight: this.getDropdownMaxHeight,
				onBlur: this._placeholderTypeInOff,
				slotDataItemHandler: this.props.slotDataItemHandler,
				sourceId: this.sourceId,
				parentNode: this.props.parentNode,
				replaceSlotItem: false
			});
		}
	}, {
		key: 'getDropdownMaxHeight',
		value: function getDropdownMaxHeight() {
			return MAX_HEIGHT;
		}
	}]);

	return SlotItemPlaceholder;
}(_react.Component);

SlotItemPlaceholder.propTypes = {
	a11Y: _propTypes2.default.object.isRequired,
	indexInSlot: _propTypes2.default.number,
	numberItemsInSlot: _propTypes2.default.number,
	canAcceptMoreItems: _propTypes2.default.bool,
	slotDataItemHandler: _propTypes2.default.object.isRequired,
	dashboardApi: _propTypes2.default.object.isRequired,
	initializeDnd: _propTypes2.default.func.isRequired,
	parentNode: _propTypes2.default.object,
	slotPlaceholderStateModel: _propTypes2.default.object
};

SlotItemPlaceholder.defaultProps = {
	indexInSlot: 0,
	numberItemsInSlot: 1,
	slotPlaceholderStateModel: undefined,
	canAcceptMoreItems: true,
	parentNode: {}

};

exports.default = (0, _mobxReact.observer)(SlotItemPlaceholder);

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_29__;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_30__;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
/**
 * The SlotEditorA11YHandler is responsible for handling any slot-editor-specific A11Y handling.
 * Specifically, it handles selection of an item as a drag source and calling back to complete a move on enter.
 */


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _js = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SlotEditorA11YHandler = function () {

	/**
  * Constructor
  */
	function SlotEditorA11YHandler() {
		_classCallCheck(this, SlotEditorA11YHandler);
	}

	/**
  * Handle the case the user hits space on the focused item
  * @param event - the keydown event
  * @param {object} handlers , A JSON object that holds mappings of slot handlers
  * @param [callback] - callback to execute if the key is not space
  */


	_createClass(SlotEditorA11YHandler, [{
		key: 'handleKeyDown',
		value: function handleKeyDown(event, handlers) {
			var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			if (event.key === ' ') {
				//Hitting a space should allow the focus item to be stored (for 'dropping' on enter.)
				this._sourceSelection = handlers.slotDataItemHandler;
				//TODO: addClass/removeClass should be removed when we convert the widget model to mobx
				(0, _jquery2.default)(this.sourceNode).removeClass('selected');
				this.sourceNode = event.target;
				(0, _jquery2.default)(this.sourceNode).addClass('selected');
				event.preventDefault(); // prevent the the browser to scroll page down
			} else {
				this.handleOpenTypeInDropdown(event, callback);
			}
		}

		/**
   * Handle the case the user do delete or paste
   * @param event - the keydown event
   * @param {object} handlers , A JSON object that holds mappings of slot handlers
   */

	}, {
		key: 'handleKeyUp',
		value: function handleKeyUp(event, handlers) {
			if (event.key === 'Delete' || event.key === 'Backspace') {
				if ((0, _jquery2.default)(event.target).hasClass('slotEditorItem')) {
					this.deleteSlotItem(handlers.slotDataItemHandler);
					event.preventDefault();
				}
			} else if (_js.A11YUtils.isPaste(event)) {
				this.slotHandleKeyUp(event, handlers.slotDataItemHandler);
				event.preventDefault();
			}
		}

		/**
   * Handle key down event specifically for local filter item
   * @param event - the keydown event
   * @param filterItemActionHandler - filterItemActionHandler
   * @param options
   * @param options.metaDataColumn - metaDataColumn
   * @param options.filterId - filterId
   */

	}, {
		key: 'handleKeyUpForFilterItem',
		value: function handleKeyUpForFilterItem(event, filterItemActionHandler, options) {
			if (event.key === 'Delete' || event.key === 'Backspace') {
				if ((0, _jquery2.default)(event.target).hasClass('slotEditorItem')) {
					this._deleteFilterItem(filterItemActionHandler, options);
					event.preventDefault();
				}
			}
		}

		/**
   * Handle 'enter' key event if no selection is made already
   * @param {} event - the keydown event 
   * @param {*} expandDropdown - callback to execute 
   */

	}, {
		key: 'handleOpenTypeInDropdown',
		value: function handleOpenTypeInDropdown(event, expandDropdown) {
			if (!this._sourceSelection && event.key === 'Enter') {
				expandDropdown();
			}
		}

		/**
   * Complete the action by calling the onEnter callback.
   * @param event - the keypress event
   * @param cbOnEnter - a callback function which should complete the event when a user hits enter.
   * @param options - pass any options on to the callback function as an argument (in the form the callback expects)
   */

	}, {
		key: 'handleKeyPress',
		value: function handleKeyPress(event, cbOnEnter, options) {
			if (this._sourceSelection && event.key === 'Enter') {
				//TODO: addClass/removeClass should be removed when we convert the widget model to mobx
				(0, _jquery2.default)(this.sourceNode).removeClass('selected');
				cbOnEnter(this._sourceSelection, options);
				this._sourceSelection = null;
				event.preventDefault();
			}
		}

		/**
   * Handles adding data item from tree and Ctrl + V to slot area
   * @param event
   * @param slotDataItemHandler
   */

	}, {
		key: 'slotHandleKeyUp',
		value: function slotHandleKeyUp(event, slotDataItemHandler) {
			// ctrl + V
			if (_js.A11YUtils.isPaste(event)) {
				var addAfter = !(event && event.target && event.target.classList.contains('slotEditorItem'));
				slotDataItemHandler.onDropA11Y(addAfter);
			}
		}

		/**
   * Handles adding data item from tree and Ctrl + V to context filters
   * @param event
   * @param node
   * @param dropSlotItemHandler
   * @param filterItemActionHandler
   */

	}, {
		key: 'filterHeaderHandleKeyUp',
		value: function filterHeaderHandleKeyUp(event, node, dropFilterItemHandler, filterItemActionHandler) {
			// ctrl + V
			if (_js.A11YUtils.isPaste(event)) {
				filterItemActionHandler.onDropA11Y(node);
			}
		}
	}, {
		key: 'deleteSlotItem',
		value: function deleteSlotItem(slotDataItemHandler) {
			return slotDataItemHandler.getActions().then(function (actions) {
				var deleteAction = actions.find(function (action) {
					return action && action.name === 'delete';
				});
				deleteAction && deleteAction.actions.apply();
			});
		}
	}, {
		key: '_deleteFilterItem',
		value: function _deleteFilterItem(filterItemActionHandler, options) {
			return filterItemActionHandler.getActions(options.metadataColumn, options.filterId).then(function (actions) {
				var deleteAction = actions.find(function (action) {
					return action.deleteLocalFilter !== undefined;
				});
				if (deleteAction) {
					deleteAction.deleteLocalFilter();
				}
			});
		}
	}]);

	return SlotEditorA11YHandler;
}();

exports.default = SlotEditorA11YHandler;

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "build-visualization_128",
  "use": "build-visualization_128-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"build-visualization_128\"><circle class=\"ba-graphics-neutral-white4\" cx=\"100\" cy=\"100\" r=\"100\" /><path class=\"ba-graphics-white\" d=\"M14.97 170.08h183.04\" /><path class=\"ba-graphics-gray60\" d=\"M198 172.08H15a2 2 0 110-4h183a2 2 0 010 4z\" /><path class=\"ba-graphics-white\" d=\"M2 170.08h4.97\" /><path class=\"ba-graphics-gray60\" d=\"M7 172.08H2a2 2 0 010-4h5a2 2 0 010 4zM75.1 37.41A2.44 2.44 0 0077.54 35a.61.61 0 011.22 0 2.44 2.44 0 002.44 2.44.61.61 0 110 1.22 2.44 2.44 0 00-2.44 2.44.61.61 0 01-1.22 0 2.44 2.44 0 00-2.44-2.44.61.61 0 010-1.22z\" /><circle class=\"ba-graphics-gray60\" cx=\"43.66\" cy=\"39.61\" r=\"2\" /><circle class=\"ba-graphics-gray60\" cx=\"114.6\" cy=\"21.66\" r=\"2\" /><path class=\"ba-graphics-white\" d=\"M31.52 56.68h137.16v113.41H31.52z\" /><path class=\"ba-graphics-gray1\" d=\"M31.48 57.37h58.28v112.66H31.48z\" /><path class=\"ba-graphics-gray60\" d=\"M168.61 172.08H31.33a2 2 0 01-2-2V95.8a2 2 0 014 0v72.28h133.28v-108a1 1 0 00-1-1h-53.47a2 2 0 010-4h53.47a5 5 0 015 5v110a2 2 0 01-2 2z\" /><path class=\"ba-graphics-gray60\" d=\"M31.33 109.05a2 2 0 01-2-2V59.74a5 5 0 015-5h65.59a2 2 0 010 4H34.33a1 1 0 00-1 1v47.31a2 2 0 01-2 2z\" /><path class=\"ba-graphics-gray60\" d=\"M89.63 171.82a2 2 0 01-2-2V59.16a2 2 0 014 0v110.66a2 2 0 01-2 2zm14.38-78.05h12.29v44.83h-12.29zm19.19 18.8h12.29v26.03H123.2zm19.18-7.95h12.29v33.98h-12.29z\" /><path class=\"ba-graphics-white\" d=\"M43.17 68.66h34.27c.66 0 1.2.4 1.2.89v15.54c0 .49-.54.88-1.2.88H43.17c-.66 0-1.2-.39-1.2-.88V69.55c.03-.49.54-.89 1.2-.89z\" /><path class=\"ba-graphics-gray60\" d=\"M77.44 88H43.17A3 3 0 0140 85.09V69.55a3 3 0 013.2-2.89h34.24a3 3 0 013.2 2.89v15.54a3 3 0 01-3.2 2.91zM44 84h32.64V70.66H44zm33.44-13.34z\" /><path class=\"ba-graphics-white\" d=\"M27.22 96h34.26c.67 0 1.2.39 1.2.88v15.54c0 .49-.53.89-1.2.89H27.22c-.67 0-1.21-.4-1.21-.89V96.85c-.01-.49.54-.85 1.21-.85z\" /><path class=\"ba-graphics-gray60\" d=\"M61.48 115.28H27.22a3 3 0 01-3.22-2.89V96.85A3 3 0 0127.22 94h34.26a3 3 0 013.2 2.88v15.54a3 3 0 01-3.2 2.86zm-33.47-4h32.67V98H28zM61.48 98z\" /><path class=\"ba-graphics-white\" d=\"M14 123.89h34.23c.67 0 1.2.4 1.2.89v15.54c0 .49-.53.88-1.2.88H14c-.67 0-1.21-.39-1.21-.88v-15.54c-.03-.49.51-.89 1.21-.89z\" /><path class=\"ba-graphics-gray60\" d=\"M48.23 143.2H14a3 3 0 01-3.21-2.88v-15.54a3 3 0 013.21-2.89h34.23a3 3 0 013.2 2.89v15.54a3 3 0 01-3.2 2.88zm-33.47-4h32.67v-13.31H14.76zm33.47-13.31z\" /><circle class=\"ba-graphics-gray80\" style=\"opacity:.1\" cx=\"140\" cy=\"60\" r=\"20\" /><circle class=\"ba-graphics-gray60\" cx=\"140\" cy=\"56\" r=\"20\" /><path class=\"ba-graphics-white\" d=\"M147.83 54H142v-5.83a2 2 0 10-4 0V54h-5.85a2 2 0 100 4H138v5.85a2 2 0 004 0V58h5.85a2 2 0 000-4z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (t) {
  function n(e) {
    if (o[e]) return o[e].exports;var r = o[e] = { i: e, l: !1, exports: {} };return t[e].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
  }var e = window.webpackJsonPBaGraphics;window.webpackJsonPBaGraphics = function (o, i, u) {
    for (var c, s, a, f = 0, d = []; f < o.length; f++) {
      s = o[f], r[s] && d.push(r[s][0]), r[s] = 0;
    }for (c in i) {
      Object.prototype.hasOwnProperty.call(i, c) && (t[c] = i[c]);
    }for (e && e(o, i, u); d.length;) {
      d.shift()();
    }if (u) for (f = 0; f < u.length; f++) {
      a = n(n.s = u[f]);
    }return a;
  };var o = {},
      r = { 197: 0 };n.m = t, n.c = o, n.d = function (t, e, o) {
    n.o(t, e) || Object.defineProperty(t, e, { configurable: !1, enumerable: !0, get: o });
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };return n.d(e, "a", e), e;
  }, n.o = function (t, n) {
    return Object.prototype.hasOwnProperty.call(t, n);
  }, n.p = "", n.oe = function (t) {
    throw console.error(t), t;
  };
}({ "698d75b157f24ae829cc": function d75b157f24ae829cc(t, n) {
    var e;e = function () {
      return this;
    }();try {
      e = e || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (e = window);
    }t.exports = e;
  }, "9689a9c94ae38b47fa2c": function a9c94ae38b47fa2c(t, n, e) {
    (function (n) {
      !function (n, e) {
        t.exports = e();
      }(0, function () {
        "use strict";
        function t(t, n) {
          return n = { exports: {} }, t(n, n.exports), n.exports;
        }var e = function e(t) {
          var n = t.id,
              e = t.viewBox,
              o = t.content;this.id = n, this.viewBox = e, this.content = o;
        };e.prototype.stringify = function () {
          return this.content;
        }, e.prototype.toString = function () {
          return this.stringify();
        }, e.prototype.destroy = function () {
          var t = this;["id", "viewBox", "content"].forEach(function (n) {
            return delete t[n];
          });
        };var o = function o(t) {
          var n = !!document.importNode,
              e = new DOMParser().parseFromString(t, "image/svg+xml").documentElement;return n ? document.importNode(e, !0) : e;
        },
            r = ("undefined" != typeof window ? window : void 0 !== n || "undefined" != typeof self && self, t(function (t, n) {
          !function (n, e) {
            t.exports = e();
          }(0, function () {
            function t(t) {
              return t && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && "[object RegExp]" !== Object.prototype.toString.call(t) && "[object Date]" !== Object.prototype.toString.call(t);
            }function n(t) {
              return Array.isArray(t) ? [] : {};
            }function e(e, o) {
              return o && !0 === o.clone && t(e) ? i(n(e), e, o) : e;
            }function o(n, o, r) {
              var u = n.slice();return o.forEach(function (o, c) {
                void 0 === u[c] ? u[c] = e(o, r) : t(o) ? u[c] = i(n[c], o, r) : -1 === n.indexOf(o) && u.push(e(o, r));
              }), u;
            }function r(n, o, r) {
              var u = {};return t(n) && Object.keys(n).forEach(function (t) {
                u[t] = e(n[t], r);
              }), Object.keys(o).forEach(function (c) {
                t(o[c]) && n[c] ? u[c] = i(n[c], o[c], r) : u[c] = e(o[c], r);
              }), u;
            }function i(t, n, i) {
              var u = Array.isArray(n),
                  c = i || { arrayMerge: o },
                  s = c.arrayMerge || o;return u ? Array.isArray(t) ? s(t, n, i) : e(n, i) : r(t, n, i);
            }return i.all = function (t, n) {
              if (!Array.isArray(t) || t.length < 2) throw new Error("first argument should be an array with at least two elements");return t.reduce(function (t, e) {
                return i(t, e, n);
              });
            }, i;
          });
        })),
            i = t(function (t, n) {
          var e = { svg: { name: "xmlns", uri: "http://www.w3.org/2000/svg" }, xlink: { name: "xmlns:xlink", uri: "http://www.w3.org/1999/xlink" } };n.default = e, t.exports = n.default;
        }),
            u = function u(t) {
          return Object.keys(t).map(function (n) {
            return n + '="' + t[n].toString().replace(/"/g, "&quot;") + '"';
          }).join(" ");
        },
            c = i.svg,
            s = i.xlink,
            a = {};a[c.name] = c.uri, a[s.name] = s.uri;var f = function f(t, n) {
          void 0 === t && (t = "");var e = r(a, n || {});return "<svg " + u(e) + ">" + t + "</svg>";
        };return function (t) {
          function n() {
            t.apply(this, arguments);
          }t && (n.__proto__ = t), n.prototype = Object.create(t && t.prototype), n.prototype.constructor = n;var e = { isMounted: {} };return e.isMounted.get = function () {
            return !!this.node;
          }, n.createFromExistingNode = function (t) {
            return new n({ id: t.getAttribute("id"), viewBox: t.getAttribute("viewBox"), content: t.outerHTML });
          }, n.prototype.destroy = function () {
            this.isMounted && this.unmount(), t.prototype.destroy.call(this);
          }, n.prototype.mount = function (t) {
            if (this.isMounted) return this.node;var n = "string" == typeof t ? document.querySelector(t) : t,
                e = this.render();return this.node = e, n.appendChild(e), e;
          }, n.prototype.render = function () {
            var t = this.stringify();return o(f(t)).childNodes[0];
          }, n.prototype.unmount = function () {
            this.node.parentNode.removeChild(this.node);
          }, Object.defineProperties(n.prototype, e), n;
        }(e);
      });
    }).call(n, e("698d75b157f24ae829cc"));
  }, "9ce58a7deea14f49ef01": function ce58a7deea14f49ef01(t, n, e) {
    (function (n) {
      !function (n, e) {
        t.exports = e();
      }(0, function () {
        "use strict";
        function t(t, n) {
          return n = { exports: {} }, t(n, n.exports), n.exports;
        }function e(t) {
          return t = t || Object.create(null), { on: function on(n, e) {
              (t[n] || (t[n] = [])).push(e);
            }, off: function off(n, e) {
              t[n] && t[n].splice(t[n].indexOf(e) >>> 0, 1);
            }, emit: function emit(n, e) {
              (t[n] || []).map(function (t) {
                t(e);
              }), (t["*"] || []).map(function (t) {
                t(n, e);
              });
            } };
        }function o(t, n) {
          return _(t).reduce(function (t, e) {
            if (!e.attributes) return t;var o = _(e.attributes),
                r = n ? o.filter(n) : o;return t.concat(r);
          }, []);
        }function r(t) {
          return t.replace(B, function (t) {
            return "%" + t[0].charCodeAt(0).toString(16).toUpperCase();
          });
        }function i(t, n, e) {
          return _(t).forEach(function (t) {
            var o = t.getAttribute(k);if (o && 0 === o.indexOf(n)) {
              var r = o.replace(n, e);t.setAttributeNS(T, k, r);
            }
          }), t;
        }var u = ("undefined" != typeof window ? window : void 0 !== n || "undefined" != typeof self && self, t(function (t, n) {
          !function (n, e) {
            t.exports = e();
          }(0, function () {
            function t(t) {
              return t && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && "[object RegExp]" !== Object.prototype.toString.call(t) && "[object Date]" !== Object.prototype.toString.call(t);
            }function n(t) {
              return Array.isArray(t) ? [] : {};
            }function e(e, o) {
              return o && !0 === o.clone && t(e) ? i(n(e), e, o) : e;
            }function o(n, o, r) {
              var u = n.slice();return o.forEach(function (o, c) {
                void 0 === u[c] ? u[c] = e(o, r) : t(o) ? u[c] = i(n[c], o, r) : -1 === n.indexOf(o) && u.push(e(o, r));
              }), u;
            }function r(n, o, r) {
              var u = {};return t(n) && Object.keys(n).forEach(function (t) {
                u[t] = e(n[t], r);
              }), Object.keys(o).forEach(function (c) {
                t(o[c]) && n[c] ? u[c] = i(n[c], o[c], r) : u[c] = e(o[c], r);
              }), u;
            }function i(t, n, i) {
              var u = Array.isArray(n),
                  c = i || { arrayMerge: o },
                  s = c.arrayMerge || o;return u ? Array.isArray(t) ? s(t, n, i) : e(n, i) : r(t, n, i);
            }return i.all = function (t, n) {
              if (!Array.isArray(t) || t.length < 2) throw new Error("first argument should be an array with at least two elements");return t.reduce(function (t, e) {
                return i(t, e, n);
              });
            }, i;
          });
        })),
            c = t(function (t, n) {
          var e = { svg: { name: "xmlns", uri: "http://www.w3.org/2000/svg" }, xlink: { name: "xmlns:xlink", uri: "http://www.w3.org/1999/xlink" } };n.default = e, t.exports = n.default;
        }),
            s = function s(t) {
          return Object.keys(t).map(function (n) {
            return n + '="' + t[n].toString().replace(/"/g, "&quot;") + '"';
          }).join(" ");
        },
            a = c.svg,
            f = c.xlink,
            d = {};d[a.name] = a.uri, d[f.name] = f.uri;var l,
            p = function p(t, n) {
          void 0 === t && (t = "");var e = u(d, n || {});return "<svg " + s(e) + ">" + t + "</svg>";
        },
            h = c.svg,
            y = c.xlink,
            m = { attrs: (l = { style: ["position: absolute", "width: 0", "height: 0"].join("; ") }, l[h.name] = h.uri, l[y.name] = y.uri, l) },
            v = function v(t) {
          this.config = u(m, t || {}), this.symbols = [];
        };v.prototype.add = function (t) {
          var n = this,
              e = n.symbols,
              o = this.find(t.id);return o ? (e[e.indexOf(o)] = t, !1) : (e.push(t), !0);
        }, v.prototype.remove = function (t) {
          var n = this,
              e = n.symbols,
              o = this.find(t);return !!o && (e.splice(e.indexOf(o), 1), o.destroy(), !0);
        }, v.prototype.find = function (t) {
          return this.symbols.filter(function (n) {
            return n.id === t;
          })[0] || null;
        }, v.prototype.has = function (t) {
          return null !== this.find(t);
        }, v.prototype.stringify = function () {
          var t = this.config,
              n = t.attrs,
              e = this.symbols.map(function (t) {
            return t.stringify();
          }).join("");return p(e, n);
        }, v.prototype.toString = function () {
          return this.stringify();
        }, v.prototype.destroy = function () {
          this.symbols.forEach(function (t) {
            return t.destroy();
          });
        };var g = function g(t) {
          var n = t.id,
              e = t.viewBox,
              o = t.content;this.id = n, this.viewBox = e, this.content = o;
        };g.prototype.stringify = function () {
          return this.content;
        }, g.prototype.toString = function () {
          return this.stringify();
        }, g.prototype.destroy = function () {
          var t = this;["id", "viewBox", "content"].forEach(function (n) {
            return delete t[n];
          });
        };var w,
            b = function b(t) {
          var n = !!document.importNode,
              e = new DOMParser().parseFromString(t, "image/svg+xml").documentElement;return n ? document.importNode(e, !0) : e;
        },
            x = function (t) {
          function n() {
            t.apply(this, arguments);
          }t && (n.__proto__ = t), n.prototype = Object.create(t && t.prototype), n.prototype.constructor = n;var e = { isMounted: {} };return e.isMounted.get = function () {
            return !!this.node;
          }, n.createFromExistingNode = function (t) {
            return new n({ id: t.getAttribute("id"), viewBox: t.getAttribute("viewBox"), content: t.outerHTML });
          }, n.prototype.destroy = function () {
            this.isMounted && this.unmount(), t.prototype.destroy.call(this);
          }, n.prototype.mount = function (t) {
            if (this.isMounted) return this.node;var n = "string" == typeof t ? document.querySelector(t) : t,
                e = this.render();return this.node = e, n.appendChild(e), e;
          }, n.prototype.render = function () {
            var t = this.stringify();return b(p(t)).childNodes[0];
          }, n.prototype.unmount = function () {
            this.node.parentNode.removeChild(this.node);
          }, Object.defineProperties(n.prototype, e), n;
        }(g),
            E = { autoConfigure: !0, mountTo: "body", syncUrlsWithBaseTag: !1, listenLocationChangeEvent: !0, locationChangeEvent: "locationChange", locationChangeAngularEmitter: !1, usagesToUpdate: "use[*|href]", moveGradientsOutsideSymbol: !1 },
            _ = function _(t) {
          return Array.prototype.slice.call(t, 0);
        },
            O = navigator.userAgent,
            S = { isChrome: /chrome/i.test(O), isFirefox: /firefox/i.test(O), isIE: /msie/i.test(O) || /trident/i.test(O), isEdge: /edge/i.test(O) },
            M = function M(t, n) {
          var e = document.createEvent("CustomEvent");e.initCustomEvent(t, !1, !1, n), window.dispatchEvent(e);
        },
            A = function A(t) {
          var n = [];return _(t.querySelectorAll("style")).forEach(function (t) {
            t.textContent += "", n.push(t);
          }), n;
        },
            C = function C(t) {
          return (t || window.location.href).split("#")[0];
        },
            j = function j(t) {
          angular.module("ng").run(["$rootScope", function (n) {
            n.$on("$locationChangeSuccess", function (n, e, o) {
              M(t, { oldUrl: o, newUrl: e });
            });
          }]);
        },
            N = function N(t, n) {
          return void 0 === n && (n = "linearGradient, radialGradient, pattern"), _(t.querySelectorAll("symbol")).forEach(function (t) {
            _(t.querySelectorAll(n)).forEach(function (n) {
              t.parentNode.insertBefore(n, t);
            });
          }), t;
        },
            T = c.xlink.uri,
            k = "xlink:href",
            B = /[{}|\\\^\[\]`"<>]/g,
            U = ["clipPath", "colorProfile", "src", "cursor", "fill", "filter", "marker", "markerStart", "markerMid", "markerEnd", "mask", "stroke", "style"],
            L = U.map(function (t) {
          return "[" + t + "]";
        }).join(","),
            P = function P(t, n, e, u) {
          var c = r(e),
              s = r(u);o(t.querySelectorAll(L), function (t) {
            var n = t.localName,
                e = t.value;return -1 !== U.indexOf(n) && -1 !== e.indexOf("url(" + c);
          }).forEach(function (t) {
            return t.value = t.value.replace(c, s);
          }), i(n, c, s);
        },
            G = { MOUNT: "mount", SYMBOL_MOUNT: "symbol_mount" },
            q = function (t) {
          function n(n) {
            var o = this;void 0 === n && (n = {}), t.call(this, u(E, n));var r = e();this._emitter = r, this.node = null;var i = this,
                c = i.config;if (c.autoConfigure && this._autoConfigure(n), c.syncUrlsWithBaseTag) {
              var s = document.getElementsByTagName("base")[0].getAttribute("href");r.on(G.MOUNT, function () {
                return o.updateUrls("#", s);
              });
            }var a = this._handleLocationChange.bind(this);this._handleLocationChange = a, c.listenLocationChangeEvent && window.addEventListener(c.locationChangeEvent, a), c.locationChangeAngularEmitter && j(c.locationChangeEvent), r.on(G.MOUNT, function (t) {
              c.moveGradientsOutsideSymbol && N(t);
            }), r.on(G.SYMBOL_MOUNT, function (t) {
              c.moveGradientsOutsideSymbol && N(t.parentNode), (S.isIE || S.isEdge) && A(t);
            });
          }t && (n.__proto__ = t), n.prototype = Object.create(t && t.prototype), n.prototype.constructor = n;var o = { isMounted: {} };return o.isMounted.get = function () {
            return !!this.node;
          }, n.prototype._autoConfigure = function (t) {
            var n = this,
                e = n.config;void 0 === t.syncUrlsWithBaseTag && (e.syncUrlsWithBaseTag = void 0 !== document.getElementsByTagName("base")[0]), void 0 === t.locationChangeAngularEmitter && (e.locationChangeAngularEmitter = "angular" in window), void 0 === t.moveGradientsOutsideSymbol && (e.moveGradientsOutsideSymbol = S.isFirefox);
          }, n.prototype._handleLocationChange = function (t) {
            var n = t.detail,
                e = n.oldUrl,
                o = n.newUrl;this.updateUrls(e, o);
          }, n.prototype.add = function (n) {
            var e = this,
                o = t.prototype.add.call(this, n);return this.isMounted && o && (n.mount(e.node), this._emitter.emit(G.SYMBOL_MOUNT, n.node)), o;
          }, n.prototype.attach = function (t) {
            var n = this,
                e = this;if (e.isMounted) return e.node;var o = "string" == typeof t ? document.querySelector(t) : t;return e.node = o, this.symbols.forEach(function (t) {
              t.mount(e.node), n._emitter.emit(G.SYMBOL_MOUNT, t.node);
            }), _(o.querySelectorAll("symbol")).forEach(function (t) {
              var n = x.createFromExistingNode(t);n.node = t, e.add(n);
            }), this._emitter.emit(G.MOUNT, o), o;
          }, n.prototype.destroy = function () {
            var t = this,
                n = t.config,
                e = t.symbols,
                o = t._emitter;e.forEach(function (t) {
              return t.destroy();
            }), o.off("*"), window.removeEventListener(n.locationChangeEvent, this._handleLocationChange), this.isMounted && this.unmount();
          }, n.prototype.mount = function (t, n) {
            void 0 === t && (t = this.config.mountTo), void 0 === n && (n = !1);var e = this;if (e.isMounted) return e.node;var o = "string" == typeof t ? document.querySelector(t) : t,
                r = e.render();return this.node = r, n && o.childNodes[0] ? o.insertBefore(r, o.childNodes[0]) : o.appendChild(r), this._emitter.emit(G.MOUNT, r), r;
          }, n.prototype.render = function () {
            return b(this.stringify());
          }, n.prototype.unmount = function () {
            this.node.parentNode.removeChild(this.node);
          }, n.prototype.updateUrls = function (t, n) {
            if (!this.isMounted) return !1;var e = document.querySelectorAll(this.config.usagesToUpdate);return P(this.node, e, C(t) + "#", C(n) + "#"), !0;
          }, Object.defineProperties(n.prototype, o), n;
        }(v),
            D = t(function (t) {
          /*!
          * domready (c) Dustin Diaz 2014 - License MIT
          */
          !function (n, e) {
            t.exports = function () {
              var _t,
                  n = [],
                  e = document,
                  o = e.documentElement.doScroll,
                  r = (o ? /^loaded|^c/ : /^loaded|^i|^c/).test(e.readyState);return r || e.addEventListener("DOMContentLoaded", _t = function t() {
                for (e.removeEventListener("DOMContentLoaded", _t), r = 1; _t = n.shift();) {
                  _t();
                }
              }), function (t) {
                r ? setTimeout(t, 0) : n.push(t);
              };
            }();
          }();
        }),
            F = !!window.__SVG_SPRITE__;F ? w = window.__SVG_SPRITE__ : (w = new q({ attrs: { id: "__SVG_SPRITE_NODE__" } }), window.__SVG_SPRITE__ = w);var I = function I() {
          var t = document.getElementById("__SVG_SPRITE_NODE__");t ? w.attach(t) : w.mount(document.body, !0);
        };return document.body ? I() : D(I), w;
      });
    }).call(n, e("698d75b157f24ae829cc"));
  } });

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _caUiToolkit = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(74);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Content Explorer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var SlotEditorEmptyState = function (_Component) {
	_inherits(SlotEditorEmptyState, _Component);

	function SlotEditorEmptyState(props) {
		_classCallCheck(this, SlotEditorEmptyState);

		return _possibleConstructorReturn(this, (SlotEditorEmptyState.__proto__ || Object.getPrototypeOf(SlotEditorEmptyState)).call(this, props));
	}

	_createClass(SlotEditorEmptyState, [{
		key: 'render',
		value: function render() {
			var icon = this.renderIcon();
			var title = this.renderTitle();
			var description = this.renderDescription();

			var alignment = this.props.alignment;
			var styles = {
				'align-items': alignment ? alignment : 'center',
				'text-align': alignment ? alignment : 'center'
			};

			return _react2.default.createElement(
				'div',
				{ className: 'slotEditorEmpty', style: styles },
				_react2.default.createElement(
					'div',
					{ className: 'slotEditorEmpty__container' },
					icon,
					title,
					description
				)
			);
		}
	}, {
		key: 'renderIcon',
		value: function renderIcon() {
			if (this.props.iconId) {
				return _react2.default.createElement(
					'div',
					{ className: 'slotEditorEmpty__icon' },
					_react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: this.props.iconId, size: 'xxlarge' })
				);
			}
			return null;
		}
	}, {
		key: 'renderTitle',
		value: function renderTitle() {
			if (this.props.title) {
				return _react2.default.createElement(_caUiToolkit.Label, { label: this.props.title, className: 'slotEditorEmpty__title' });
			}
			return null;
		}
	}, {
		key: 'renderDescription',
		value: function renderDescription() {
			if (this.props.description) {
				var description = this.props.description;
				return _react2.default.createElement(_caUiToolkit.Label, { label: description, className: 'slotEditorEmpty__description' });
			}
			return null;
		}
	}]);

	return SlotEditorEmptyState;
}(_react.Component);

SlotEditorEmptyState.propTypes = {
	title: _propTypes2.default.string,
	description: _propTypes2.default.string,
	iconId: _propTypes2.default.string,
	alignment: _propTypes2.default.string
};

SlotEditorEmptyState.defaultProps = {
	title: null,
	iconId: null,
	description: null,
	alignment: null
};

exports.default = SlotEditorEmptyState;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| (C) Copyright IBM Corp. 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _utils = __webpack_require__(7);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScrollableDragHandler = function () {
	function ScrollableDragHandler(options) {
		_classCallCheck(this, ScrollableDragHandler);

		this.accepts = function () {
			return false;
		};

		this.scrollableContainer = options.scrollableContainer;
		this.priority = function () {
			return 10;
		};
		this.dndManager = options.dndManager;
		this.receiveEventsWhenNotAccepting = true; // this is needed by dndManager
	}

	_createClass(ScrollableDragHandler, [{
		key: 'onDragMove',
		value: function onDragMove(dragObject, dropTarget, event) {
			var _this = this;

			(0, _utils.handleScroll)(event, this.scrollableContainer, function () {
				return _this.dndManager && _this.dndManager.reassessContainer(_this.scrollableContainer);
			});
		}
	}]);

	return ScrollableDragHandler;
}();

exports.default = ScrollableDragHandler;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Watson Analytics (C) Copyright IBM Corp. 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SLOT_ITEM_TOUCH_DRAG_DURATION = 600;

var DndSlotItemHandler = function () {
	/**
  * DndSlotItemHandler hides most of the drag and drop handling used by the glass DndManager
  * It handles drop of data from the metadata tree to a Slot Item (or Slot Heading)
  * It also handles Drag&Drop of slot to slot data.
  *
  * @param {DOMNode} domNode - DOM node to attach drag and drop to
  * @param {string} className - class name
  * @param {Function} dropHandler - function to be called on drop
  * @param {Function} [acceptsHandler] - function to be used as validation for accepting the drag event as drop target; by default always accepts; pass custom function for additional validation
  */
	function DndSlotItemHandler(domNode, className, dropHandler) {
		var acceptsHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
			return true;
		};
		var dndManager = arguments[4];

		_classCallCheck(this, DndSlotItemHandler);

		this.domNode = domNode;
		this.className = className;
		this.dropHandler = dropHandler;
		this.acceptsHandler = acceptsHandler;
		this.timer = null;
		this.dndManager = dndManager;
	}

	/**
  * A slotItem can accept data from the metadata tree/data grid (type MODEL_ITEM)
  * or from another slot Item (ie: swap 2 slot items or move items from one slot to another.)
  * A slotItem also accepts a shape (type widget) if the visualization type is a summary
  */


	_createClass(DndSlotItemHandler, [{
		key: 'accepts',
		value: function accepts(dragObject) {
			return (dragObject.type === 'SLOT_ITEM' || dragObject.widgetType === 'shape' || (dragObject.type === 'GRID_HEADER_ITEM' || dragObject.type === 'MODEL_ITEM') && dragObject.data && dragObject.data.utils && dragObject.data.utils.isValid()) && this.acceptsHandler(dragObject);
		}

		/**
   * @param dragObject - the dragObject (that could have come from the metadata tree, another slot item, or a shape)
   * @returns the data portion of the payload - one of: source dataItemHandler, metadatacolumns, or shape widget
   */

	}, {
		key: 'getData',
		value: function getData(dragObject) {

			if (!dragObject) {
				return null;
			}
			if (dragObject.type === 'SLOT_ITEM') {
				return dragObject.data.source;
			}
			if (dragObject.widgetType === 'shape') {
				return dragObject;
			}
			return this._getDropMetadataColumns(dragObject);
		}
	}, {
		key: '_getDropMetadataColumns',
		value: function _getDropMetadataColumns(dragObject) {
			return dragObject && dragObject.data;
		}
	}, {
		key: 'activateDropTarget',
		value: function activateDropTarget() {
			(0, _jquery2.default)(this.domNode).toggleClass(this.className, true);
		}
	}, {
		key: 'deactivateDropTarget',
		value: function deactivateDropTarget() {
			(0, _jquery2.default)(this.domNode).toggleClass(this.className, false);
		}
	}, {
		key: 'onDragStart',
		value: function onDragStart() {}
	}, {
		key: 'onDragMove',
		value: function onDragMove(dragObject, dropNode, event) {
			var _this = this;

			var slotEditorNode = (0, _jquery2.default)(dropNode).closest('.slotEditor').get(0);
			if (slotEditorNode) {
				(0, _utils.handleScroll)(event, slotEditorNode, function () {
					return _this.dndManager && _this.dndManager.reassessContainer(slotEditorNode);
				});
			}
			this.activateDropTarget();
		}
	}, {
		key: 'onDragLeave',
		value: function onDragLeave() {
			this.deactivateDropTarget();
		}
	}, {
		key: 'onDragEnd',
		value: function onDragEnd() {
			this.deactivateDropTarget();
		}
	}, {
		key: 'onDrop',
		value: function onDrop(dragObject, dropNode) {
			this.dropHandler(dragObject, dropNode);
		}

		/**
   * @param dndManager - the dndManager to initialize the drag within
   * @param cbGetSlotDataItemHandler - a callback function which should be called when starting any drag to get the up-to-date item data handler.
   */

	}, {
		key: 'initializeDndSource',
		value: function initializeDndSource(dndManager, cbGetSlotDataItemHandler, iconsFeature) {
			var _this2 = this;

			// Separate mouse and touch event handlers for defect 241719
			(0, _jquery2.default)(this.domNode).on('mousedown', {}, function (event) {
				_this2._startDrag({
					dndManager: dndManager,
					event: event,
					cbGetSlotDataItemHandler: cbGetSlotDataItemHandler,
					iconsFeature: iconsFeature
				});
				return true;
			});

			(0, _jquery2.default)(this.domNode).on('touchstart', {}, function (event) {
				_this2._touchStart({
					dndManager: dndManager,
					event: event,
					cbGetSlotDataItemHandler: cbGetSlotDataItemHandler,
					iconsFeature: iconsFeature
				});
				return true;
			});

			(0, _jquery2.default)(this.domNode).on('touchend touchcancel', {}, function () {
				return _this2._touchEnd();
			});
		}

		// defect 241719
		// after touchstart, wait short time to start drag process if still touch,
		// so that it can reduce change of ambiguous event with scrolling of the slot editor

	}, {
		key: '_touchStart',
		value: function _touchStart(options) {
			this.timer = setTimeout(function () {
				this._touchStartDrag(options);
			}.bind(this), SLOT_ITEM_TOUCH_DRAG_DURATION);
		}
	}, {
		key: '_touchEnd',
		value: function _touchEnd() {
			if (this.timer) {
				clearTimeout(this.timer);
			}
			this.timer = null;
		}
	}, {
		key: '_touchStartDrag',
		value: function _touchStartDrag(options) {
			if (this.timer) {
				this._startDrag(options);
			}
		}
	}, {
		key: '_startDrag',
		value: function _startDrag(options) {
			var $avatar = (0, _jquery2.default)('<div style="position:absolute; z-index:10000;"/>');

			var $draggedNode = (0, _jquery2.default)(this.domNode).clone().addClass('draggedNode');
			if (options.iconsFeature) {
				var disableIcon = options.iconsFeature.getIcon('common-nodrop');
				if (disableIcon) {
					var $nodropSign = (0, _jquery2.default)('<div class="slotEditorItem__nameLine__nodrop is-hidden">\n\t\t\t\t\t\t<svg class="svgIcon">\n\t\t\t\t\t\t\t<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#' + disableIcon.id + '">\n\t\t\t\t\t\t\t</use>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t</div>');
					$draggedNode.find('.slotEditorItem__nameLine').prepend($nodropSign);
				}
			}
			$avatar.append($draggedNode);

			options.dndManager.startDrag({
				event: options.event,
				type: 'SLOT_ITEM',
				data: {
					source: options.cbGetSlotDataItemHandler()
				},
				callerCallbacks: {
					onMove: this._onMove.bind(this)
				},
				avatar: $avatar,
				moveXThreshold: 20,
				moveYThreshold: 20
			});
		}
	}, {
		key: '_onMove',
		value: function _onMove(event) {
			var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var dragObject = payload.dragObject;

			if (dragObject) {
				var avatar = dragObject.avatar;

				if (avatar) {
					var $avatar = (0, _jquery2.default)(avatar);
					var $nodrop = $avatar.find('.slotEditorItem__nameLine__nodrop');
					if ($nodrop.length) {
						var dropTargetNode = payload.dropTargetNode;

						if (!dropTargetNode) {
							// no payload.dropTargetNode means currenly you cannot drop here, so we show `not allowed drop sign`
							$nodrop.toggleClass('is-hidden', false);
						} else {
							// else payload.dropTargetNode exists,
							// if the drop target is not `.slotEditor` (which is used for drag auto scroll ),
							// then means currenly you can REALLY drop the slot item here, so we does not show `not allowed drop sign`
							var isDropTargetNotSlotEditor = !(dropTargetNode.classList && dropTargetNode.classList.contains('slotEditor'));
							$nodrop.toggleClass('is-hidden', isDropTargetNotSlotEditor);
						}
					}
				}
			}
		}
	}]);

	return DndSlotItemHandler;
}();

exports.default = DndSlotItemHandler;

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp; /**
                    * Licensed Materials - Property of IBM
                    * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
                    * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                    */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(39);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _SlotEditorDOMAPI = __webpack_require__(40);

var _SlotEditorDOMAPI2 = _interopRequireDefault(_SlotEditorDOMAPI);

var _SlotEditor = __webpack_require__(41);

var _SlotEditor2 = _interopRequireDefault(_SlotEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var APIFactory = __webpack_require__(20);

var SlotEditorDOM = (_temp = _class = function () {
	function SlotEditorDOM(_ref) {
		var features = _ref.features;

		_classCallCheck(this, SlotEditorDOM);

		this._dashboardApi = features.API;
		this._slideout = features.InAppSlideoutDOM;
		this._slotEditorState = features.SlotEditorState;
		this._api = null;
		this._parent = null;
		this._extensions = [];
	}

	_createClass(SlotEditorDOM, [{
		key: 'getAPI',
		value: function getAPI() {
			return this._api;
		}
	}, {
		key: 'addExtension',
		value: function addExtension(extension) {
			this._extensions.push(extension);
		}
	}, {
		key: 'initialize',
		value: function initialize() {
			this._api = APIFactory.createAPI(this, [_SlotEditorDOMAPI2.default]);
			this._slideout.registerView(this._slotEditorState.getProviderId(), this);
		}
	}, {
		key: 'getProviderId',
		value: function getProviderId() {
			return this._slotEditorState.getProviderId();
		}
	}, {
		key: 'render',
		value: function render(options) {
			var _this = this;

			var _ref2 = options || {},
			    _ref2$parentNode = _ref2.parentNode,
			    parentNode = _ref2$parentNode === undefined ? null : _ref2$parentNode;

			if (parentNode && document.body.contains(parentNode)) {
				if (this._parent !== parentNode) {
					//before a new render, clear previous rendered SlotEditor
					this.unmount();
					this._parent = parentNode;
					return new Promise(function (resolve) {
						_reactDom2.default.render(_react2.default.createElement(_SlotEditor2.default, {
							dndManager: _this._dashboardApi.getDashboardSvc('.DndManager'),
							slotEditorModel: _this._slotEditorState.getModel(),
							logger: _this._dashboardApi.getService(_this._dashboardApi.GLOBAL_SERVICES.LOGGER),
							extensions: _this._extensions
						}), parentNode, function () {
							return resolve();
						});
					});
				}
			}

			return Promise.resolve(null);
		}
	}, {
		key: 'unmount',
		value: function unmount() {
			if (this._parent) {
				_reactDom2.default.unmountComponentAtNode(this._parent);
				this._parent = null;
			}
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			this.unmount();
			this._api = null;
			this._dashboardApi = null;
			this._slotEditorState = null;
			this._slideout = null;
		}
	}]);

	return SlotEditorDOM;
}(), _class.PROVIDER_ID = 'SlotEditorDOM', _temp);


module.exports = SlotEditorDOM;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_39__;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var SlotEditorDOMAPI = function () {
	function SlotEditorDOMAPI() {
		_classCallCheck(this, SlotEditorDOMAPI);
	}

	_createClass(SlotEditorDOMAPI, [{
		key: "render",

		/**
   * @function SlotEditorDOMAPI#render
   * @description Renders slots in a given container
   * @param {Object} options
   * @param {Object} options.parentNode - the parent dom node for rendering the slots editor
   */
		value: function render() {}

		/**
   * @function SlotEditorDOMAPI#unmount
   * @description unmount slots
   */

	}, {
		key: "unmount",
		value: function unmount() {}

		/**
   * @function SlotEditorDOMAPI#getProviderId
   * @description Returns the provider id for the feature
   * @return {String} DOM feature provider id
   */

	}, {
		key: "getProviderId",
		value: function getProviderId() {}
	}, {
		key: "addExtension",
		value: function addExtension() {}
	}]);

	return SlotEditorDOMAPI;
}();

exports.default = SlotEditorDOMAPI;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ErrorBoundary = __webpack_require__(42);

var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);

var _SlotEditorView = __webpack_require__(43);

var _SlotEditorView2 = _interopRequireDefault(_SlotEditorView);

var _SlotEditorView3 = __webpack_require__(76);

var _SlotEditorView4 = _interopRequireDefault(_SlotEditorView3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2019, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * The SlotEditor component is responsible for editing of the slots/filters for the widget whose api is provided.
 */
var SlotEditor = function (_Component) {
	_inherits(SlotEditor, _Component);

	function SlotEditor(props) {
		_classCallCheck(this, SlotEditor);

		return _possibleConstructorReturn(this, (SlotEditor.__proto__ || Object.getPrototypeOf(SlotEditor)).call(this, props));
	}

	_createClass(SlotEditor, [{
		key: 'isTypeInEnabled',
		value: function isTypeInEnabled() {
			return !this.props.slotEditorModel.dashboardApi.getGlassCoreSvc('.FeatureChecker').checkValue('dashboard', 'typeInSlots', 'disabled');
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    slotEditorModel = _props.slotEditorModel,
			    dndManager = _props.dndManager,
			    logger = _props.logger,
			    extensions = _props.extensions;

			var isTypeInEnabled = this.isTypeInEnabled();
			return _react2.default.createElement(
				_ErrorBoundary2.default,
				{
					logger: logger
				},
				isTypeInEnabled ? _react2.default.createElement(_SlotEditorView2.default, {
					dndManager: dndManager,
					slotEditorModel: slotEditorModel,
					extensions: extensions
				}) : _react2.default.createElement(_SlotEditorView4.default, {
					dndManager: dndManager,
					slotEditorModel: slotEditorModel,
					extensions: extensions
				})
			);
		}
	}]);

	return SlotEditor;
}(_react.Component);

SlotEditor.propTypes = {
	dndManager: _propTypes2.default.object.isRequired,
	slotEditorModel: _propTypes2.default.object.isRequired,
	logger: _propTypes2.default.object.isRequired,
	extensions: _propTypes2.default.array
};

exports.default = SlotEditor;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var ErrorBoundary = function (_Component) {
	_inherits(ErrorBoundary, _Component);

	function ErrorBoundary(props) {
		_classCallCheck(this, ErrorBoundary);

		var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

		_this.state = { hasError: false };
		return _this;
	}

	_createClass(ErrorBoundary, [{
		key: 'componentDidCatch',
		value: function componentDidCatch(error, errorInfo) {
			var logger = this.props.logger;

			if (logger) {
				// logging error message
				logger.error(errorInfo.componentStack /* information about which component threw the error. */);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.state.hasError) {
				// TODO: error screen when we encounter error
				return null;
			}
			return this.props.children;
		}
	}], [{
		key: 'getDerivedStateFromError',
		value: function getDerivedStateFromError() /*error*/{
			// Update state so the next render will show the fallback UI.
			return { hasError: true };
		}
	}]);

	return ErrorBoundary;
}(_react.Component);

ErrorBoundary.propTypes = {
	logger: _propTypes2.default.object.isRequired,
	children: _propTypes2.default.any
};

ErrorBoundary.defaultProps = {
	children: []
};
exports.default = ErrorBoundary;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(12);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _SlotEditorSlot = __webpack_require__(44);

var _SlotEditorSlot2 = _interopRequireDefault(_SlotEditorSlot);

var _SlotEditorA11YHandler = __webpack_require__(31);

var _SlotEditorA11YHandler2 = _interopRequireDefault(_SlotEditorA11YHandler);

var _caUiToolkit = __webpack_require__(3);

var _buildVisualization_ = __webpack_require__(32);

var _buildVisualization_2 = _interopRequireDefault(_buildVisualization_);

var _nothingHere_ = __webpack_require__(73);

var _nothingHere_2 = _interopRequireDefault(_nothingHere_);

var _SlotEditorEmptyState = __webpack_require__(34);

var _SlotEditorEmptyState2 = _interopRequireDefault(_SlotEditorEmptyState);

var _mobxStateTree = __webpack_require__(5);

var _ScrollableDragHandler = __webpack_require__(35);

var _ScrollableDragHandler2 = _interopRequireDefault(_ScrollableDragHandler);

__webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2019, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * The SlotEditor View
 */
var SlotEditorView = function (_Component) {
	_inherits(SlotEditorView, _Component);

	function SlotEditorView(props) {
		_classCallCheck(this, SlotEditorView);

		//Handle slot-editor-specific accessibility actions (eg swapping slot items etc.)
		var _this = _possibleConstructorReturn(this, (SlotEditorView.__proto__ || Object.getPrototypeOf(SlotEditorView)).call(this, props));

		_this._initializeScrollDragSupport = function () {
			var dndManagerPromise = _this.props.dndManager;

			dndManagerPromise && dndManagerPromise.then(function (dndManager) {
				if (_this.slotEditorRef.current) {
					_this.scrollableDragHandler = new _ScrollableDragHandler2.default({
						scrollableContainer: _this.slotEditorRef.current,
						dndManager: dndManager
					});
					_this.dropTarget = dndManager.addDropTarget(_this.slotEditorRef.current, _this.scrollableDragHandler);
				}
			});
		};

		_this.a11YHandler = new _SlotEditorA11YHandler2.default();
		_this.state = {
			needsRefresh: null
		};
		_this.slotEditorRef = _react2.default.createRef();
		return _this;
	}

	_createClass(SlotEditorView, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this._initializeScrollDragSupport();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.dropTarget && this.dropTarget.remove();
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{
					ref: this.slotEditorRef,
					className: 'slotEditor'
				},
				this.renderContent()
			);
		}
	}, {
		key: 'renderContent',
		value: function renderContent() {
			var slotEditorModel = this.props.slotEditorModel;

			if (!slotEditorModel || !(0, _mobxStateTree.isAlive)(slotEditorModel)) {
				// unable to render the view if the model is dead
				return null;
			}
			var selectedContent = slotEditorModel.selectedContents[0];
			var SLOT_EDITOR_STATES = slotEditorModel.SLOT_EDITOR_STATES;

			var currentState = slotEditorModel.slotEditorState;
			if (currentState === SLOT_EDITOR_STATES.DISPLAY) {

				if (!this._canRenderSlotEditor(selectedContent)) {
					return this._renderEmptyState(SLOT_EDITOR_STATES, SLOT_EDITOR_STATES.EMPTY.NO_VIS_CREATED);
				}

				var result = this.renderSlotsAndExtensions();
				if (result) {
					return result;
				} else {
					return this._renderEmptyState(SLOT_EDITOR_STATES);
				}
			} else {
				return this._renderEmptyState(SLOT_EDITOR_STATES, currentState);
			}
		}
	}, {
		key: '_getSlotsSection',
		value: function _getSlotsSection() {
			var slotEditorModel = this.props.slotEditorModel;

			var slotInfo = slotEditorModel.getSlotInfo();
			return _react2.default.createElement(
				'div',
				{ className: 'slotEditor__slots' },
				slotInfo.length > 1 ? this._renderLayersAndSlots(slotInfo) : this._renderSlots(slotInfo[0].slotAPIs)
			);
		}
	}, {
		key: 'renderSlotsAndExtensions',
		value: function renderSlotsAndExtensions() {
			var slotEditorModel = this.props.slotEditorModel;

			var slotInfo = slotEditorModel.getSlotInfo();
			var sections = [{
				index: 0,
				render: this._getSlotsSection.bind(this)
			}];

			if (this.props.extensions !== undefined) {
				sections = sections.concat(this.props.extensions);
			}
			var sorted_sections = sections.sort(function (a, b) {
				return a.index - b.index;
			});

			if (slotInfo.length > 0) {
				return _react2.default.createElement(
					_react2.default.Fragment,
					null,
					sorted_sections.map(function (section) {
						return section.render();
					})
				);
			}
		}
	}, {
		key: '_canRenderSlotEditor',
		value: function _canRenderSlotEditor(content) {
			// in some edge cases, there is no `visualization` in `content`, we cannot display slot editor without `visualization`
			return !!(content && content.getFeature('Visualization'));
		}
	}, {
		key: '_renderEmptyState',
		value: function _renderEmptyState(SLOT_EDITOR_STATES, currentSlotEditorState) {
			switch (currentSlotEditorState) {
				case SLOT_EDITOR_STATES.EMPTY.NO_VIS_CREATED:
					return this._getEmptyState(_StringResources2.default.get('slotEditor_emptyState_vis_not_created_title'), _StringResources2.default.get('slotEditor_emptyState_vis_not_created_description'), _buildVisualization_2.default.id);
				case SLOT_EDITOR_STATES.EMPTY.NOT_SUPPORT_SLOTS:
					return this._getEmptyState(_StringResources2.default.get('slotEditor_emptyState_widget_not_support_slot_selected_title'), _StringResources2.default.get('slotEditor_emptyState_widget_not_support_slot_selected_description'), _nothingHere_2.default.id);
				case SLOT_EDITOR_STATES.EMPTY.NO_VIS_SELECTED:
					return this._getEmptyState(_StringResources2.default.get('slotEditor_emptyState_no_visualization_selected_title'), _StringResources2.default.get('slotEditor_emptyState_no_visualization_selected_description'), _buildVisualization_2.default.id);
				case SLOT_EDITOR_STATES.EMPTY.MUILTI_SELECTION:
					return this._getEmptyState(_StringResources2.default.get('slotEditor_emptyState_multiple_visualizations_selected_title'), _StringResources2.default.get('slotEditor_emptyState_multiple_visualizations_selected_description'), _nothingHere_2.default.id);
				case SLOT_EDITOR_STATES.EMPTY.ERROR:
					return this._getEmptyState(_StringResources2.default.get('slotEditor_emptyState_visualization_has_error_title'), null, _nothingHere_2.default.id);
				default:
					return this._getEmptyState();
			}
		}
	}, {
		key: '_getEmptyState',
		value: function _getEmptyState(title, description, iconId) {
			return _react2.default.createElement(_SlotEditorEmptyState2.default, {
				title: title,
				description: description,
				iconId: iconId
			});
		}

		/**
   * For the multi-layer case, we need to draw the layer headings and the slots per layer.
   * @param slotInfoByLayer - a structure containing the layerId and the array of slotAPI's assigned to that layer.
   */

	}, {
		key: '_renderLayersAndSlots',
		value: function _renderLayersAndSlots(slotInfoByLayer) {
			var _this2 = this;

			return slotInfoByLayer.map(function (slotInfoByLayerEntry) {
				if (!slotInfoByLayerEntry.isHideLayer) {
					return _react2.default.createElement(
						_caUiToolkit.Accordion,
						{ key: slotInfoByLayerEntry.layerId },
						_react2.default.createElement(
							_caUiToolkit.AccordionItem,
							{
								icon: 'right',
								itemName: slotInfoByLayerEntry.layerCaption,
								open: slotInfoByLayerEntry.open
							},
							_this2._renderSlots(slotInfoByLayerEntry.slotAPIs, slotInfoByLayerEntry.layerId, '__multilayer' /*customeClass*/)
						)
					);
				} else {
					return _this2._renderSlots(slotInfoByLayerEntry.slotAPIs);
				}
			});
		}

		/**
   * Called to render the data slots (or a single layer worth of slots for the multi-layer scenario).
   * @param slotAPIs - the slots to render
   * @param pLayerId - (optional) the layerId to render
   * @param className - (optional) the custom class name to render
   */

	}, {
		key: '_renderSlots',
		value: function _renderSlots(slotAPIs, pLayerId, className) {
			var _this3 = this;

			var layerId = pLayerId || '';
			return slotAPIs.map(function (slotAPI) {
				return slotAPI.getDefinition().isHidden() ? [] : _react2.default.createElement(_SlotEditorSlot2.default, {
					className: className,
					key: layerId + slotAPI.getDefinition().getId(),
					slotAPI: slotAPI,
					dataItemAPIs: slotAPI.getDataItemList(),
					a11Y: _this3.a11YHandler,
					slotDataItemHandler: _this3.props.slotEditorModel.getSlotDataItemHandler(slotAPI, -1),
					slotEditorModel: _this3.props.slotEditorModel,
					dndManager: _this3.props.dndManager
				});
			});
		}
	}]);

	return SlotEditorView;
}(_react.Component);

SlotEditorView.propTypes = {
	dndManager: _propTypes2.default.object.isRequired,
	slotEditorModel: _propTypes2.default.object.isRequired,
	extensions: _propTypes2.default.array
};

exports.default = (0, _mobxReact.observer)(SlotEditorView);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _caUiToolkit = __webpack_require__(3);

var _SlotEditorItem = __webpack_require__(45);

var _SlotEditorItem2 = _interopRequireDefault(_SlotEditorItem);

var _DndSlotItemHandler = __webpack_require__(22);

var _DndSlotItemHandler2 = _interopRequireDefault(_DndSlotItemHandler);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _SlotItemPlaceholder = __webpack_require__(28);

var _SlotItemPlaceholder2 = _interopRequireDefault(_SlotItemPlaceholder);

var _classnames = __webpack_require__(29);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SlotPlaceholderStateModel = __webpack_require__(68);

var _SlotPlaceholderStateModel2 = _interopRequireDefault(_SlotPlaceholderStateModel);

var _mobxStateTree = __webpack_require__(5);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var GlassUtils = __webpack_require__(30);


var _ = __webpack_require__(6); //TODO: should try to remove this dependency
var AGGREGATION_TYPE_MAP = {
	none: 'none',
	countDistinct: 'countDistinct'
};

/**
 * The SlotEditorSlot component is responsible for rendering a single slot and its items.
 * It also manages drag and drop of items or data to the 'slot heading region'.
 */

var SlotEditorSlot = function (_Component) {
	_inherits(SlotEditorSlot, _Component);

	function SlotEditorSlot(props) {
		_classCallCheck(this, SlotEditorSlot);

		var _this = _possibleConstructorReturn(this, (SlotEditorSlot.__proto__ || Object.getPrototypeOf(SlotEditorSlot)).call(this, props));

		_this._applySlotCoachMarks = _.debounce(function () {
			var _this$props = _this.props,
			    slot = _this$props.slotAPI,
			    _this$props$slotDataI = _this$props.slotDataItemHandler,
			    visualization = _this$props$slotDataI.visualization,
			    dashboardApi = _this$props$slotDataI.dashboardApi;

			var slotDef = slot.getDefinition();
			var coachMark = slotDef.getCoachMark();
			var slotId = slotDef.getId();
			var $slotEditorSlot = (0, _jquery2.default)(_this.slotEditorSlotRef.current);
			if (coachMark) {
				var isMapped = slot.getDataItemList().length > 0;
				if (!coachMark.mappedOnly || isMapped) {
					var $el = isMapped ? $slotEditorSlot.find('.slotEditorItem') : $slotEditorSlot;
					if ($el.length) {
						// Make the coachmark unique for each slot of every visualization
						var options = {
							id: visualization.getDefinition().getId() + '#' + slotId,
							$el: $el,
							title: _StringResources2.default.get(coachMark.titleResource),
							contents: _StringResources2.default.get(coachMark.contentResource),
							showPopover: coachMark.showPopover,
							placement: 'bottom'
						};
						dashboardApi.prepareGlassOptions(options);
						GlassUtils.addCoachmark(options);
					}
				}
			} else {
				var $coachMarkNode = $slotEditorSlot.find('.coachMark');
				if ($coachMarkNode.length) {
					var _coachMark = $coachMarkNode[0];
					var coachMarkParent = _coachMark.parentElement;
					if (coachMarkParent) {
						coachMarkParent.classList.remove('coachMarkContainer');
						coachMarkParent.removeAttribute('id');
						coachMarkParent.removeChild(_coachMark);
					}
				}
			}
		});

		_this._initializeDndSupport = function (node) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			//A data slot can be a drop target but not a dragdrop source.
			_this.props.dndManager.then(function (dndManager) {
				if (node) {
					_this.dropSlotItemHandler = new _DndSlotItemHandler2.default({
						domNode: node,
						className: 'dndHover',
						slotDataItemHandler: _this.props.slotDataItemHandler,
						addAfter: true, //The slot placeholder is assigned index -1.  "Dropping after nothing" means inserting before any (or no) items
						dndManager: dndManager,
						onDragEnter: options.onDragEnter,
						onDragLeave: options.onDragLeave
					});
					if (options.getDndManager) {
						options.getDndManager(dndManager);
					}
				}
			});
		};

		_this.slotEditorSlotRef = _react2.default.createRef();
		_this.slotPlaceholderStateModel = _SlotPlaceholderStateModel2.default.create({
			activePlaceholderExists: false
		});
		return _this;
	}

	_createClass(SlotEditorSlot, [{
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this.slotPlaceholderStateModel) {
				(0, _mobxStateTree.destroy)(this.slotPlaceholderStateModel);
			}
			this.dropSlotItemHandler && this.dropSlotItemHandler.destroy();
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this._applySlotCoachMarks();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			this._applySlotCoachMarks();
		}

		/**
   * Apply coach marks on the slot or data item
   * The slot coach mark consists with:
   * - showPopover: boolean flag indicating whether the popover show along with the coach mark.
   * - mappedOnly: boolean flag indicating whether the coach mark applies when the slot is mapped or
   * 		regardless of the mapped state.
   * - titleResource: resource name for the coach title.
   * - contentResource: resource name for the coach content.
   */

	}, {
		key: 'render',


		/**
   * Called to render the data slots (or a single layer worth of slots for the multi-layer scenario).
   * @param slotAPIs - the slots to render
   * @param pLayerId - (optional) the layerId to render
   * @param className - (optional) the custom class name to render
   */
		value: function render() {
			var _this2 = this;

			/* a custom class name will be added iff exists */
			var classes = (0, _classnames2.default)(_defineProperty({
				slotEditor__slots__slot: true
			}, '' + this.props.className, this.props.className));

			var slotDefinition = this.props.slotAPI.getDefinition();
			var slotCaption = slotDefinition.getCaption();
			var slotId = slotDefinition.getId();
			return _react2.default.createElement(
				'div',
				{ ref: this.slotEditorSlotRef, className: classes },
				_react2.default.createElement(
					'div',
					{ className: 'slotEditor__slots__slot__heading',
						'aria-label': slotCaption,
						title: slotCaption,
						role: 'Listbox',
						'data-slot-id': slotId,
						'aria-required': this._isRequiredField(this.props.slotAPI),
						onKeyUp: function onKeyUp(event) {
							return _this2.props.a11Y.slotHandleKeyUp(event, _this2.props.slotDataItemHandler);
						},
						onKeyPress: function onKeyPress(event) {
							return _this2.props.a11Y.handleKeyPress(event, _this2.props.slotDataItemHandler.swapSlotItems.bind(_this2.props.slotDataItemHandler), /*dropAfter*/true);
						} },
					_react2.default.createElement(
						'div',
						{ className: 'slotEditor__slots__slot__heading__container' },
						_react2.default.createElement(
							'div',
							{ className: 'slotEditor__slots__slot__heading__icon' },
							_react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: this._getSlotIcon(), size: 'small' })
						),
						this._isRequiredField(this.props.slotAPI) ? _react2.default.createElement(
							'div',
							{ className: 'slotEditor__slots__slot__heading__required' },
							_react2.default.createElement(
								'div',
								{ className: 'slotEditor__slots__slot__heading__required__caption' },
								slotCaption,
								_react2.default.createElement(
									'span',
									{ className: 'slotEditor__slots__slot__heading__required__caption__star' },
									'*'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'slotEditor__slots__slot__heading__required__text' },
								_StringResources2.default.get('slotEditorMsg1')
							)
						) : slotCaption
					),
					_react2.default.createElement(
						'div',
						{
							className: 'slotEditor__slots__slot__heading__dropBefore',
							tabIndex: '0'
						},
						this._renderSlotPlaceholder()
					)
				),
				this._renderSlotDataItems()
			);
		}
	}, {
		key: '_isRequiredField',
		value: function _isRequiredField(slotAPI) {
			return !slotAPI.getDefinition().isOptional() && slotAPI.getDefinition().getShowRequiredMarker();
		}
	}, {
		key: '_renderSlotPlaceholder',
		value: function _renderSlotPlaceholder() {
			if (this.props.slotDataItemHandler) {
				return _react2.default.createElement(_SlotItemPlaceholder2.default, {
					a11Y: this.props.a11Y,
					indexInSlot: this.props.slotDataItemHandler.indexInSlot,
					numberItemsInSlot: this.props.dataItemAPIs.length,
					canAcceptMoreItems: this.props.slotDataItemHandler.canAcceptMoreItems(),
					slotDataItemHandler: this.props.slotDataItemHandler,
					dashboardApi: this.props.slotEditorModel.dashboardApi,
					initializeDnd: this._initializeDndSupport.bind(this),
					slotPlaceholderStateModel: this.slotPlaceholderStateModel
				});
			}
		}

		/**
   * Render all data items assigned to this slot.
   */

	}, {
		key: '_renderSlotDataItems',
		value: function _renderSlotDataItems() {
			var _this3 = this;

			if (this.props.dataItemAPIs.length) {
				var slotHasUnavailableColumns = this.props.slotAPI.hasUnavailableMetadataColumns();
				return _.map(this.props.dataItemAPIs, function (dataItemAPI, indexInSlot) {
					var slotId = _this3.props.slotAPI.getDefinition().getId();

					return _react2.default.createElement(_SlotEditorItem2.default, { key: slotId + dataItemAPI.getId(),
						itemName: _this3._getSlotItemLabel(indexInSlot, slotHasUnavailableColumns),
						columnId: dataItemAPI.getColumnId(),
						dashboardApi: _this3.props.slotEditorModel.dashboardApi,
						slotPlaceholderStateModel: _this3.slotPlaceholderStateModel,
						slotDataItemHandler: _this3.props.slotEditorModel.getSlotDataItemHandler(_this3.props.slotAPI, indexInSlot),
						indexInSlot: indexInSlot,
						numberItemsInSlot: _this3.props.dataItemAPIs.length,
						a11Y: _this3.props.a11Y,
						dndManager: _this3.props.dndManager });
				});
			}
		}
	}, {
		key: '_getSlotItemLabel',
		value: function _getSlotItemLabel(itemIndex, slotHasUnavailableColumns) {
			var dataItem = this.props.slotAPI.getDataItemList()[itemIndex];
			var label = dataItem.getLabel();
			if (slotHasUnavailableColumns) {
				// check if the current data item is the missing one
				var metadataColumn = dataItem.getMetadataColumn();
				if (!metadataColumn) {
					label = _StringResources2.default.get('missingColumn', { 'columnLabel': label });
				}
			}
			return label;
		}
		/**
   * Slot icons are retrieved from the dashboard slots and definition.
   * If there is no icon assigned to the slot, the default for category or value is returned.
   * @param slotAPI - the slotAPI to return the icon for.
   */

	}, {
		key: '_getSlotIcon',
		value: function _getSlotIcon() {
			var iconId = this.props.slotAPI.getDefinition().getIcon();
			var iconsFeature = this.props.slotEditorModel.dashboardApi.getFeature('Icons');
			var icon = iconsFeature.getIcon(iconId);
			if (icon) {
				return icon.id;
			}
			return this._getFinalSlotType(this.props.slotAPI) === 'ordinal' ? iconsFeature.getIcon('values').id : iconsFeature.getIcon('category').id;
		}

		/**
  * Return the 'final slot type' ==> meaning that if the slot type is 'any' and data is mapped to the slot,
  * the type of the data will be used to infer the type of the slot.
  * (Not to be confused with getEffectiveType...see below)
  * @param slotAPI - the slotAPI of interest
  * @param [dataItemIndex=0] - the data item in question
  * @returns the final slot type for this slotAPI.
  * TODO: this api returns legacy slot types.  We need to change to categorical and continuous throughout the code.
  * This function is copied from the old SlotAPI.getFinalSlotType
  * Story 295271: Add missing API to get layer caption and to replace the old API slotAPI.itemsNotSupported
  */

	}, {
		key: '_getFinalSlotType',
		value: function _getFinalSlotType(slotAPI) {
			var dataItemIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

			var layerId = slotAPI.getDefinition().getDatasetIdList()[0];
			if (layerId === 'latitude' || layerId === 'longitude') {
				return 'category';
			}
			var slotType = slotAPI.getDefinition().getType();
			if (slotType === 'any') {
				if (this._isMultiMeasuresSlot(slotAPI)) {
					return 'category';
				}
				var mappedDataItem = slotAPI.getDataItemList()[dataItemIndex];
				if (mappedDataItem) {
					if (mappedDataItem.getBinning()) {
						return 'category';
					}
					if (mappedDataItem.getType() === 'attribute') {
						var dataItemAggregationType = mappedDataItem.getAggregation ? mappedDataItem.getAggregation() : mappedDataItem.getAggregationType && mappedDataItem.getAggregationType();
						if (dataItemAggregationType === AGGREGATION_TYPE_MAP.none) {
							return 'category';
						} else {
							return 'ordinal';
						}
					} else if (mappedDataItem.getType() === 'fact') {
						/**
       * - If one of the items in an 'any' slot is a measure, and we have more than one items,
       * then simply consider slot type to be category.
       * - Also look at the 'repeats' attribute by looking at the slot definition. If 'repeats'
       * attribute is there, then it means that we don't stack the data items in this slot. This
       * occurs in all non-VIPR visualizations.
       * - For al non-VIPR visualizations we don't want to enforce
       * the slot type to be a 'category', like we do for all VIPR visualizations.
       * This prevents issues described in defect #255087
       */
						// TODO: repeats (old API)
						if (slotAPI.getDataItemList().length > 1 && !slotAPI.getDefinition().repeats) {
							return 'category';
						} else {
							return 'ordinal';
						}
					}
				}
			}
			return slotType;
		}
	}, {
		key: '_isMultiMeasuresSlot',
		value: function _isMultiMeasuresSlot(slot) {
			return slot.getDataItemList().find(function (dataItem) {
				return dataItem.getColumnId() === '_multiMeasuresSeries';
			});
		}

		/** initializes drag and drop support for placeholder dropzone
   * that is attached to this slot
   * @param node - domNode that dropzone will be initialized on
   * @param options - object that contains callbacks to be passed to and executed in DndHandler
   * @param {Function} [options.onDragEnterExecute] - function to be executed when on Drag Enter event occurs
   * @param {Function} [options.onDragLeaveExecute] - function to be executed when on Drag Leave event occurs
   * @param {Function} [options.getDndManager] - a callback to get dndManager
   */

	}]);

	return SlotEditorSlot;
}(_react.Component);

SlotEditorSlot.propTypes = {
	className: _propTypes2.default.string,
	slotAPI: _propTypes2.default.object,
	dataItemAPIs: _propTypes2.default.array,
	slotEditorModel: _propTypes2.default.object.isRequired,
	dndManager: _propTypes2.default.object.isRequired,
	slotDataItemHandler: _propTypes2.default.object,
	a11Y: _propTypes2.default.object
};

exports.default = SlotEditorSlot;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(17);

var _DndSlotItemHandler = __webpack_require__(22);

var _DndSlotItemHandler2 = _interopRequireDefault(_DndSlotItemHandler);

var _FieldDropdown = __webpack_require__(23);

var _FieldDropdown2 = _interopRequireDefault(_FieldDropdown);

var _SlotEditorItemFlyout = __webpack_require__(27);

var _SlotEditorItemFlyout2 = _interopRequireDefault(_SlotEditorItemFlyout);

var _FieldItem = __webpack_require__(61);

var _FieldItem2 = _interopRequireDefault(_FieldItem);

var _SlotItemPlaceholder = __webpack_require__(28);

var _SlotItemPlaceholder2 = _interopRequireDefault(_SlotItemPlaceholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var MAX_HEIGHT = 500;
/**
 * The SlotEditorItem component is responsible for the User Interface for a single slot data item
 */

var SlotEditorItem = function (_Component) {
	_inherits(SlotEditorItem, _Component);

	function SlotEditorItem(props) {
		_classCallCheck(this, SlotEditorItem);

		var _this = _possibleConstructorReturn(this, (SlotEditorItem.__proto__ || Object.getPrototypeOf(SlotEditorItem)).call(this, props));

		_this._initializeDropAfterSupport = function (node, options) {
			return _this.props.dndManager.then(function (dndManager) {
				if (node) {
					//Initialize a drop handler 'after node'.
					//Also initialize the node as a drag source.
					_this._dndManager = dndManager;
					_this.dropSlotItemAfterHandler = new _DndSlotItemHandler2.default({
						domNode: node,
						className: 'dndHover',
						slotDataItemHandler: _this.props.slotDataItemHandler,
						addAfter: true,
						dndManager: dndManager,
						onDragEnter: options.onDragEnter,
						onDragLeave: options.onDragLeave
					});
					if (options.getDndManager) {
						options.getDndManager(dndManager);
					}
				}
			});
		};

		_this._showFlyout = function () {
			// don't show flyout when doing DND because the mui three flyout somehow mess up the drag object(see defect CADBLW-5243)
			// don't show flyout if slot menu is open
			if (_this.flyoutTooltipTimer) {
				return;
			}
			_this.flyoutTooltipTimer = setTimeout(function () {
				if (!_this._isDragging() && !_this.props.slotDataItemHandler.isSlotActionMenuOpened()) {
					_this.setState({
						isFlyoutShown: !_this.state.isTypeInMode
					});
				}
			}, 200);
		};

		_this._hideFlyout = function () {
			_this.setState({ isFlyoutShown: false });
			if (_this.flyoutTooltipTimer) {
				clearTimeout(_this.flyoutTooltipTimer);
				_this.flyoutTooltipTimer = null;
			}
		};

		_this._isDragging = function () {
			return !!(_this._dndManager && _this._dndManager.dragObject);
		};

		_this._slotItemTypeInOn = function () {
			_this.setState({
				isTypeInMode: true,
				isFlyoutShown: false
			});
		};

		_this._slotItemTypeInOff = function () {
			_this.setState({ isTypeInMode: false });
		};

		_this.triggerUpdateDnD = function () {
			_this._initializeDndSupport();
		};

		_this.state = {
			isFlyoutShown: false,
			isTypeInMode: false
		};
		_this.sourceId = _this.props.slotDataItemHandler.getDatasourceId();
		_this.flyoutTooltipTimer = null;
		return _this;
	}

	_createClass(SlotEditorItem, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this._initializeDndSupport();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps) {
			if (prevProps && prevProps.slotDataItemHandler !== this.props.slotDataItemHandler) {
				this.dropSlotItemHandler && this.dropSlotItemHandler.updateDropTarget(this.props.slotDataItemHandler);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.dropSlotItemHandler && this.dropSlotItemHandler.destroy();
		}

		/**
   * A slot item consists of the name, a menu (to launch actions), an itemValues section (for displaying local filters on that item)
   * and an additional 'dropAfter' region which is used to allow a user to drop after to augment a slots definition.
   */

	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				this._renderFlyout(),
				this.state.isTypeInMode && !this.props.slotDataItemHandler.isMeasureGroupItem() ? this._renderFieldDropdown() : _react2.default.createElement(_FieldItem2.default, {
					className: 'slotEditorItem',
					fieldName: this.props.itemName,
					onKeyPress: function onKeyPress(event) {
						return _this2.props.a11Y.handleKeyPress(event, _this2.props.slotDataItemHandler.swapSlotItems.bind(_this2.props.slotDataItemHandler), /*dropAfter*/false);
					},
					onKeyDown: function onKeyDown(event) {
						return _this2.props.a11Y.handleKeyDown(event, { slotDataItemHandler: _this2.props.slotDataItemHandler }, _this2._slotItemTypeInOn);
					},
					onKeyUp: function onKeyUp(event) {
						return _this2.props.a11Y.handleKeyUp(event, { slotDataItemHandler: _this2.props.slotDataItemHandler });
					},
					onMouseEnterCallBack: this._showFlyout.bind(this),
					onMouseLeaveCallBack: this._hideFlyout.bind(this),
					onClick: this._slotItemTypeInOn.bind(this),
					fieldGraphics: this.props.slotDataItemHandler.getGraphicData() ? this.props.slotDataItemHandler.getGraphicData() : undefined,
					showActionMenu: !this.props.slotDataItemHandler.isMeasureGroupItem(),
					onOpenActionMenu: !this.props.slotDataItemHandler.isMeasureGroupItem() ? this._slotActionMenu.bind(this) : undefined,
					filterInfo: this.props.slotDataItemHandler.getFilterStringAndNumber(),
					ref: function ref(fieldItem) {
						if (fieldItem && fieldItem.getDOMNode) {
							_this2.domNode = fieldItem.getDOMNode();
						}
					}
				}),
				_react2.default.createElement(
					'div',
					{ className: 'slotEditorItem__dropAfter',
						onKeyPress: function onKeyPress(event) {
							return _this2.props.a11Y.handleKeyPress(event, _this2.props.slotDataItemHandler.swapSlotItems.bind(_this2.props.slotDataItemHandler), /*dropAfter*/true);
						},
						onKeyUp: function onKeyUp(event) {
							return _this2.props.a11Y.slotHandleKeyUp(event, { slotDataItemHandler: _this2.props.slotDataItemHandler });
						}
					},
					_react2.default.createElement(_SlotItemPlaceholder2.default, {
						a11Y: this.props.a11Y,
						indexInSlot: this.props.indexInSlot,
						numberItemsInSlot: this.props.numberItemsInSlot,
						canAcceptMoreItems: this.props.slotDataItemHandler.canAcceptMoreItems(),
						slotDataItemHandler: this.props.slotDataItemHandler,
						dashboardApi: this.props.dashboardApi,
						slotPlaceholderStateModel: this.props.slotPlaceholderStateModel,
						initializeDnd: this._initializeDropAfterSupport.bind(this)
					})
				)
			);
		}

		//Drag and Drop Support.

	}, {
		key: '_initializeDndSupport',
		value: function _initializeDndSupport() {
			var _this3 = this;

			return this.props.dndManager.then(function (dndManager) {
				if (_this3.domNode) {
					//Initialize a drop handler for both the item node and the 'after node'.
					//Also initialize the node as a drag source.
					_this3._dndManager = dndManager;
					_this3.dropSlotItemHandler = new _DndSlotItemHandler2.default({
						domNode: _this3.domNode,
						className: 'dndHover',
						slotDataItemHandler: _this3.props.slotDataItemHandler,
						addAfter: false,
						dndManager: dndManager
					});

					//We need to set up a callback function when initializing the drag source so that the drag handler is always up-to-date.
					//(not the one at drag drop initialization time!)
					_this3.dropSlotItemHandler.initializeDndSource(_this3._dndManager, _this3._getSlotDataItemHandler.bind(_this3), _this3.props.dashboardApi.getFeature('Icons'), _this3._hideFlyout);
				}
			});
		}

		/** initializes drag and drop support for placeholder dropzone
   * that is attached to this item
   * @param node - domNode that dropzone will be initialized on
   * @param {Function} [options.onDragEnterExecute] - function to be executed when on Drag Enter event occurs
   * @param {Function} [options.onDragLeaveExecute] - function to be executed when on Drag Leave event occurs
   * @param {Function} [options.getDndManager] - a callback to get dndManager
   */

	}, {
		key: '_getSlotDataItemHandler',
		value: function _getSlotDataItemHandler() {
			return this.props.slotDataItemHandler;
		}
	}, {
		key: '_slotActionMenu',
		value: function _slotActionMenu() {
			this.props.slotDataItemHandler.openSlotActionMenu(this.domNode, {
				attachPoint: '.actionmenu',
				placement: 'bottom auto' //This string is important. Please see https://github.ibm.com/BusinessAnalytics/vis-slot-editor/pull/43 before changing.
			});
		}
	}, {
		key: '_renderFlyout',
		value: function _renderFlyout() {
			/* we dont't want to show tooltip if the item is measure group*/
			var shouldRenderFlyout = this.state.isFlyoutShown && this.domNode && !this.props.slotDataItemHandler.isMeasureGroupItem();
			if (shouldRenderFlyout) {
				return _react2.default.createElement(_SlotEditorItemFlyout2.default, {
					domNode: this.domNode,
					dashboardApi: this.props.dashboardApi,
					columnId: this.props.columnId,
					sourceId: this.sourceId,
					onClose: this._hideFlyout
				});
			}
		}
	}, {
		key: '_renderFieldDropdown',
		value: function _renderFieldDropdown() {
			if (this.state.isTypeInMode && !this.props.slotDataItemHandler.isMeasureGroupItem()) {
				return _react2.default.createElement(_FieldDropdown2.default, {
					a11Y: this.props.a11Y,
					open: this.state.isTypeInMode,
					textValue: this.props.itemName,
					dashboardApi: this.props.dashboardApi,
					getDropdownMaxHeight: this.getDropdownMaxHeight,
					onBlur: this._slotItemTypeInOff,
					onItemSelected: this.triggerUpdateDnD,
					slotDataItemHandler: this.props.slotDataItemHandler,
					sourceId: this.sourceId,
					replaceSlotItem: true
				});
			}
		}
	}, {
		key: 'getDropdownMaxHeight',
		value: function getDropdownMaxHeight() {
			return MAX_HEIGHT;
		}
	}]);

	return SlotEditorItem;
}(_react.Component);

SlotEditorItem.propTypes = {
	slotPlaceholderStateModel: _propTypes2.default.object.isRequired,
	itemName: _propTypes2.default.string,
	indexInSlot: _propTypes2.default.number.isRequired,
	numberItemsInSlot: _propTypes2.default.number.isRequired,
	itemValues: _propTypes2.default.string,
	dashboardApi: _propTypes2.default.object,
	columnId: _propTypes2.default.string,
	slotDataItemHandler: _propTypes2.default.object.isRequired,
	a11Y: _propTypes2.default.object,
	dndManager: _propTypes2.default.object.isRequired
};

exports.default = SlotEditorItem;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2018, 2020\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.slotEditor:not(.is-old) {\n  overflow-y: auto;\n  height: 100%;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots .ba-common-accordion:first-child {\n  border-top: 1px solid;\n  border-top-color: #f4f4f4;\n  border-top-color: hsla(var(--ui-02-h, 0), var(--ui-02-s, 0%), var(--ui-02-l, 95.68627%), 1);\n  margin-top: 40px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots .ba-common-accordion {\n  border-top: none;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots .ba-common-accordionItem__button {\n  width: auto;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  margin-top: 16px;\n  margin-right: 16px;\n  margin-left: 16px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot:first-child {\n  margin-top: 24px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot.__multilayer {\n  margin-right: 0;\n  margin-left: 0;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot.__multilayer:first-child {\n  margin-top: 0;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__dropzone {\n  padding: 0 16px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__dropzone {\n  padding: 0 16px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: column;\n      flex-flow: column;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading__container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  font-size: 0.875rem;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading__indent {\n  width: 16px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading__icon {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-right: 8px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading__icon svg {\n  fill: #161616;\n  fill: hsla(var(--icon-01-h, 0), var(--icon-01-s, 0%), var(--icon-01-l, 8.62745%), 1);\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading__required {\n  -ms-flex: 1 0 auto;\n      flex: 1 0 auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: baseline;\n      align-items: baseline;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading__required__caption {\n  font-weight: 600;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading__required__caption__star {\n  color: #da1e28;\n  color: hsla(var(--support-01-h, 356.80851), var(--support-01-s, 75.80645%), var(--support-01-l, 48.62745%), 1);\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading__required__text {\n  font-size: 0.75rem;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot > .coachMark {\n  top: 30px;\n  right: 80px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots .bi-mui-moserObjectTree {\n  max-height: 500px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters {\n  margin-right: 16px;\n  margin-left: 16px;\n  margin-top: 24px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters.dndHover {\n  background-color: rgba(15, 98, 254, 0.2);\n  background-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 0.2);\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters__heading__container {\n  font-size: 0.875rem;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding-bottom: 8px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters__heading__icon {\n  padding-right: 8px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters__item {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  margin-bottom: 8px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters__item .bi-common-field-item {\n  padding-left: 16px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters__item .bi-common-field-item__nameLine__fieldName {\n  margin-left: 0px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters__item .bi-common-field-item__infoLine__values {\n  margin-left: 0px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters .bi-mui-moserObjectTree {\n  max-height: 500px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__footer__line {\n  padding-top: 16px;\n  font-size: 14px;\n  display: -ms-flexbox;\n  display: flex;\n  color: #393939;\n  color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n}\n\n.slotEditor:not(.is-old) .slotEditor__footer__line__icon {\n  margin-right: 8px;\n  margin-left: 16px;\n  color: #8d8d8d;\n  color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n}\n\n.slotEditor:not(.is-old) .ba-common-baseInput > input {\n  box-sizing: border-box;\n}\n\n.highcontrast .slotEditorItem:not(.is-old) {\n  border: 1px solid;\n}\n\n.highcontrast .slotEditor:not(.is-old) .slotEditor__localFilters.dndHover {\n  outline-width: 2px;\n  outline-style: dotted;\n  outline-color: white;\n  outline-color: hsla(var(--inverse-focus-ui-h, 0), var(--inverse-focus-ui-s, 0%), var(--inverse-focus-ui-l, 100%), 1);\n}\n\n.slotEditorItem:not(.is-old) {\n  cursor: pointer;\n}\n\n.slotEditorItem:not(.is-old).selected {\n  border: 2px solid;\n  border-color: #8d8d8d;\n  border-color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n}\n\n.slotEditorItem:not(.is-old).dndHover {\n  outline: #2d74da solid 2px;\n}\n\n.slotEditorItem:not(.is-old).dndHover .bi-common-field-item__nameLine__fieldName .ba-common-truncatedText__text {\n  text-decoration: underline;\n  color: #0f62fe;\n  color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n}\n\n.slotEditorItem:not(.is-old).action-menu-opened {\n  pointer-events: none;\n}\n\n.slotEditorItem:not(.is-old).draggedNode:hover {\n  background-color: #f4f4f4;\n  background-color: hsla(var(--ui-02-h, 0), var(--ui-02-s, 0%), var(--ui-02-l, 95.68627%), 1);\n}\n\n.slotEditorItem:not(.is-old) > .coachMark {\n  top: 10px;\n  right: -10px;\n}\n\n.slotEditorItem:not(.is-old) .nodrop {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n}\n\n.slotEditorItem:not(.is-old) .nodrop.is-hidden {\n  visibility: hidden;\n}\n\n.slotEditorItem:not(.is-old) .nodrop .svgIcon {\n  height: 16px;\n  width: 16px;\n}\n\n.slotEditorItem:not(.is-old).has-filters .nodrop {\n  -ms-flex-item-align: end;\n      align-self: flex-end;\n}\n\n.slotEditorItem__disambiguatingTooltip {\n  min-width: 240px;\n  text-align: left;\n  padding-bottom: 5px;\n}\n\n.slotEditorItem__disambiguatingTooltipTitle {\n  min-width: 240px;\n  padding-left: 8px;\n  padding-top: 5px;\n}\n\n", ""]);

// exports


/***/ }),
/* 47 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(24),
    now = __webpack_require__(49),
    toNumber = __webpack_require__(51);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(25);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(52),
    isObject = __webpack_require__(24),
    isSymbol = __webpack_require__(54);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(53);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(55),
    isObjectLike = __webpack_require__(58);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(26),
    getRawTag = __webpack_require__(56),
    objectToString = __webpack_require__(57);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(26);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(60);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./fieldDropdown.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./fieldDropdown.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.slotEditor .dropdownWrapper {\n  width: 100%;\n  min-width: 96px;\n  position: relative;\n}\n\n.slotEditor .dropdownWrapper .dropdown {\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n  box-shadow: 0 2px 8px 0 #eaeaea;\n  position: absolute;\n  width: 100%;\n}\n\n.slotEditor .ba-common-accordionItem__collapse .ReactCollapse--content {\n  overflow-x: inherit;\n  overflow-y: inherit;\n}\n\n", ""]);

// exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp; /**
                    * Licensed Materials - Property of IBM
                    * IBM Watson Analytics (C) Copyright IBM Corp. 2020
                    * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                    */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _underscore = __webpack_require__(6);

var _underscore2 = _interopRequireDefault(_underscore);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(62);

var _caUiToolkit = __webpack_require__(3);

var _overflowMenuVertical_ = __webpack_require__(64);

var _overflowMenuVertical_2 = _interopRequireDefault(_overflowMenuVertical_);

var _draggable_ = __webpack_require__(65);

var _draggable_2 = _interopRequireDefault(_draggable_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The common FieldItem component
 */
var FieldItem = (_temp = _class = function (_Component) {
	_inherits(FieldItem, _Component);

	function FieldItem() {
		_classCallCheck(this, FieldItem);

		return _possibleConstructorReturn(this, (FieldItem.__proto__ || Object.getPrototypeOf(FieldItem)).apply(this, arguments));
	}

	_createClass(FieldItem, [{
		key: 'getDOMNode',
		value: function getDOMNode() {
			return this.domNode;
		}
	}, {
		key: '_renderFilterStringAndNumber',
		value: function _renderFilterStringAndNumber(filterInfo) {
			var _ref = filterInfo || {},
			    filterString = _ref.filterString,
			    numberOfFilterItems = _ref.numberOfFilterItems;

			if (filterString) {
				return _react2.default.createElement(
					'div',
					{ className: 'bi-common-field-item__infoLine' },
					_react2.default.createElement(
						'div',
						{ className: 'bi-common-field-item__infoLine__values' },
						_react2.default.createElement(_caUiToolkit.TruncatedText, { value: filterString })
					),
					numberOfFilterItems ? _react2.default.createElement(
						'div',
						{ className: 'bi-common-field-item__infoLine__badge' },
						numberOfFilterItems
					) : null
				);
			}

			return null;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    fieldName = _props.fieldName,
			    className = _props.className,
			    draggable = _props.draggable,
			    showActionMenu = _props.showActionMenu,
			    onOpenActionMenu = _props.onOpenActionMenu,
			    fieldGraphics = _props.fieldGraphics,
			    filterInfo = _props.filterInfo;

			var forwardedProps = _underscore2.default.omit(this.props, 'className', 'children', 'fieldName', 'draggable', 'showActionMenu', 'onOpenActionMenu', 'fieldGraphics', 'filterInfo');
			var hasFilters = !!(filterInfo && filterInfo.filterString);
			var classNames = (0, _caUiToolkit.classnames)('bi-common-field-item', {
				'has-filters': hasFilters,
				'is-draggable': draggable
			});

			return _react2.default.createElement(
				'div',
				_extends({
					className: className ? classNames + ' ' + className : classNames,
					'aria-label': fieldName,
					tabIndex: '0',
					ref: function ref(node) {
						_this2.domNode = node;
					}
				}, forwardedProps),
				_react2.default.createElement(
					'div',
					{ className: 'bi-common-field-item__nameLine' },
					draggable && _react2.default.createElement(
						'div',
						{ className: 'bi-common-field-item__nameLine__draggable' },
						_react2.default.createElement(_caUiToolkit.SVGIcon, { size: 'small', iconId: _draggable_2.default.id })
					),
					_react2.default.createElement(
						'div',
						{ className: 'bi-common-field-item__nameLine__fieldName',
							onMouseEnter: this.props.onMouseEnterCallBack,
							onMouseLeave: this.props.onMouseLeaveCallBack },
						hasFilters ? _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(_caUiToolkit.TruncatedText, { location: 'middle', style: { fontWeight: 'bold' }, value: fieldName })
						) : _react2.default.createElement(_caUiToolkit.TruncatedText, { location: 'middle', style: { fontWeight: 'normal' }, value: fieldName })
					),
					fieldGraphics && _react2.default.createElement(
						'div',
						{ className: 'bi-common-field-item__nameLine__icon' },
						_react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: fieldGraphics } })
					),
					showActionMenu && _react2.default.createElement(
						'div',
						{
							className: 'bi-common-field-item__nameLine__actionMenu',
							tabIndex: 0,
							onKeyPress: function onKeyPress(e) {
								e.stopPropagation();
								onOpenActionMenu(e);
							},
							onClick: function onClick(e) {
								e.stopPropagation();
								onOpenActionMenu(e);
							}
						},
						_react2.default.createElement(_caUiToolkit.SVGIcon, { size: 'small', iconId: _overflowMenuVertical_2.default.id }),
						_react2.default.createElement('div', { className: 'actionmenu' })
					)
				),
				this._renderFilterStringAndNumber(filterInfo)
			);
		}
	}]);

	return FieldItem;
}(_react.Component), _class.propTypes = {
	className: _propTypes2.default.string,
	fieldName: _propTypes2.default.string.isRequired,
	draggable: _propTypes2.default.bool,
	showActionMenu: _propTypes2.default.bool,
	onOpenActionMenu: _propTypes2.default.func,
	fieldGraphics: _propTypes2.default.node,
	filterInfo: _propTypes2.default.object,
	onMouseEnterCallBack: _propTypes2.default.func,
	onMouseLeaveCallBack: _propTypes2.default.func
}, _class.defaultProps = {
	className: '',
	draggable: true,
	showActionMenu: true,
	onOpenActionMenu: function onOpenActionMenu() {},
	fieldGraphics: null,
	filterInfo: null
}, _temp);
exports.default = FieldItem;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(63);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./FieldItem.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./FieldItem.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/**\n * Licensed Materials - Property of IBM\n * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2020\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n.slotEditor .bi-common-field-item {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: column;\n      flex-flow: column;\n  padding-left: 8px;\n  -ms-flex-align: stretch;\n      align-items: stretch;\n  background-color: #f4f4f4;\n  background-color: hsla(var(--ui-02-h, 0), var(--ui-02-s, 0%), var(--ui-02-l, 95.68627%), 1);\n}\n\n.slotEditor .bi-common-field-item.is-draggable {\n  cursor: move;\n}\n\n.slotEditor .bi-common-field-item.is-draggable .bi-common-field-item__nameLine__fieldName {\n  margin-left: 8px;\n}\n\n.slotEditor .bi-common-field-item:hover {\n  background-color: #e5e5e5;\n  background-color: hsla(var(--hover-ui-h, 0), var(--hover-ui-s, 0%), var(--hover-ui-l, 89.80392%), 1);\n}\n\n.slotEditor .bi-common-field-item.has-filters .bi-common-field-item__nameLine {\n  height: 32px;\n}\n\n.slotEditor .bi-common-field-item.has-filters .bi-common-field-item__nameLine__draggable {\n  -ms-flex-item-align: end;\n      align-self: flex-end;\n}\n\n.slotEditor .bi-common-field-item__nameLine {\n  height: 40px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row;\n      flex-flow: row;\n  -ms-flex-align: center;\n      align-items: center;\n  font-size: 0.875rem;\n}\n\n.slotEditor .bi-common-field-item__nameLine__draggable {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n}\n\n.slotEditor .bi-common-field-item__nameLine__fieldName {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  margin-right: 8px;\n  margin-left: 24px;\n}\n\n.slotEditor .bi-common-field-item__nameLine__icon {\n  margin-right: 8px;\n  margin-left: 8px;\n  width: 16px;\n  height: 16px;\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n}\n\n.slotEditor .bi-common-field-item__nameLine__actionMenu {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  cursor: pointer;\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  padding: 8px;\n}\n\n.slotEditor .bi-common-field-item__infoLine {\n  font-size: 0.75rem;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  height: 24px;\n  margin-right: 6px;\n}\n\n.slotEditor .bi-common-field-item__infoLine__values {\n  margin-left: 24px;\n  margin-right: 8px;\n  -ms-flex: 0 1 auto;\n      flex: 0 1 auto;\n}\n\n.slotEditor .bi-common-field-item__infoLine__badge {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  border-radius: 100%;\n  width: 20px;\n  height: 20px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  background-color: #525252;\n  background-color: hsla(var(--icon-02-h, 0), var(--icon-02-s, 0%), var(--icon-02-l, 32.15686%), 1);\n  color: white;\n  color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n}\n\n", ""]);

// exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, o) {
  if ("object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module))) module.exports = o(__webpack_require__(8));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (o),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {
    var c = o("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? require("@ba-ui-toolkit/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js") : e["@ba-ui-toolkit/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for (var i in c) {
      ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports : e)[i] = c[i];
    }
  }
}("undefined" != typeof self ? self : undefined, function (e) {
  return webpackJsonPBaGraphics([787], { "3865314c5959606874d4": function c5959606874d4(o, c) {
      o.exports = e;
    }, "7c2db376ce0d1f5bdc4b": function c2db376ce0d1f5bdc4b(e, o, c) {
      "use strict";
      Object.defineProperty(o, "__esModule", { value: !0 });var i = c("3865314c5959606874d4"),
          s = (c.n(i), c("80e093a7dfdd5dade304"));o.default = s.a;
    }, "80e093a7dfdd5dade304": function e093a7dfdd5dade304(e, o, c) {
      "use strict";
      var i = c("9689a9c94ae38b47fa2c"),
          s = c.n(i),
          t = c("9ce58a7deea14f49ef01"),
          a = c.n(t),
          n = new s.a({ id: "overflow-menu--vertical_16_v7", use: "overflow-menu--vertical_16_v7-usage", viewBox: "0 0 16 16", content: '<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="overflow-menu--vertical_16_v7"><circle cx="8" cy="3" r="1" /><circle cx="8" cy="8" r="1" /><circle cx="8" cy="13" r="1" /><path style="fill:none" d="M0 0h16v16H0z" /></symbol>' });a.a.add(n);o.a = n;
    } }, ["7c2db376ce0d1f5bdc4b"]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)(module)))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, o) {
  if ("object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module))) module.exports = o(__webpack_require__(8));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (o),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {
    var a = o("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? require("@ba-ui-toolkit/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js") : e["@ba-ui-toolkit/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for (var s in a) {
      ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports : e)[s] = a[s];
    }
  }
}("undefined" != typeof self ? self : undefined, function (e) {
  return webpackJsonPBaGraphics([1314], { "3865314c5959606874d4": function c5959606874d4(o, a) {
      o.exports = e;
    }, b51c98ef9181e63d4df5: function b51c98ef9181e63d4df5(e, o, a) {
      "use strict";
      Object.defineProperty(o, "__esModule", { value: !0 });var s = a("3865314c5959606874d4"),
          i = (a.n(s), a("ba424a47b2434622aaec"));o.default = i.a;
    }, ba424a47b2434622aaec: function ba424a47b2434622aaec(e, o, a) {
      "use strict";
      var s = a("9689a9c94ae38b47fa2c"),
          i = a.n(s),
          t = a("9ce58a7deea14f49ef01"),
          c = a.n(t),
          n = new i.a({ id: "draggable_16_v7", use: "draggable_16_v7-usage", viewBox: "0 0 16 16", content: '<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="draggable_16_v7"><path d="M5 3h2v2H5zm4 0h2v2H9zM5 7h2v2H5zm4 0h2v2H9zm-4 4h2v2H5zm4 0h2v2H9z" /><path style="fill:none" d="M0 0h16v16H0z" /></symbol>' });c.a.add(n);o.a = n;
    } }, ["b51c98ef9181e63d4df5"]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)(module)))

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(67);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./slotItemPlaceholder.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./slotItemPlaceholder.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.slotPlaceholder__hoverIndicator {\n  height: 8px;\n  width: inherit;\n}\n\n.slotPlaceholder__itemPlaceholder {\n  height: 40px;\n  border-style: dashed;\n  border-width: 1px;\n  border-color: #8d8d8d;\n  border-color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n  margin-bottom: 8px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n\n.slotPlaceholder__itemPlaceholder__actionLabel {\n  color: #a8a8a8;\n  color: hsla(var(--text-03-h, 0), var(--text-03-s, 0%), var(--text-03-l, 65.88235%), 1);\n  font-size: 0.75rem;\n  text-align: center;\n}\n\n.slotPlaceholder.dndHover .slotPlaceholder__itemPlaceholder {\n  border: 2px solid;\n  color: #0f62fe;\n  color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n}\n\n.slotPlaceholder.dndHover .slotPlaceholder__itemPlaceholder__actionLabel {\n  color: #0f62fe;\n  color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  text-decoration: underline;\n}\n\n", ""]);

// exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _mobxStateTree = __webpack_require__(5);

exports.default = _mobxStateTree.types.model('SlotPlaceholderStateModel', {
	activePlaceholderExists: _mobxStateTree.types.optional(_mobxStateTree.types.boolean, false)
}).views(function (self) {
	return {
		/**
   * @return {boolean} activePlaceholderExists
   */
		getActivePlaceholderExists: function getActivePlaceholderExists() {
			return self.activePlaceholderExists;
		}
	};
}).actions(function (self) {
	return {
		setActivePlaceholderExists: function setActivePlaceholderExists(activePlaceholderExists) {
			self.activePlaceholderExists = activePlaceholderExists;
		}
	};
}); /*
     *+------------------------------------------------------------------------+
     *| Licensed Materials - Property of IBM
     *| IBM Cognos Products: Explore
     *| (C) Copyright IBM Corp. 2020
     *|
     *| US Government Users Restricted Rights - Use, duplication or disclosure
     *| restricted by GSA ADP Schedule Contract with IBM Corp.
     *+------------------------------------------------------------------------+
     */

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A11YUtils = exports.A11YDirection = exports.A11YCollections = undefined;

var _Collections = __webpack_require__(70);

var _Collections2 = _interopRequireDefault(_Collections);

var _Direction = __webpack_require__(71);

var _Direction2 = _interopRequireDefault(_Direction);

var _Utils = __webpack_require__(72);

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.A11YCollections = _Collections2.default;
exports.A11YDirection = _Direction2.default;
exports.A11YUtils = _Utils2.default; /*
                                      *+------------------------------------------------------------------------+
                                      *| Licensed Materials - Property of IBM
                                      *| IBM Cognos Products: Explore
                                      *| (C) Copyright IBM Corp. 2018
                                      *|
                                      *| US Government Users Restricted Rights - Use, duplication or disclosure
                                      *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                      *+------------------------------------------------------------------------+
                                      */

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(6);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var A11YCollections = function () {
	function A11YCollections(options) {
		_classCallCheck(this, A11YCollections);

		if (Array.isArray(options.direction)) {
			this.direction = options.direction;
		} else {
			this.direction = [options.direction];
		}

		this.adapters = {
			elements: options.handlers.elements,
			container: options.handlers.container
		};
	}

	_createClass(A11YCollections, [{
		key: 'onKeyDown',
		value: function onKeyDown(event) {
			for (var i = 0; i < this.direction.length; i++) {
				var direction = this.direction[i];

				switch (event.key) {
					case direction.previous:
						this._handleFocusPrevious(event);
						return;
					case direction.next:
						this._handleFocusNext(event);
						return;
				}
			}
		}
	}, {
		key: '_handleFocusPrevious',
		value: function _handleFocusPrevious(event) {
			if (this._getContainer(event.target).length > 0) {
				this._cycleFocus(event, -1);

				event.preventDefault();
			}
		}
	}, {
		key: '_handleFocusNext',
		value: function _handleFocusNext(event) {
			if (this._getContainer(event.target).length > 0) {
				this._cycleFocus(event, 1);

				event.preventDefault();
			}
		}

		/// Adapters

	}, {
		key: '_getElements',
		value: function _getElements(element) {
			if (_underscore2.default.isFunction(this.adapters.elements)) {
				return (0, _jquery2.default)(this.adapters.elements(element));
			}
			return (0, _jquery2.default)(this.adapters.elements);
		}
	}, {
		key: '_getContainer',
		value: function _getContainer(element) {
			if (this.adapters.container) {
				return (0, _jquery2.default)(this.adapters.container(element));
			}
			return (0, _jquery2.default)(element);
		}

		/// Private

	}, {
		key: '_cycleFocus',
		value: function _cycleFocus(event, increment) {
			var index = this._getContainer(event.target).index();

			this._focus(this._getElements(event.target), index + increment);
		}
	}, {
		key: '_focus',
		value: function _focus(items, index) {
			if (index >= items.length) {
				// Loop back to the first element.
				index = 0;
			}

			items.eq(index).focus();
		}
	}]);

	return A11YCollections;
}();

exports.default = A11YCollections;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

var Direction = {
  UP_DOWN: {
    previous: 'ArrowUp',
    next: 'ArrowDown'
  },
  LEFT_RIGHT: {
    previous: 'ArrowLeft',
    next: 'ArrowRight'
  }
};

exports.default = Direction;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
/**
 * Check if the event is Ctrl + V
 * @param {object} event 
 */
var A11YUtils = function () {
  function A11YUtils() {
    _classCallCheck(this, A11YUtils);
  }

  _createClass(A11YUtils, null, [{
    key: "isPaste",
    value: function isPaste(event) {
      return event.keyCode === 86 && (event.ctrlKey || event.metaKey);
    }
  }]);

  return A11YUtils;
}();

exports.default = A11YUtils;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (a, s) {
  if ("object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module))) module.exports = s(__webpack_require__(33));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(33)], __WEBPACK_AMD_DEFINE_FACTORY__ = (s),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {
    var c = s("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? require("@ba-ui-toolkit/ba-graphics/dist/illustrations-js/ba-graphics-icons-commons.js") : a["@ba-ui-toolkit/ba-graphics/dist/illustrations-js/ba-graphics-icons-commons.js"]);for (var i in c) {
      ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports : a)[i] = c[i];
    }
  }
}("undefined" != typeof self ? self : undefined, function (a) {
  return webpackJsonPBaGraphics([60], { "3865314c5959606874d4": function c5959606874d4(s, c) {
      s.exports = a;
    }, "9612edcdbcc934e7f1ff": function edcdbcc934e7f1ff(a, s, c) {
      "use strict";
      Object.defineProperty(s, "__esModule", { value: !0 });var i = c("3865314c5959606874d4"),
          r = (c.n(i), c("dd3d8884a737f47c10b1"));s.default = r.a;
    }, dd3d8884a737f47c10b1: function dd3d8884a737f47c10b1(a, s, c) {
      "use strict";
      var i = c("9689a9c94ae38b47fa2c"),
          r = c.n(i),
          e = c("9ce58a7deea14f49ef01"),
          t = c.n(e),
          h = new r.a({ id: "nothing-here_128_v7", use: "nothing-here_128_v7-usage", viewBox: "0 0 200 200", content: '<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" id="nothing-here_128_v7"><circle class="ba-graphics-neutral-white4" cx="100" cy="100" r="100" /><path class="ba-graphics-white" d="M14.97 170.08h135.66" /><path class="ba-graphics-gray60" d="M150.63 172.08H15a2 2 0 110-4h135.63a2 2 0 010 4z" /><path class="ba-graphics-white" d="M2 170.08h4.97" /><path class="ba-graphics-gray60" d="M7 172.08H2a2 2 0 010-4h5a2 2 0 010 4z" /><path class="ba-graphics-white" d="M179.03 170.08H198" /><path class="ba-graphics-gray60" d="M198 172.08h-19a2 2 0 010-4h19a2 2 0 010 4z" /><path class="ba-graphics-white" d="M158.63 170.08h12.4" /><path class="ba-graphics-gray60" d="M171 172.08h-12.4a2 2 0 010-4H171a2 2 0 010 4z" /><path class="ba-graphics-white" d="M30.17 46.52h139.57a6.21 6.21 0 016.26 6.21v96.79a4 4 0 01-4 4H28a4 4 0 01-4-4V52.73a6.21 6.21 0 016.17-6.21z" /><path class="ba-graphics-gray60" d="M169.74 50.34a2.39 2.39 0 012.39 2.39v96.79a.18.18 0 01-.18.18H28a.18.18 0 01-.18-.18V52.73a2.4 2.4 0 012.4-2.39h139.52m0-3.82H30.17A6.22 6.22 0 0024 52.73v96.79a4 4 0 004 4h144a4 4 0 004-4V52.73a6.21 6.21 0 00-6.21-6.21z" /><path class="ba-graphics-gray1" d="M176 67.28v-16.8a4 4 0 00-4-4H28a4 4 0 00-4 4v16.8z" /><path class="ba-graphics-gray60" d="M172 50.3a.18.18 0 01.18.18v13H27.77v-13a.18.18 0 01.23-.18h144m0-3.82H28a4 4 0 00-4 4v16.8h152v-16.8a4 4 0 00-4-4z" /><circle class="ba-graphics-gray60" cx="34.07" cy="56.82" r="2" /><circle class="ba-graphics-gray60" cx="41.21" cy="56.82" r="2" /><circle class="ba-graphics-gray60" cx="48.34" cy="56.82" r="2" /><circle class="ba-graphics-gray60" cx="104.65" cy="20.58" r="2" /><circle class="ba-graphics-gray60" cx="141.96" cy="31.17" r="2" /><path class="ba-graphics-gray60" d="M61.33 27.91a4 4 0 004-4 1 1 0 112 0 4 4 0 004 4 1 1 0 010 2 4 4 0 00-4 4 1 1 0 01-2 0 4 4 0 00-4-4 1 1 0 010-2z" /><path class="ba-graphics-white" d="M88.66 128.74h19.08" /><path class="ba-graphics-gray60" d="M107.74 130.74H88.65a2 2 0 010-4h19.09a2 2 0 010 4z" /><circle class="ba-graphics-gray60" cx="75.32" cy="117.69" r="3.47" /><circle class="ba-graphics-gray60" cx="121" cy="117.69" r="3.47" /></symbol>' });t.a.add(h);s.a = h;
    } }, ["9612edcdbcc934e7f1ff"]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)(module)))

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(75);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./slotEditorEmptyState.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./slotEditorEmptyState.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2019\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.slotEditorEmpty__description {\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.125rem;\n}\n\n.slotEditorEmpty {\n  height: 100%;\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n.slotEditorEmpty__container {\n  margin: auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  width: 100%;\n}\n\n.slotEditorEmpty__icon {\n  padding: 4px 24px;\n}\n\n.slotEditorEmpty__title {\n  display: block;\n  padding: 4px 24px;\n  font-weight: 700;\n  line-height: 1.25rem;\n}\n\n.slotEditorEmpty__description {\n  display: block;\n  padding: 4px 24px;\n}\n\n", ""]);

// exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(12);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _SlotEditorSlot = __webpack_require__(77);

var _SlotEditorSlot2 = _interopRequireDefault(_SlotEditorSlot);

var _SlotEditorA11YHandler = __webpack_require__(31);

var _SlotEditorA11YHandler2 = _interopRequireDefault(_SlotEditorA11YHandler);

var _caUiToolkit = __webpack_require__(3);

var _information_ = __webpack_require__(81);

var _information_2 = _interopRequireDefault(_information_);

var _buildVisualization_ = __webpack_require__(32);

var _buildVisualization_2 = _interopRequireDefault(_buildVisualization_);

var _nothingHere_ = __webpack_require__(82);

var _nothingHere_2 = _interopRequireDefault(_nothingHere_);

var _SlotEditorEmptyState = __webpack_require__(34);

var _SlotEditorEmptyState2 = _interopRequireDefault(_SlotEditorEmptyState);

var _mobxStateTree = __webpack_require__(5);

var _ScrollableDragHandler = __webpack_require__(35);

var _ScrollableDragHandler2 = _interopRequireDefault(_ScrollableDragHandler);

__webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2019, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * The SlotEditor View
 */
var SlotEditorView = function (_Component) {
	_inherits(SlotEditorView, _Component);

	function SlotEditorView(props) {
		_classCallCheck(this, SlotEditorView);

		//Handle slot-editor-specific accessibility actions (eg swapping slot items etc.)
		var _this = _possibleConstructorReturn(this, (SlotEditorView.__proto__ || Object.getPrototypeOf(SlotEditorView)).call(this, props));

		_this._initializeScrollDragSupport = function () {
			var dndManagerPromise = _this.props.dndManager;

			dndManagerPromise && dndManagerPromise.then(function (dndManager) {
				if (_this.slotEditorRef.current) {
					_this.scrollableDragHandler = new _ScrollableDragHandler2.default({
						scrollableContainer: _this.slotEditorRef.current,
						dndManager: dndManager
					});
					dndManager.addDropTarget(_this.slotEditorRef.current, _this.scrollableDragHandler);
				}
			});
		};

		_this.a11YHandler = new _SlotEditorA11YHandler2.default();
		_this.state = {
			needsRefresh: null
		};
		_this.slotEditorRef = _react2.default.createRef();
		return _this;
	}

	_createClass(SlotEditorView, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this._initializeScrollDragSupport();
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{
					ref: this.slotEditorRef,
					className: 'slotEditor is-old'
				},
				this.renderContent()
			);
		}
	}, {
		key: 'renderContent',
		value: function renderContent() {
			var slotEditorModel = this.props.slotEditorModel;

			if (!slotEditorModel || !(0, _mobxStateTree.isAlive)(slotEditorModel)) {
				// unable to render the view if the model is dead
				return null;
			}
			var selectedContent = slotEditorModel.selectedContents[0];
			var SLOT_EDITOR_STATES = slotEditorModel.SLOT_EDITOR_STATES;

			var currentState = slotEditorModel.slotEditorState;
			if (currentState === SLOT_EDITOR_STATES.DISPLAY) {

				if (!this._canRenderSlotEditor(selectedContent)) {
					return this._renderEmptyState(SLOT_EDITOR_STATES, SLOT_EDITOR_STATES.EMPTY.NO_VIS_CREATED);
				}

				var result = this.renderSlotsAndExtensions();
				if (result) {
					return result;
				} else {
					return this._renderEmptyState(SLOT_EDITOR_STATES);
				}
			} else {
				return this._renderEmptyState(SLOT_EDITOR_STATES, currentState);
			}
		}
	}, {
		key: '_getSlotsSection',
		value: function _getSlotsSection() {
			var slotEditorModel = this.props.slotEditorModel;

			var slotInfo = slotEditorModel.getSlotInfo();
			return _react2.default.createElement(
				'div',
				{ className: 'slotEditor__slots' },
				slotInfo.length > 1 ? this._renderLayersAndSlots(slotInfo) : this._renderSlots(slotInfo[0].slotAPIs)
			);
		}
	}, {
		key: 'renderSlotsAndExtensions',
		value: function renderSlotsAndExtensions() {
			var slotEditorModel = this.props.slotEditorModel;

			var slotInfo = slotEditorModel.getSlotInfo();
			var sections = [{
				index: 0,
				render: this._getSlotsSection.bind(this)
			}];

			if (this.props.extensions !== undefined) {
				sections = sections.concat(this.props.extensions);
			}
			var sorted_sections = sections.sort(function (a, b) {
				return a.index - b.index;
			});

			if (slotInfo.length > 0) {
				return _react2.default.createElement(
					_react2.default.Fragment,
					null,
					this._renderHeaderArea(),
					sorted_sections.map(function (section) {
						return section.render();
					}),
					this._renderFooterArea()
				);
			}
		}
	}, {
		key: '_canRenderSlotEditor',
		value: function _canRenderSlotEditor(content) {
			// in some edge cases, there is no `visualization` in `content`, we cannot display slot editor without `visualization`
			return !!(content && content.getFeature('Visualization'));
		}
	}, {
		key: '_renderEmptyState',
		value: function _renderEmptyState(SLOT_EDITOR_STATES, currentSlotEditorState) {
			switch (currentSlotEditorState) {
				case SLOT_EDITOR_STATES.EMPTY.NO_VIS_CREATED:
					return this._getEmptyState(_StringResources2.default.get('slotEditor_emptyState_vis_not_created_title'), _StringResources2.default.get('slotEditor_emptyState_vis_not_created_description'), _buildVisualization_2.default.id);
				case SLOT_EDITOR_STATES.EMPTY.NOT_SUPPORT_SLOTS:
					return this._getEmptyState(_StringResources2.default.get('slotEditor_emptyState_widget_not_support_slot_selected_title'), _StringResources2.default.get('slotEditor_emptyState_widget_not_support_slot_selected_description'), _nothingHere_2.default.id);
				case SLOT_EDITOR_STATES.EMPTY.NO_VIS_SELECTED:
					return this._getEmptyState(_StringResources2.default.get('slotEditor_emptyState_no_visualization_selected_title'), _StringResources2.default.get('slotEditor_emptyState_no_visualization_selected_description'), _buildVisualization_2.default.id);
				case SLOT_EDITOR_STATES.EMPTY.MUILTI_SELECTION:
					return this._getEmptyState(_StringResources2.default.get('slotEditor_emptyState_multiple_visualizations_selected_title'), _StringResources2.default.get('slotEditor_emptyState_multiple_visualizations_selected_description'), _nothingHere_2.default.id);
				case SLOT_EDITOR_STATES.EMPTY.ERROR:
					return this._getEmptyState(_StringResources2.default.get('slotEditor_emptyState_visualization_has_error_title'), null, _nothingHere_2.default.id);
				default:
					return this._getEmptyState();
			}
		}
	}, {
		key: '_getEmptyState',
		value: function _getEmptyState(title, description, iconId) {
			return _react2.default.createElement(_SlotEditorEmptyState2.default, {
				title: title,
				description: description,
				iconId: iconId
			});
		}

		/**
   * For the multi-layer case, we need to draw the layer headings and the slots per layer.
   * @param slotInfoByLayer - a structure containing the layerId and the array of slotAPI's assigned to that layer.
   */

	}, {
		key: '_renderLayersAndSlots',
		value: function _renderLayersAndSlots(slotInfoByLayer) {
			var _this2 = this;

			return slotInfoByLayer.map(function (slotInfoByLayerEntry) {
				if (!slotInfoByLayerEntry.isHideLayer) {
					return _react2.default.createElement(
						_caUiToolkit.Accordion,
						{ className: 'customAccordion', key: slotInfoByLayerEntry.layerId },
						_react2.default.createElement(
							_caUiToolkit.AccordionItem,
							{ className: 'customAccordion', itemName: slotInfoByLayerEntry.layerCaption, open: slotInfoByLayerEntry.open },
							_this2._renderSlots(slotInfoByLayerEntry.slotAPIs, slotInfoByLayerEntry.layerId, '__multilayer' /*customeClass*/)
						)
					);
				} else {
					return _this2._renderSlots(slotInfoByLayerEntry.slotAPIs);
				}
			});
		}

		/**
   * Called to render the data slots (or a single layer worth of slots for the multi-layer scenario).
   * @param slotAPIs - the slots to render
   * @param pLayerId - (optional) the layerId to render
   * @param className - (optional) the custom class name to render
   */

	}, {
		key: '_renderSlots',
		value: function _renderSlots(slotAPIs, pLayerId, className) {
			var _this3 = this;

			var layerId = pLayerId || '';
			return slotAPIs.map(function (slotAPI) {
				return slotAPI.getDefinition().isHidden() ? [] : _react2.default.createElement(_SlotEditorSlot2.default, {
					className: className,
					key: layerId + slotAPI.getDefinition().getId(),
					slotAPI: slotAPI,
					dataItemAPIs: slotAPI.getDataItemList(),
					a11Y: _this3.a11YHandler,
					slotDataItemHandler: _this3.props.slotEditorModel.getSlotDataItemHandler(slotAPI, -1),
					slotEditorModel: _this3.props.slotEditorModel,
					dndManager: _this3.props.dndManager
				});
			});
		}

		/**
   * Render the header area.
   */

	}, {
		key: '_renderHeaderArea',
		value: function _renderHeaderArea() {
			return _react2.default.createElement(
				'div',
				{ className: 'slotEditor__header' },
				_react2.default.createElement(
					'div',
					{ className: 'slotEditor__header__line' },
					_react2.default.createElement(
						'span',
						{ className: 'slotEditor__header__required' },
						'*'
					),
					_StringResources2.default.get('slotEditorMsg1')
				)
			);
		}

		/**
   * Render the footer area.
   */

	}, {
		key: '_renderFooterArea',
		value: function _renderFooterArea() {
			return _react2.default.createElement(
				'div',
				{ className: 'slotEditor__footer' },
				_react2.default.createElement(
					'div',
					{ className: 'slotEditor__footer__line' },
					_react2.default.createElement(
						'span',
						{ className: 'slotEditor__footer__line__icon' },
						_react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: _information_2.default.id })
					),
					_StringResources2.default.get('slotEditorMsg2')
				)
			);
		}
	}]);

	return SlotEditorView;
}(_react.Component);

SlotEditorView.propTypes = {
	dndManager: _propTypes2.default.object.isRequired,
	slotEditorModel: _propTypes2.default.object.isRequired,
	extensions: _propTypes2.default.array
};

exports.default = (0, _mobxReact.observer)(SlotEditorView);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _caUiToolkit = __webpack_require__(3);

var _SlotEditorItem = __webpack_require__(78);

var _SlotEditorItem2 = _interopRequireDefault(_SlotEditorItem);

var _DndSlotItemHandler = __webpack_require__(36);

var _DndSlotItemHandler2 = _interopRequireDefault(_DndSlotItemHandler);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _classnames = __webpack_require__(29);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var GlassUtils = __webpack_require__(30);


var _ = __webpack_require__(6); //TODO: should try to remove this dependency
var AGGREGATION_TYPE_MAP = {
	none: 'none',
	countDistinct: 'countDistinct'
};

/**
 * The SlotEditorSlot component is responsible for rendering a single slot and its items.
 * It also manages drag and drop of items or data to the 'slot heading region'.
 */

var SlotEditorSlot = function (_Component) {
	_inherits(SlotEditorSlot, _Component);

	function SlotEditorSlot(props) {
		_classCallCheck(this, SlotEditorSlot);

		var _this = _possibleConstructorReturn(this, (SlotEditorSlot.__proto__ || Object.getPrototypeOf(SlotEditorSlot)).call(this, props));

		_this._applySlotCoachMarks = _.debounce(function () {
			var _this$props = _this.props,
			    slot = _this$props.slotAPI,
			    _this$props$slotDataI = _this$props.slotDataItemHandler,
			    visualization = _this$props$slotDataI.visualization,
			    dashboardApi = _this$props$slotDataI.dashboardApi;

			var slotDef = slot.getDefinition();
			var coachMark = slotDef.getCoachMark();
			var slotId = slotDef.getId();
			var $slotEditorSlot = (0, _jquery2.default)(_this.slotEditorSlotRef.current);
			if (coachMark) {
				var isMapped = slot.getDataItemList().length > 0;
				if (!coachMark.mappedOnly || isMapped) {
					var $el = isMapped ? $slotEditorSlot.find('.slotEditorItem') : $slotEditorSlot;
					if ($el.length) {
						// Make the coachmark unique for each slot of every visualization
						var options = {
							id: visualization.getDefinition().getId() + '#' + slotId,
							$el: $el,
							title: _StringResources2.default.get(coachMark.titleResource),
							contents: _StringResources2.default.get(coachMark.contentResource),
							showPopover: coachMark.showPopover,
							placement: 'bottom'
						};
						dashboardApi.prepareGlassOptions(options);
						GlassUtils.addCoachmark(options);
					}
				}
			} else {
				var $coachMarkNode = $slotEditorSlot.find('.coachMark');
				if ($coachMarkNode.length) {
					var _coachMark = $coachMarkNode[0];
					var coachMarkParent = _coachMark.parentElement;
					if (coachMarkParent) {
						coachMarkParent.classList.remove('coachMarkContainer');
						coachMarkParent.removeAttribute('id');
						coachMarkParent.removeChild(_coachMark);
					}
				}
			}
		});

		_this.slotEditorSlotRef = _react2.default.createRef();
		return _this;
	}

	_createClass(SlotEditorSlot, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this._initializeDndSupport();
			this._applySlotCoachMarks();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			this._applySlotCoachMarks();
		}

		/**
   * Apply coach marks on the slot or data item
   * The slot coach mark consists with:
   * - showPopover: boolean flag indicating whether the popover show along with the coach mark.
   * - mappedOnly: boolean flag indicating whether the coach mark applies when the slot is mapped or
   * 		regardless of the mapped state.
   * - titleResource: resource name for the coach title.
   * - contentResource: resource name for the coach content.
   */

	}, {
		key: 'render',


		/**
   * Called to render the data slots (or a single layer worth of slots for the multi-layer scenario).
   * @param slotAPIs - the slots to render
   * @param pLayerId - (optional) the layerId to render
   * @param className - (optional) the custom class name to render
   */
		value: function render() {
			var _this2 = this;

			/* a custom class name will be added iff exists */
			var classes = (0, _classnames2.default)(_defineProperty({
				slotEditor__slots__slot: true
			}, '' + this.props.className, this.props.className));
			var handler = new _DndSlotItemHandler2.default(this.domNode, 'dndHover', this._handleDropSlotItemOnTop.bind(this), this._handleAcceptDropSlotItem.bind(this));
			var slotDefinition = this.props.slotAPI.getDefinition();
			var slotCaption = slotDefinition.getCaption();
			var slotId = slotDefinition.getId();
			return _react2.default.createElement(
				'div',
				{ ref: this.slotEditorSlotRef, className: classes },
				_react2.default.createElement(
					'div',
					{ className: 'slotEditor__slots__slot__heading',
						ref: function ref(node) {
							_this2.domNode = node;
						},
						tabIndex: '0',
						'aria-label': slotCaption,
						title: slotCaption,
						role: 'Listbox',
						'data-slot-id': slotId,
						'aria-required': this._isRequiredField(this.props.slotAPI),
						onKeyUp: function onKeyUp(event) {
							return _this2.props.a11Y.slotHandleKeyUp(event, handler, _this2.props.slotDataItemHandler);
						},
						onKeyPress: function onKeyPress(event) {
							return _this2.props.a11Y.handleKeyPress(event, _this2.props.slotDataItemHandler.swapSlotItems.bind(_this2.props.slotDataItemHandler), /*dropAfter*/true);
						} },
					_react2.default.createElement(
						'div',
						{ className: 'slotEditor__slots__slot__heading__container' },
						_react2.default.createElement(
							'div',
							{ className: 'slotEditor__slots__slot__heading__icon' },
							_react2.default.createElement(_caUiToolkit.SVGIcon, { intent: 'primary', iconId: this._getSlotIcon(), size: 'small' })
						),
						slotCaption,
						this._isRequiredField(this.props.slotAPI) ? _react2.default.createElement(
							'div',
							{ className: 'slotEditor__slots__slot__heading__required' },
							'*'
						) : []
					),
					_react2.default.createElement(
						'div',
						{ className: 'slotEditor__slots__slot__heading__dropBefore' },
						_react2.default.createElement('div', { className: 'slotEditor__slots__slot__heading__dropBefore__indicator'
						})
					)
				),
				this._renderSlotDataItems()
			);
		}
	}, {
		key: '_isRequiredField',
		value: function _isRequiredField(slotAPI) {
			return !slotAPI.getDefinition().isOptional() && slotAPI.getDefinition().getShowRequiredMarker();
		}

		/**
   * Render all data items assigned to this slot.
   */

	}, {
		key: '_renderSlotDataItems',
		value: function _renderSlotDataItems() {
			var _this3 = this;

			if (this.props.dataItemAPIs.length) {
				var slotHasUnavailableColumns = this.props.slotAPI.hasUnavailableMetadataColumns();
				return _.map(this.props.dataItemAPIs, function (dataItemAPI, indexInSlot) {
					var slotId = _this3.props.slotAPI.getDefinition().getId();
					return _react2.default.createElement(_SlotEditorItem2.default, { key: slotId + dataItemAPI.getId(),
						itemName: _this3._getSlotItemLabel(indexInSlot, slotHasUnavailableColumns),
						columnId: dataItemAPI.getColumnId(),
						dashboardApi: _this3.props.slotEditorModel.dashboardApi,
						slotDataItemHandler: _this3.props.slotEditorModel.getSlotDataItemHandler(_this3.props.slotAPI, indexInSlot),
						dropSlotItemHandler: new _DndSlotItemHandler2.default(_this3.domNode, 'dndHover', _this3._handleDropSlotItemOnTop.bind(_this3), _this3._handleAcceptDropSlotItem.bind(_this3)),
						indexInSlot: indexInSlot,
						a11Y: _this3.props.a11Y,
						dndManager: _this3.props.dndManager });
				});
			}
		}
	}, {
		key: '_getSlotItemLabel',
		value: function _getSlotItemLabel(itemIndex, slotHasUnavailableColumns) {
			var dataItem = this.props.slotAPI.getDataItemList()[itemIndex];
			var label = dataItem.getLabel();
			if (slotHasUnavailableColumns) {
				// check if the current data item is the missing one
				var metadataColumn = dataItem.getMetadataColumn();
				if (!metadataColumn) {
					label = _StringResources2.default.get('missingColumn', { 'columnLabel': label });
				}
			}
			return label;
		}
		/**
   * Slot icons are retrieved from the dashboard slots and definition.
   * If there is no icon assigned to the slot, the default for category or value is returned.
   * @param slotAPI - the slotAPI to return the icon for.
   */

	}, {
		key: '_getSlotIcon',
		value: function _getSlotIcon() {
			var iconId = this.props.slotAPI.getDefinition().getIcon();
			var iconsFeature = this.props.slotEditorModel.dashboardApi.getFeature('Icons');
			var icon = iconsFeature.getIcon(iconId);
			if (icon) {
				return icon.id;
			}
			return this._getFinalSlotType(this.props.slotAPI) === 'ordinal' ? iconsFeature.getIcon('values').id : iconsFeature.getIcon('category').id;
		}

		/**
  * Return the 'final slot type' ==> meaning that if the slot type is 'any' and data is mapped to the slot,
  * the type of the data will be used to infer the type of the slot.
  * (Not to be confused with getEffectiveType...see below)
  * @param slotAPI - the slotAPI of interest
  * @param [dataItemIndex=0] - the data item in question
  * @returns the final slot type for this slotAPI.
  * TODO: this api returns legacy slot types.  We need to change to categorical and continuous throughout the code.
  * This function is copied from the old SlotAPI.getFinalSlotType
  * Story 295271: Add missing API to get layer caption and to replace the old API slotAPI.itemsNotSupported
  */

	}, {
		key: '_getFinalSlotType',
		value: function _getFinalSlotType(slotAPI) {
			var dataItemIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

			var layerId = slotAPI.getDefinition().getDatasetIdList()[0];
			if (layerId === 'latitude' || layerId === 'longitude') {
				return 'category';
			}
			var slotType = slotAPI.getDefinition().getType();
			if (slotType === 'any') {
				if (this._isMultiMeasuresSlot(slotAPI)) {
					return 'category';
				}
				var mappedDataItem = slotAPI.getDataItemList()[dataItemIndex];
				if (mappedDataItem) {
					if (mappedDataItem.getBinning()) {
						return 'category';
					}
					if (mappedDataItem.getType() === 'attribute') {
						var dataItemAggregationType = mappedDataItem.getAggregation ? mappedDataItem.getAggregation() : mappedDataItem.getAggregationType && mappedDataItem.getAggregationType();
						if (dataItemAggregationType === AGGREGATION_TYPE_MAP.none) {
							return 'category';
						} else {
							return 'ordinal';
						}
					} else if (mappedDataItem.getType() === 'fact') {
						/**
       * - If one of the items in an 'any' slot is a measure, and we have more than one items,
       * then simply consider slot type to be category.
       * - Also look at the 'repeats' attribute by looking at the slot definition. If 'repeats'
       * attribute is there, then it means that we don't stack the data items in this slot. This
       * occurs in all non-VIPR visualizations.
       * - For al non-VIPR visualizations we don't want to enforce
       * the slot type to be a 'category', like we do for all VIPR visualizations.
       * This prevents issues described in defect #255087
       */
						// TODO: repeats (old API)
						if (slotAPI.getDataItemList().length > 1 && !slotAPI.getDefinition().repeats) {
							return 'category';
						} else {
							return 'ordinal';
						}
					}
				}
			}
			return slotType;
		}
	}, {
		key: '_isMultiMeasuresSlot',
		value: function _isMultiMeasuresSlot(slot) {
			return slot.getDataItemList().find(function (dataItem) {
				return dataItem.getId() === '_multiMeasuresSeries';
			});
		}

		//DRAG AND DROP SUPPORT....

	}, {
		key: '_initializeDndSupport',
		value: function _initializeDndSupport() {
			var _this4 = this;

			//A data slot can be a drop target but not a dragdrop source.
			this.props.dndManager.then(function (dndManager) {
				if (_this4.domNode) {
					_this4._dndManager = dndManager;
					_this4.dropSlotItemHandler = new _DndSlotItemHandler2.default(_this4.domNode, 'dndHover', _this4._handleDropSlotItemOnTop.bind(_this4), _this4._handleAcceptDropSlotItem.bind(_this4), dndManager);
					dndManager.addDropTarget(_this4.domNode, _this4.dropSlotItemHandler);
				}
			});
		}
	}, {
		key: '_handleDropSlotItemOnTop',
		value: function _handleDropSlotItemOnTop(dragObject) {
			if (dragObject.type === 'SLOT_ITEM') {
				this.props.slotDataItemHandler.swapSlotItems(this.dropSlotItemHandler.getData(dragObject), /*addAfter*/true);
			} else {
				this.props.slotDataItemHandler.insertAfterItem(this.dropSlotItemHandler.getData(dragObject));
			}
		}

		//Can we accept an item at the head of the item list (after -1)

	}, {
		key: '_handleAcceptDropSlotItem',
		value: function _handleAcceptDropSlotItem(dragObject) {
			// Cannot accept widget to SlotEditorSlot scope; must be within SlotEditorItem
			return this.props.slotDataItemHandler.accepts(this.dropSlotItemHandler.getData(dragObject), /*after*/true);
		}
	}]);

	return SlotEditorSlot;
}(_react.Component);

SlotEditorSlot.propTypes = {
	className: _propTypes2.default.string,
	slotAPI: _propTypes2.default.object,
	dataItemAPIs: _propTypes2.default.array,
	slotEditorModel: _propTypes2.default.object.isRequired,
	dndManager: _propTypes2.default.object.isRequired,
	slotDataItemHandler: _propTypes2.default.object,
	a11Y: _propTypes2.default.object
};

exports.default = SlotEditorSlot;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(19);

var _DndSlotItemHandler = __webpack_require__(36);

var _DndSlotItemHandler2 = _interopRequireDefault(_DndSlotItemHandler);

var _SlotEditorItemFlyout = __webpack_require__(27);

var _SlotEditorItemFlyout2 = _interopRequireDefault(_SlotEditorItemFlyout);

var _caUiToolkit = __webpack_require__(3);

var _overflowMenuHorizontal_ = __webpack_require__(80);

var _overflowMenuHorizontal_2 = _interopRequireDefault(_overflowMenuHorizontal_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * The SlotEditorItem component is responsible for the User Interface for a single slot data item
 */
var SlotEditorItem = function (_Component) {
	_inherits(SlotEditorItem, _Component);

	function SlotEditorItem(props) {
		_classCallCheck(this, SlotEditorItem);

		var _this = _possibleConstructorReturn(this, (SlotEditorItem.__proto__ || Object.getPrototypeOf(SlotEditorItem)).call(this, props));

		_this._showFlyout = function () {
			// don't show flyout when doing DND because the mui three flyout somehow mess up the drag object(see defect CADBLW-5243)
			// don't show flyout if slot menu is open
			if (!_this._isDragging() && !_this.props.slotDataItemHandler.isSlotActionMenuOpened()) {
				_this.setState({
					isFlyoutShown: true
				});
			}
		};

		_this._hideFlyout = function () {
			_this.setState({ isFlyoutShown: false });
		};

		_this._isDragging = function () {
			return !!(_this._dndManager && _this._dndManager.dragObject);
		};

		_this.state = {
			isFlyoutShown: false
		};
		_this.sourceId = _this.props.slotDataItemHandler.getDatasourceId();
		return _this;
	}

	_createClass(SlotEditorItem, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this._initializeDndSupport();
		}

		/**
   * A slot item consists of the name, a menu (to launch actions), an itemValues section (for displaying local filters on that item)
   * and an additional 'dropAfter' region which is used to allow a user to drop after to augment a slots definition.
   */

	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				this._renderFlyout(),
				_react2.default.createElement(
					'div',
					{
						className: 'slotEditorItem is-old',
						'aria-label': this.props.itemName,
						onKeyPress: function onKeyPress(event) {
							return _this2.props.a11Y.handleKeyPress(event, _this2.props.slotDataItemHandler.swapSlotItems.bind(_this2.props.slotDataItemHandler), /*dropAfter*/false);
						},
						onKeyDown: function onKeyDown(event) {
							return _this2.props.a11Y.handleKeyDown(event, { slotDataItemHandler: _this2.props.slotDataItemHandler, dropSlotItemHandler: _this2.props.dropSlotItemHandler });
						},
						onKeyUp: function onKeyUp(event) {
							return _this2.props.a11Y.handleKeyUp(event, { slotDataItemHandler: _this2.props.slotDataItemHandler, dropSlotItemHandler: _this2.props.dropSlotItemHandler });
						},
						tabIndex: '0',
						ref: function ref(node) {
							_this2.domNode = node;
						}
					},
					this.props.itemName && _react2.default.createElement(
						'div',
						{ className: 'slotEditorItem__nameLine' },
						_react2.default.createElement(
							'div',
							{ className: 'slotEditorItem__nameLine__itemName',
								onMouseEnter: this._showFlyout,
								onMouseLeave: this._hideFlyout
							},
							this._renderItemField()
						),
						this.props.slotDataItemHandler.getGraphicData() && _react2.default.createElement(
							'div',
							{ className: 'slotEditorItem__nameLine__icon' },
							_react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.props.slotDataItemHandler.getGraphicData() } })
						),
						!this.props.slotDataItemHandler.isMeasureGroupItem() && _react2.default.createElement(
							'div',
							{ className: 'slotEditorItem__nameLine__actionMenu',
								tabIndex: '0',
								onKeyPress: this._slotActionMenu.bind(this),
								onClick: this._slotActionMenu.bind(this) },
							_react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: _overflowMenuHorizontal_2.default.id }),
							_react2.default.createElement('div', { className: 'actionmenu' })
						)
					),
					this._renderFilterStringAndNumber()
				),
				_react2.default.createElement(
					'div',
					{ className: 'slotEditorItem__dropAfter',
						onKeyPress: function onKeyPress(event) {
							return _this2.props.a11Y.handleKeyPress(event, _this2.props.slotDataItemHandler.swapSlotItems.bind(_this2.props.slotDataItemHandler), /*dropAfter*/true);
						},
						onKeyUp: function onKeyUp(event) {
							return _this2.props.a11Y.slotHandleKeyUp(event, _this2.props.dropSlotItemHandler, _this2.props.slotDataItemHandler);
						},
						tabIndex: '0',
						ref: function ref(node) {
							_this2.domNodeAfter = node;
						} },
					_react2.default.createElement('div', { className: 'slotEditorItem__dropAfter__indicator'
					})
				)
			);
		}
	}, {
		key: '_renderFilterStringAndNumber',
		value: function _renderFilterStringAndNumber() {
			var _ref = this.props.slotDataItemHandler.getFilterStringAndNumber() || {},
			    filterString = _ref.filterString,
			    numberOfFilterItems = _ref.numberOfFilterItems;

			if (filterString) {
				return _react2.default.createElement(
					'div',
					{ className: 'slotEditorItem__infoLine' },
					_react2.default.createElement(
						'div',
						{ className: 'slotEditorItem__infoLine__values' },
						_react2.default.createElement(_caUiToolkit.TruncatedText, { value: filterString })
					),
					numberOfFilterItems ? _react2.default.createElement(
						'div',
						{ className: 'slotEditorItem__infoLine__filterNumber' },
						_react2.default.createElement(
							'div',
							{ className: 'slotEditorItem__infoLine__filterNumber__badge' },
							numberOfFilterItems
						)
					) : null
				);
			}
			return null;
		}
		//Drag and Drop Support.

	}, {
		key: '_initializeDndSupport',
		value: function _initializeDndSupport() {
			var _this3 = this;

			return this.props.dndManager.then(function (dndManager) {
				if (_this3.domNode) {
					//Initialize a drop handler for both the item node and the 'after node'.
					//Also initialize the node as a drag source.
					_this3._dndManager = dndManager;
					_this3.dropSlotItemHandler = new _DndSlotItemHandler2.default(_this3.domNode, 'dndHover', _this3._handleDropSlotItemOnTop.bind(_this3), _this3._handleAcceptDropSlotItemOnTop.bind(_this3), dndManager);

					//We need to set up a callback function when initializing the drag source so that the drag handler is always up-to-date.
					//(not the one at drag drop initialization time!)
					_this3.dropSlotItemHandler.initializeDndSource(_this3._dndManager, _this3._getSlotDataItemHandler.bind(_this3), _this3.props.dashboardApi.getFeature('Icons'));
					_this3.dropSlotItemAfterHandler = new _DndSlotItemHandler2.default(_this3.domNodeAfter, 'dndHover', _this3._handleDropSlotItemAfter.bind(_this3), _this3._handleAcceptDropSlotItemAfter.bind(_this3), dndManager);
					dndManager.addDropTarget(_this3.domNode, _this3.dropSlotItemHandler);
					dndManager.addDropTarget(_this3.domNodeAfter, _this3.dropSlotItemAfterHandler);
				}
			});
		}
	}, {
		key: '_getSlotDataItemHandler',
		value: function _getSlotDataItemHandler() {
			return this.props.slotDataItemHandler;
		}
	}, {
		key: '_handleDropSlotItemOnTop',
		value: function _handleDropSlotItemOnTop(dragObject) {
			//If the source of the drag is a slot item, we are reorganizing slot items in some way.
			//If its metadata, we're adding new metadata or replacing.
			if (dragObject.type === 'SLOT_ITEM') {
				this.props.slotDataItemHandler.swapSlotItems(this.dropSlotItemHandler.getData(dragObject));
			} else if (dragObject.widgetType === 'shape') {
				this.props.slotDataItemHandler.applyShapeOnSlot(this.dropSlotItemHandler.getData(dragObject));
			} else {
				this.props.slotDataItemHandler.replaceItemWith(this.dropSlotItemHandler.getData(dragObject));
			}
		}
	}, {
		key: '_handleDropSlotItemAfter',
		value: function _handleDropSlotItemAfter(dragObject) {
			//Handles the 'drop after zone'
			if (dragObject.type === 'SLOT_ITEM') {
				this.props.slotDataItemHandler.swapSlotItems(this.dropSlotItemHandler.getData(dragObject), /*after*/true);
			} else {
				this.props.slotDataItemHandler.insertAfterItem(this.dropSlotItemHandler.getData(dragObject), /*after*/true);
			}
		}

		//Can we drop on top of an existing item?

	}, {
		key: '_handleAcceptDropSlotItemOnTop',
		value: function _handleAcceptDropSlotItemOnTop(dragObject) {
			return this.props.slotDataItemHandler.accepts(this.dropSlotItemHandler.getData(dragObject));
		}

		//Can we drop after an existing item?

	}, {
		key: '_handleAcceptDropSlotItemAfter',
		value: function _handleAcceptDropSlotItemAfter(dragObject) {
			return this.props.slotDataItemHandler.accepts(this.dropSlotItemHandler.getData(dragObject), /*after*/true);
		}
	}, {
		key: '_slotActionMenu',
		value: function _slotActionMenu() {
			this.props.slotDataItemHandler.openSlotActionMenu(this.domNode, {
				attachPoint: '.actionmenu',
				placement: 'bottom auto' //This string is important. Please see https://github.ibm.com/BusinessAnalytics/vis-slot-editor/pull/43 before changing.
			});
		}
	}, {
		key: '_renderFlyout',
		value: function _renderFlyout() {
			/* we dont't want to show tooltip if the item is measure group*/
			var shouldRenderFlyout = this.state.isFlyoutShown && this.domNode && !this.props.slotDataItemHandler.isMeasureGroupItem();
			if (shouldRenderFlyout) {
				return _react2.default.createElement(_SlotEditorItemFlyout2.default, {
					domNode: this.domNode,
					dashboardApi: this.props.dashboardApi,
					columnId: this.props.columnId,
					sourceId: this.sourceId,
					onClose: this._hideFlyout
				});
			}
		}
	}, {
		key: '_renderItemField',
		value: function _renderItemField() {
			var truncatedTextStyle = {
				minWidth: 100
			};
			return _react2.default.createElement(_caUiToolkit.TruncatedText, { location: 'middle', value: this.props.itemName, style: truncatedTextStyle });
		}
	}]);

	return SlotEditorItem;
}(_react.Component);

SlotEditorItem.propTypes = {
	itemName: _propTypes2.default.string,
	indexInSlot: _propTypes2.default.number,
	itemValues: _propTypes2.default.string,
	dashboardApi: _propTypes2.default.object,
	columnId: _propTypes2.default.string,
	slotDataItemHandler: _propTypes2.default.object.isRequired,
	dropSlotItemHandler: _propTypes2.default.object.isRequired,
	a11Y: _propTypes2.default.object,
	dndManager: _propTypes2.default.object.isRequired
};

exports.default = SlotEditorItem;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2018, 2020\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.is-old.slotEditor {\n  overflow-y: auto;\n  height: 100%;\n  padding: 8px 0 8px 8px;\n}\n\n.is-old.slotEditor .slotEditor__slots {\n  /* overriding border and padding from toolkit */\n}\n\n.is-old.slotEditor .slotEditor__slots .customAccordion {\n  border-top: none;\n  padding-bottom: 8px;\n  /* Not ideal - reaching internal toolkit class to override style due to toolkit defect 248859 */\n}\n\n.is-old.slotEditor .slotEditor__slots .customAccordion:first-child {\n  padding-top: 8px;\n}\n\n.is-old.slotEditor .slotEditor__slots .customAccordion .ba-common-accordionItem__content {\n  padding: 0 0 0 32px;\n}\n\n.is-old.slotEditor .slotEditor__slots__layer {\n  margin-top: 8px;\n  margin-bottom: 8px;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.is-old.slotEditor .slotEditor__slots__slot {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding-top: 16px;\n  border-bottom: 1px solid #eaeaea;\n}\n\n.is-old.slotEditor .slotEditor__slots__slot.__multilayer {\n  border-bottom: none;\n}\n\n.is-old.slotEditor .slotEditor__slots__slot__heading__container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  font-weight: bold;\n  font-size: 14px;\n  margin-left: 16px;\n  padding-bottom: 8px;\n}\n\n.is-old.slotEditor .slotEditor__slots__slot__heading__indent {\n  width: 16px;\n}\n\n.is-old.slotEditor .slotEditor__slots__slot__heading__icon {\n  padding-right: 8px;\n}\n\n.is-old.slotEditor .slotEditor__slots__slot__heading__required {\n  padding-left: 4px;\n  padding-right: 4px;\n  color: #e62325;\n}\n\n.is-old.slotEditor .slotEditor__slots__slot__heading__dropBefore {\n  padding: 0 16px;\n  margin-left: 24px;\n}\n\n.is-old.slotEditor .slotEditor__slots__slot__heading__dropBefore__indicator {\n  width: 80%;\n  height: 8px;\n  margin-bottom: 4px;\n}\n\n.is-old.slotEditor .slotEditor__slots__slot__heading.dndHover .slotEditor__slots__slot__heading__dropBefore__indicator {\n  background-color: rgba(45, 116, 218, 0.2);\n}\n\n.is-old.slotEditor .slotEditor__slots__slot__heading:focus .slotEditor__slots__slot__heading__dropBefore__indicator {\n  background-color: #a8c0f3;\n}\n\n.is-old.slotEditor .slotEditor__slots__slot > .coachMark {\n  top: 30px;\n  right: 80px;\n}\n\n.is-old.slotEditor .slotEditor__slots .bi-mui-moserObjectTree {\n  max-height: 500px;\n}\n\n.is-old.slotEditor .slotEditor__localFilters {\n  font-size: 14px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #eaeaea;\n}\n\n.is-old.slotEditor .slotEditor__localFilters.dndHover {\n  background-color: rgba(45, 116, 218, 0.2);\n}\n\n.is-old.slotEditor .slotEditor__localFilters.dndHover .slotEditorItem__nameLine__actionMenu:hover {\n  background-color: #f3f3f3;\n}\n\n.is-old.slotEditor .slotEditor__localFilters__heading__container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  font-weight: bold;\n  font-size: 14px;\n  margin-left: 16px;\n  padding-bottom: 8px;\n}\n\n.is-old.slotEditor .slotEditor__localFilters__heading__icon {\n  padding-right: 8px;\n}\n\n.is-old.slotEditor .slotEditor__localFilters__items {\n  padding-top: 16px;\n  padding-bottom: 8px;\n}\n\n.is-old.slotEditor .slotEditor__localFilters__item {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  margin-bottom: 8px;\n}\n\n.is-old.slotEditor .slotEditor__localFilters__item:last-child {\n  margin-bottom: 0;\n}\n\n.is-old.slotEditor .slotEditor__localFilters__item .slotEditorItem__nameLine__itemName {\n  cursor: default;\n}\n\n.is-old.slotEditor .slotEditor__header__line {\n  padding-top: 8px;\n  font-size: 12px;\n  font-weight: bold;\n  display: -ms-flexbox;\n  display: flex;\n  color: #343334;\n}\n\n.is-old.slotEditor .slotEditor__header__required {\n  padding-right: 4px;\n  color: #e62325;\n}\n\n.is-old.slotEditor .slotEditor__footer__line {\n  padding-top: 16px;\n  font-size: 14px;\n  display: -ms-flexbox;\n  display: flex;\n  color: #343334;\n}\n\n.is-old.slotEditor .slotEditor__footer__line__icon {\n  margin-right: 8px;\n  margin-left: 16px;\n  color: #595859;\n}\n\n.is-old.slotEditor .slotEditorItem__dropAfter {\n  margin-right: 16px;\n  margin-left: 40px;\n}\n\n.is-old.slotEditor .slotEditorItem__dropAfter__indicator {\n  width: 80%;\n  height: 8px;\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n.is-old.slotEditor .slotEditorItem__dropAfter.dndHover .slotEditorItem__dropAfter__indicator {\n  background-color: rgba(45, 116, 218, 0.2);\n}\n\n.is-old.slotEditor .slotEditorItem__dropAfter:focus .slotEditorItem__dropAfter__indicator {\n  background-color: #a8c0f3;\n}\n\n.highcontrast .is-old.slotEditor .slotEditor__slots__slot__heading.dndHover .slotEditor__slots__slot__heading__dropBefore__indicator {\n  border: 1px dotted;\n}\n\n.highcontrast .is-old.slotEditor .slotEditor__slots__slot__heading:focus .slotEditor__slots__slot__heading__dropBefore__indicator {\n  border: 1px dashed;\n}\n\n.highcontrast .is-old.slotEditor .slotEditor__localFilters.dndHover {\n  border: 2px dotted;\n}\n\n.highcontrast .is-old.slotEditorItem.dndHover .slotEditorItem__nameLine {\n  border: 2px dotted;\n}\n\n.highcontrast .is-old.slotEditorItem .slotEditorItem__dropAfter.dndHover .slotEditorItem__dropAfter__indicator {\n  border: 1px dotted;\n}\n\n.highcontrast .is-old.slotEditorItem .slotEditorItem__dropAfter:focus .slotEditorItem__dropAfter__indicator {\n  border: 1px dashed;\n}\n\n.is-old.slotEditorItem {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: column;\n      flex-flow: column;\n  margin-right: 16px;\n  margin-left: 40px;\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n  -ms-flex-align: stretch;\n      align-items: stretch;\n  border: 1px solid #eaeaea;\n  background-color: white;\n}\n\n.is-old.slotEditorItem.action-menu-opened {\n  pointer-events: none;\n}\n\n.is-old.slotEditorItem.selected {\n  border: 2px solid #c0bfc0;\n}\n\n.is-old.slotEditorItem:focus {\n  background-color: rgba(45, 116, 218, 0.2);\n}\n\n.is-old.slotEditorItem.dndHover .slotEditorItem__nameLine__itemName,\n.is-old.slotEditorItem.dndHover .slotEditorItem__nameLine__icon,\n.is-old.slotEditorItem.dndHover .slotEditorItem__nameLine__actionMenu,\n.is-old.slotEditorItem.dndHover .slotEditorItem__infoLine {\n  background-color: rgba(45, 116, 218, 0.2);\n}\n\n.is-old.slotEditorItem .slotEditorItem__nameLine {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row;\n      flex-flow: row;\n  border-bottom: 1px solid #eaeaea;\n}\n\n.is-old.slotEditorItem .slotEditorItem__nameLine__itemName {\n  max-width: 200px;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  font-size: 14px;\n  padding: 8px;\n  cursor: move;\n}\n\n.is-old.slotEditorItem .slotEditorItem__nameLine__itemName:hover {\n  background-color: #c0bfc0;\n}\n\n.is-old.slotEditorItem .slotEditorItem__nameLine__icon {\n  margin-right: 8px;\n  margin-left: 8px;\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n  width: 16px;\n  height: 16px;\n}\n\n.is-old.slotEditorItem .slotEditorItem__nameLine__actionMenu {\n  display: -ms-flexbox;\n  display: flex;\n  padding: 8px;\n  -ms-flex-align: center;\n      align-items: center;\n  border-left: 1px solid #eaeaea;\n  cursor: pointer;\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n}\n\n.is-old.slotEditorItem .slotEditorItem__nameLine__actionMenu:hover {\n  background-color: #c0bfc0;\n}\n\n.is-old.slotEditorItem .slotEditorItem__nameLine__actionMenu .ba-common-svgIcon {\n  fill: #595859;\n  width: 12px;\n  height: 12px;\n}\n\n.is-old.slotEditorItem .slotEditorItem__nameLine__nodrop {\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: 8px;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n}\n\n.is-old.slotEditorItem .slotEditorItem__nameLine__nodrop.is-hidden {\n  display: none;\n}\n\n.is-old.slotEditorItem .slotEditorItem__nameLine__nodrop .svgIcon {\n  height: 16px;\n  width: 16px;\n  fill: #595859;\n}\n\n.is-old.slotEditorItem .slotEditorItem__infoLine {\n  font-size: 10px;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.is-old.slotEditorItem .slotEditorItem__infoLine__values {\n  max-width: 200px;\n  -ms-flex: 0 1 auto;\n      flex: 0 1 auto;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.is-old.slotEditorItem .slotEditorItem__infoLine__filterNumber {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row-reverse;\n      flex-direction: row-reverse;\n  -ms-flex: 1 0 auto;\n      flex: 1 0 auto;\n}\n\n.is-old.slotEditorItem .slotEditorItem__infoLine__filterNumber__badge {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  border-radius: 40%;\n  width: 24px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  font-weight: bold;\n  background-color: #eaeaea;\n}\n\n.is-old.slotEditorItem.draggedNode {\n  padding: 0;\n  margin: 0;\n}\n\n.is-old.slotEditorItem > .coachMark {\n  top: 10px;\n  right: -10px;\n}\n\n.slotEditorItem__disambiguatingTooltip {\n  min-width: 240px;\n  text-align: left;\n  padding-bottom: 5px;\n}\n\n.slotEditorItem__disambiguatingTooltipTitle {\n  min-width: 240px;\n  padding-left: 8px;\n  padding-top: 5px;\n}\n\n", ""]);

// exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "overflow-menu--horizontal_16",
  "use": "overflow-menu--horizontal_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"overflow-menu--horizontal_16\"><circle cx=\"3\" cy=\"8\" r=\"1\" /><circle cx=\"8\" cy=\"8\" r=\"1\" /><circle cx=\"13\" cy=\"8\" r=\"1\" /><path style=\"fill:none\" d=\"M0 0h16v16H0z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "information_16",
  "use": "information_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"information_16\"><path d=\"M8.5 11V6.5h-2v1h1V11H6v1h4v-1zM8 3.5c-.4 0-.8.3-.8.8s.4.7.8.7.8-.3.8-.8-.4-.7-.8-.7z\" /><path d=\"M8 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zM8 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z\" /><path style=\"fill:none\" d=\"M0 0h16v16H0z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "nothing-here_128",
  "use": "nothing-here_128-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"nothing-here_128\"><circle class=\"ba-graphics-neutral-white4\" cx=\"100\" cy=\"100\" r=\"100\" /><path class=\"ba-graphics-white\" d=\"M14.97 170.08h135.66\" /><path class=\"ba-graphics-gray60\" d=\"M150.63 172.08H15a2 2 0 110-4h135.63a2 2 0 010 4z\" /><path class=\"ba-graphics-white\" d=\"M2 170.08h4.97\" /><path class=\"ba-graphics-gray60\" d=\"M7 172.08H2a2 2 0 010-4h5a2 2 0 010 4z\" /><path class=\"ba-graphics-white\" d=\"M179.03 170.08H198\" /><path class=\"ba-graphics-gray60\" d=\"M198 172.08h-19a2 2 0 010-4h19a2 2 0 010 4z\" /><path class=\"ba-graphics-white\" d=\"M158.63 170.08h12.4\" /><path class=\"ba-graphics-gray60\" d=\"M171 172.08h-12.4a2 2 0 010-4H171a2 2 0 010 4z\" /><path class=\"ba-graphics-white\" d=\"M30.17 46.52h139.57a6.21 6.21 0 016.26 6.21v96.79a4 4 0 01-4 4H28a4 4 0 01-4-4V52.73a6.21 6.21 0 016.17-6.21z\" /><path class=\"ba-graphics-gray60\" d=\"M169.74 50.34a2.39 2.39 0 012.39 2.39v96.79a.18.18 0 01-.18.18H28a.18.18 0 01-.18-.18V52.73a2.4 2.4 0 012.4-2.39h139.52m0-3.82H30.17A6.22 6.22 0 0024 52.73v96.79a4 4 0 004 4h144a4 4 0 004-4V52.73a6.21 6.21 0 00-6.21-6.21z\" /><path class=\"ba-graphics-gray1\" d=\"M176 67.28v-16.8a4 4 0 00-4-4H28a4 4 0 00-4 4v16.8z\" /><path class=\"ba-graphics-gray60\" d=\"M172 50.3a.18.18 0 01.18.18v13H27.77v-13a.18.18 0 01.23-.18h144m0-3.82H28a4 4 0 00-4 4v16.8h152v-16.8a4 4 0 00-4-4z\" /><circle class=\"ba-graphics-gray60\" cx=\"34.07\" cy=\"56.82\" r=\"2\" /><circle class=\"ba-graphics-gray60\" cx=\"41.21\" cy=\"56.82\" r=\"2\" /><circle class=\"ba-graphics-gray60\" cx=\"48.34\" cy=\"56.82\" r=\"2\" /><circle class=\"ba-graphics-gray60\" cx=\"104.65\" cy=\"20.58\" r=\"2\" /><circle class=\"ba-graphics-gray60\" cx=\"141.96\" cy=\"31.17\" r=\"2\" /><path class=\"ba-graphics-gray60\" d=\"M61.33 27.91a4 4 0 004-4 1 1 0 112 0 4 4 0 004 4 1 1 0 010 2 4 4 0 00-4 4 1 1 0 01-2 0 4 4 0 00-4-4 1 1 0 010-2z\" /><path class=\"ba-graphics-white\" d=\"M88.66 128.74h19.08\" /><path class=\"ba-graphics-gray60\" d=\"M107.74 130.74H88.65a2 2 0 010-4h19.09a2 2 0 010 4z\" /><circle class=\"ba-graphics-gray60\" cx=\"75.32\" cy=\"117.69\" r=\"3.47\" /><circle class=\"ba-graphics-gray60\" cx=\"121\" cy=\"117.69\" r=\"3.47\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ })
/******/ ])});;


// WEBPACK FOOTER //
// SlotEditorDOM.js